import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import type * as VueCompositionApi from 'vue';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type ReactiveFunction<TParam> = () => TParam;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigInt: { input: any; output: any; }
  Map: { input: any; output: any; }
  Timestamp: { input: any; output: any; }
};

/** 聊天上传的内容附件 */
export type AiChatAttachment = {
  __typename?: 'AIChatAttachment';
  id?: Maybe<Scalars['Int']['output']>;
  kind?: Maybe<Scalars['Int']['output']>;
};

/** 聊天上传的内容附件 */
export type AiChatAttachmentInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  kind?: InputMaybe<Scalars['Int']['input']>;
};

/** AI聊天对话 */
export type AiChatConversation = {
  __typename?: 'AIChatConversation';
  created_at?: Maybe<Scalars['Timestamp']['output']>;
  first_message: AiChatMessage;
  id?: Maybe<Scalars['String']['output']>;
  last_message_time?: Maybe<Scalars['Timestamp']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** AI聊天单个对话 */
export type AiChatConversationInput = {
  first_message: AiChatMessageInput;
  model?: InputMaybe<Scalars['String']['input']>;
  /** 对话标题 */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AiChatConversationPage = {
  __typename?: 'AIChatConversationPage';
  items?: Maybe<Array<Maybe<AiChatConversation>>>;
  page_info?: Maybe<PageInfo>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** AI聊天对话消息 */
export type AiChatMessage = {
  __typename?: 'AIChatMessage';
  attachments?: Maybe<Array<Maybe<AiChatAttachment>>>;
  conversation_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['Timestamp']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  role?: Maybe<AiChatRole>;
  text?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** 对话消息 */
export type AiChatMessageInput = {
  attachments?: InputMaybe<Array<InputMaybe<AiChatAttachmentInput>>>;
  role: AiChatRole;
  text: Scalars['String']['input'];
};

export type AiChatMessagePage = {
  __typename?: 'AIChatMessagePage';
  items?: Maybe<Array<Maybe<AiChatMessage>>>;
  page_info?: Maybe<PageInfo>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** 聊天角色 */
export enum AiChatRole {
  Assistant = 'assistant',
  Function = 'function',
  System = 'system',
  Tool = 'tool',
  User = 'user'
}

/** 创建 API Key 后的返回值，包含明文 key */
export type ApiKeyCreated = {
  __typename?: 'APIKeyCreated';
  /** 明文 API Key，仅在创建时返回一次 */
  api_key?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['Timestamp']['output']>;
  expires_at?: Maybe<Scalars['Timestamp']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** API Key 信息 */
export type ApiKeyInfo = {
  __typename?: 'APIKeyInfo';
  created_at?: Maybe<Scalars['Timestamp']['output']>;
  expires_at?: Maybe<Scalars['Timestamp']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  key_prefix?: Maybe<Scalars['String']['output']>;
  last_used_at?: Maybe<Scalars['Timestamp']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ApiKeyStatus>;
};

/** API Key 状态 */
export enum ApiKeyStatus {
  Active = 'active',
  Expired = 'expired',
  Revoked = 'revoked'
}

export type AShareIrManagement = {
  __typename?: 'AShareIRManagement';
  answer?: Maybe<Scalars['String']['output']>;
  answer_time?: Maybe<Scalars['Timestamp']['output']>;
  detail_page_url?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  market_source?: Maybe<Scalars['String']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  question_time?: Maybe<Scalars['Timestamp']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  sec_code?: Maybe<Scalars['String']['output']>;
  sec_name?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AddressArea = {
  __typename?: 'AddressArea';
  /** 编号 */
  id: Scalars['Int']['output'];
  /** 名称 */
  name: Scalars['String']['output'];
};

export type AddressAreaInput = {
  /** 编号 */
  id: Scalars['Int']['input'];
  /** 名称 */
  name: Scalars['String']['input'];
};

/** 管理后台评论列表 */
export type AdminCommentList = {
  __typename?: 'AdminCommentList';
  items?: Maybe<Array<Maybe<Comment>>>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type AmountPromotion = {
  __typename?: 'AmountPromotion';
  /** 折扣/减价 */
  discount?: Maybe<Scalars['Int']['output']>;
  /** 最小金额 */
  min_amount?: Maybe<Scalars['Int']['output']>;
  /** 最小件数 */
  min_quantity?: Maybe<Scalars['Int']['output']>;
  /** 总价促销类型 */
  type?: Maybe<AmountPromotionType>;
};

export type AmountPromotionInput = {
  /** 折扣/减价 */
  discount?: InputMaybe<Scalars['Int']['input']>;
  /** 最小金额 */
  min_amount?: InputMaybe<Scalars['Int']['input']>;
  /** 最小件数 */
  min_quantity?: InputMaybe<Scalars['Int']['input']>;
  /** 总价促销类型 */
  type?: InputMaybe<AmountPromotionType>;
};

/** 总价促销类型 */
export enum AmountPromotionType {
  /** 每满元减 */
  EveryXPriceOff = 'EVERY_X_PRICE_OFF',
  /** 满元折 */
  XPriceDiscount = 'X_PRICE_DISCOUNT',
  /** 满元减 */
  XPriceOff = 'X_PRICE_OFF',
  /** 满件折 */
  XQuantityDiscount = 'X_QUANTITY_DISCOUNT',
  /** 满件减 */
  XQuantityOff = 'X_QUANTITY_OFF'
}

export type ApplyRefundOrderResp = {
  __typename?: 'ApplyRefundOrderResp';
  /** 订单详情 */
  order: Order;
};

export type Article = {
  __typename?: 'Article';
  attachments?: Maybe<Array<Maybe<File>>>;
  author?: Maybe<Author>;
  /** 正文 */
  body?: Maybe<Scalars['String']['output']>;
  /** 正文音频URL */
  body_audio_url?: Maybe<Scalars['String']['output']>;
  counter?: Maybe<Counter>;
  /** 封面 */
  cover_url?: Maybe<Scalars['String']['output']>;
  /** 展示时间 */
  display_time?: Maybe<Scalars['Timestamp']['output']>;
  /** 是否已经嵌入向量数据库 */
  embedded?: Maybe<Scalars['Boolean']['output']>;
  /** 嵌入的html，可用于展示和引用 */
  embedded_html?: Maybe<Scalars['String']['output']>;
  /** 免费开放时间 */
  free_at?: Maybe<Scalars['Timestamp']['output']>;
  /** 免费截止时间 */
  free_expired_at?: Maybe<Scalars['Timestamp']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** 第三方合作文章 */
  is_cooperation?: Maybe<Scalars['Boolean']['output']>;
  /** 计划发布时间 */
  planned_published_at?: Maybe<Scalars['Timestamp']['output']>;
  /** 预览 */
  preview?: Maybe<Scalars['String']['output']>;
  source_url?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  /** 总结 */
  summary?: Maybe<Scalars['String']['output']>;
  tag_relations?: Maybe<Array<Maybe<TagRelation>>>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** 标题 */
  title?: Maybe<Scalars['String']['output']>;
  /** 付费等级 */
  vip_visibility?: Maybe<Scalars['Int']['output']>;
  /** 字数 */
  words_count?: Maybe<Scalars['Int']['output']>;
};

export type ArticlePage = {
  __typename?: 'ArticlePage';
  items?: Maybe<Array<Maybe<Article>>>;
  page_info?: Maybe<PageInfo>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** 有声书 */
export type Audio = {
  __typename?: 'Audio';
  body?: Maybe<Scalars['String']['output']>;
  counter?: Maybe<Counter>;
  cover_url?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  display_time?: Maybe<Scalars['Timestamp']['output']>;
  episodes?: Maybe<Array<Maybe<AudioEpisode>>>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  serial_status?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tag_relations?: Maybe<Array<Maybe<TagRelation>>>;
  tags?: Maybe<Array<Maybe<Tag>>>;
};

/** 有声书章节 */
export type AudioEpisode = {
  __typename?: 'AudioEpisode';
  audio?: Maybe<Audio>;
  audio_id?: Maybe<Scalars['Int']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  counter?: Maybe<Counter>;
  cover_url?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  display_time?: Maybe<Scalars['Timestamp']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tag_relations?: Maybe<Array<Maybe<TagRelation>>>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Author = {
  /** 作者头像 */
  avatar?: Maybe<Scalars['String']['output']>;
  /** 作者描述 */
  description?: Maybe<Scalars['String']['output']>;
  /** 作者编号 */
  id?: Maybe<Scalars['Int']['output']>;
  /** 作者名称 */
  nickname?: Maybe<Scalars['String']['output']>;
};

/** 优先根据`ids`中指定的作者编号筛选，如果ids为空则根据`followed`来判断全部作者还是限用户订阅的作者 */
export type AuthorFilter = {
  /** 是否只看订阅的作者 */
  followed?: InputMaybe<Scalars['Boolean']['input']>;
  /** 作者的id列表 */
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** 作者类型 */
  kind?: InputMaybe<AuthorKind>;
};

/** 内容作者的类型 */
export enum AuthorKind {
  /** 外部来源 */
  ExternalSource = 'EXTERNAL_SOURCE',
  /** 内部作者 */
  InternalEditor = 'INTERNAL_EDITOR'
}

export type BatchTask = {
  __typename?: 'BatchTask';
  id?: Maybe<Scalars['Int']['output']>;
  task_name?: Maybe<Scalars['String']['output']>;
};

/** 日历事件 */
export type CalendarEvent = {
  __typename?: 'CalendarEvent';
  /** 实际值 */
  actual?: Maybe<Scalars['String']['output']>;
  /** 国家 */
  country?: Maybe<Scalars['String']['output']>;
  /** 数据ticker */
  data_ticker?: Maybe<Scalars['String']['output']>;
  /** 描述 */
  description?: Maybe<Scalars['String']['output']>;
  /** 展示时间 */
  display_time?: Maybe<Scalars['Timestamp']['output']>;
  /** 事件，请严格对应日历来源的日历标题，后续数据更新以此为依据 */
  event?: Maybe<Scalars['String']['output']>;
  /** 预测值 */
  forecast?: Maybe<Scalars['String']['output']>;
  /** 日历事件ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** 重要性 */
  importance?: Maybe<Scalars['Int']['output']>;
  /** 前值 */
  previous?: Maybe<Scalars['String']['output']>;
  /** 修正值 */
  revised?: Maybe<Scalars['String']['output']>;
  /** 日历来源 */
  source?: Maybe<CalendarSource>;
  /** 状态 */
  status?: Maybe<ContentStatus>;
  /** tag配置 */
  tag_relations?: Maybe<Array<Maybe<TagRelation>>>;
  /** 标题 */
  title?: Maybe<Scalars['String']['output']>;
  /** 单位 */
  unit?: Maybe<Scalars['String']['output']>;
};

/** 日历事件 */
export type CalendarEventInput = {
  /** 实际值 */
  actual?: InputMaybe<Scalars['String']['input']>;
  /** 国家 */
  country?: InputMaybe<Scalars['String']['input']>;
  /** 描述 */
  description?: InputMaybe<Scalars['String']['input']>;
  /** 展示时间 */
  display_time?: InputMaybe<Scalars['Timestamp']['input']>;
  /** 事件 */
  event?: InputMaybe<Scalars['String']['input']>;
  /** 预测值 */
  forecast?: InputMaybe<Scalars['String']['input']>;
  /** 日历事件ID */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** 重要性 */
  importance?: InputMaybe<Scalars['Int']['input']>;
  /** 前值 */
  previous?: InputMaybe<Scalars['String']['input']>;
  /** 修正值 */
  revised?: InputMaybe<Scalars['String']['input']>;
  /** 日历来源 */
  source?: InputMaybe<CalendarSource>;
  /** 状态 */
  status?: InputMaybe<ContentStatus>;
  /** tag配置 */
  tag_relations?: InputMaybe<Array<InputMaybe<TagRelationInput>>>;
  /** 标题 */
  title?: InputMaybe<Scalars['String']['input']>;
  /** 单位 */
  unit?: InputMaybe<Scalars['String']['input']>;
};

/** 日历来源 */
export enum CalendarSource {
  /** 金十 */
  Jin10 = 'JIN10',
  /** 无来源 */
  None = 'NONE',
  /** 华尔街见闻 */
  Wscn = 'WSCN'
}

/** 日历项专题 */
export type CalendarTopic = {
  __typename?: 'CalendarTopic';
  /** 描述 */
  description?: Maybe<Scalars['String']['output']>;
  /** ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** 名称 */
  name?: Maybe<Scalars['String']['output']>;
  /** 发布机构 */
  organization?: Maybe<Scalars['String']['output']>;
  /** 发布周期 */
  period?: Maybe<Scalars['String']['output']>;
  /** 状态 */
  status?: Maybe<ContentStatus>;
  /** tag配置 */
  tag_relations?: Maybe<Array<Maybe<TagRelation>>>;
  /** 官方网站 */
  website?: Maybe<Scalars['String']['output']>;
};

/** 日历项专题 */
export type CalendarTopicInput = {
  /** 描述 */
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** 名称 */
  name?: InputMaybe<Scalars['String']['input']>;
  /** 发布机构 */
  organization?: InputMaybe<Scalars['String']['input']>;
  /** 发布周期 */
  period?: InputMaybe<Scalars['String']['input']>;
  /** 状态 */
  status?: InputMaybe<ContentStatus>;
  /** tag配置 */
  tag_relations?: InputMaybe<Array<InputMaybe<TagRelationInput>>>;
  /** 官方网站 */
  website?: InputMaybe<Scalars['String']['input']>;
};

/** Bot 的 Agent 配置 */
export type ClawbotAgentConfig = {
  __typename?: 'ClawbotAgentConfig';
  /** Bot 人设 prompt */
  prompt_header?: Maybe<Scalars['String']['output']>;
  /** 对话标题 */
  session_title?: Maybe<Scalars['String']['output']>;
};

/** Bot 信息 */
export type ClawbotBotInfo = {
  __typename?: 'ClawbotBotInfo';
  bot_id?: Maybe<Scalars['String']['output']>;
  config?: Maybe<ClawbotAgentConfig>;
  /** 最后收到用户消息时间 (RFC3339) */
  last_message_at?: Maybe<Scalars['String']['output']>;
  /** 最后任务完成时间 (RFC3339) */
  last_task_done_at?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ClawbotBotStatus>;
};

/** Bot 运行状态 */
export enum ClawbotBotStatus {
  /** 等待扫码 */
  LoggingIn = 'LOGGING_IN',
  /** 待登录 */
  New = 'NEW',
  /** 运行中 */
  Running = 'RUNNING',
  /** 会话过期 */
  SessionExpired = 'SESSION_EXPIRED',
  /** 已停止 */
  Stopped = 'STOPPED'
}

/** 扫码登录结果 */
export type ClawbotLoginResult = {
  __typename?: 'ClawbotLoginResult';
  qr_code_url?: Maybe<Scalars['String']['output']>;
};

/** Bot 状态 */
export type ClawbotStatusResult = {
  __typename?: 'ClawbotStatusResult';
  session_id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ClawbotBotStatus>;
};

/** 评论 */
export type Comment = {
  __typename?: 'Comment';
  content?: Maybe<Scalars['String']['output']>;
  counter?: Maybe<Counter>;
  datetime?: Maybe<Scalars['Timestamp']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  image_url?: Maybe<Scalars['String']['output']>;
  item?: Maybe<Content>;
  /** 评论状态：1=正常 -1=已删除（评论列表中已删除评论的 content 会被替换为占位文案） */
  status?: Maybe<Scalars['Int']['output']>;
  tag_relations?: Maybe<Array<Maybe<TagRelation>>>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** 评论被赞次数 */
  thumb_up?: Maybe<Scalars['Int']['output']>;
  to_user?: Maybe<User>;
  user?: Maybe<User>;
};

/** 评论消息 */
export type CommentMessage = {
  __typename?: 'CommentMessage';
  comment?: Maybe<Comment>;
  to_content?: Maybe<Scalars['String']['output']>;
};

/** 评论消息列表 */
export type CommentMessageList = {
  __typename?: 'CommentMessageList';
  items?: Maybe<Array<Maybe<CommentMessage>>>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** 评论节点（含当前用户点赞态） */
export type CommentNode = {
  __typename?: 'CommentNode';
  active?: Maybe<Scalars['Boolean']['output']>;
  comment?: Maybe<Comment>;
};

export type Commodity = {
  __typename?: 'Commodity';
  /** 商品分类 */
  categories?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** 商品封面 */
  cover_uri?: Maybe<Scalars['String']['output']>;
  /** 描述 */
  description?: Maybe<Scalars['String']['output']>;
  /** 单品折扣 */
  discount?: Maybe<Scalars['Int']['output']>;
  /** 自动发货代码 */
  dispatch_code?: Maybe<Scalars['String']['output']>;
  /** 商品id */
  id: Scalars['Int']['output'];
  /** 商品种类 */
  kind?: Maybe<CommodityKind>;
  /** 详细描述 */
  long_description?: Maybe<Scalars['String']['output']>;
  /** 商品名称 */
  name?: Maybe<Scalars['String']['output']>;
  /** 商品是否上架 */
  on_sale?: Maybe<Scalars['Boolean']['output']>;
  /** 平台 */
  platforms?: Maybe<Array<Maybe<Platform>>>;
  /** 商品均价 */
  price?: Maybe<Scalars['Int']['output']>;
  /** 项目 */
  projects?: Maybe<Array<Maybe<Project>>>;
  /** sku列表 */
  skus?: Maybe<Array<Maybe<Sku>>>;
  /** 规格列表 */
  specs?: Maybe<Array<Maybe<CommoditySpec>>>;
};


export type CommoditySkusArgs = {
  on_sale?: InputMaybe<Scalars['Boolean']['input']>;
  sku_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

/** 具体规格 */
export type CommodityAttribute = {
  __typename?: 'CommodityAttribute';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** 具体规格 */
export type CommodityAttributeInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CommodityConnection = {
  __typename?: 'CommodityConnection';
  nodes?: Maybe<Array<Maybe<Commodity>>>;
  page_info?: Maybe<PageInfo>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type CommodityFilter = {
  /** 商品品类列表 */
  categories?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** 商品编号 */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** 商品种类 */
  kind?: InputMaybe<CommodityKind>;
  /** sku编号 */
  sku_id?: InputMaybe<Scalars['Int']['input']>;
};

export type CommodityInput = {
  /** 商品分类 */
  categories?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** 商品封面 */
  cover_uri?: InputMaybe<Scalars['String']['input']>;
  /** 描述 */
  description?: InputMaybe<Scalars['String']['input']>;
  /** 单品折扣 */
  discount?: InputMaybe<Scalars['Int']['input']>;
  /** 自动发货代码 */
  dispatch_code?: InputMaybe<Scalars['String']['input']>;
  /** 商品编号 */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** 商品种类 */
  kind?: InputMaybe<CommodityKind>;
  /** 详细描述 */
  long_description?: InputMaybe<Scalars['String']['input']>;
  /** 商品名称 */
  name?: InputMaybe<Scalars['String']['input']>;
  /** 商品是否上架 */
  on_sale?: InputMaybe<Scalars['Boolean']['input']>;
  /** 售卖平台 */
  platforms?: InputMaybe<Array<InputMaybe<Platform>>>;
  /** 商品均价 */
  price?: InputMaybe<Scalars['Int']['input']>;
  /** 售卖项目 */
  projects?: InputMaybe<Array<InputMaybe<Project>>>;
  /** sku列表 */
  skus?: InputMaybe<Array<InputMaybe<SkuInput>>>;
  /** 规格列表 */
  specs?: InputMaybe<Array<InputMaybe<CommoditySpecInput>>>;
};

/** 商品种类，分为实体商品和虚拟商品两种 */
export enum CommodityKind {
  /** 实体商品 */
  Physical = 'PHYSICAL',
  /** 虚拟商品 */
  Virtual = 'VIRTUAL'
}

/** 商品的规格属性 */
export type CommoditySpec = {
  __typename?: 'CommoditySpec';
  /** 规格名称 */
  name: Scalars['String']['output'];
  /** 具体列表 */
  values?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** 商品的规格属性 */
export type CommoditySpecInput = {
  /** 规格名称 */
  name: Scalars['String']['input'];
  /** 属性类型 */
  type?: InputMaybe<Scalars['String']['input']>;
  /** 具体列表 */
  values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Consignee = {
  __typename?: 'Consignee';
  /** 详细地址 */
  address?: Maybe<Scalars['String']['output']>;
  /** 别名标签 */
  alias?: Maybe<Scalars['String']['output']>;
  /** 省市区 */
  area?: Maybe<Array<Maybe<AddressArea>>>;
  /** 区号 */
  country_code?: Maybe<Scalars['String']['output']>;
  /** 收货人id */
  id?: Maybe<Scalars['Int']['output']>;
  /** 是否为默认地址 */
  is_default?: Maybe<Scalars['Boolean']['output']>;
  /** 收货人名称 */
  name?: Maybe<Scalars['String']['output']>;
  /** 手机号 */
  phone_number?: Maybe<Scalars['String']['output']>;
  /** 用户id */
  user_id?: Maybe<Scalars['Int']['output']>;
  /** 版本信息 */
  version?: Maybe<Scalars['Int']['output']>;
};

export type ConsigneeInput = {
  /** 详细地址 */
  address?: InputMaybe<Scalars['String']['input']>;
  /** 别名标签 */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** 省市区 */
  area?: InputMaybe<Array<InputMaybe<AddressAreaInput>>>;
  /** 区号 */
  country_code?: InputMaybe<Scalars['String']['input']>;
  /** 收货人id */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** 是否为默认地址 */
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  /** 收货人名称 */
  name?: InputMaybe<Scalars['String']['input']>;
  /** 手机号 */
  phone_number?: InputMaybe<Scalars['String']['input']>;
  /** 版本信息 */
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type ConsigneesConnection = {
  __typename?: 'ConsigneesConnection';
  nodes?: Maybe<Array<Maybe<Consignee>>>;
  page_info?: Maybe<PageInfo>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type Content = {
  __typename?: 'Content';
  /** 主动关联，即该事物主动关联的内容，也即是tag_relations中的子集，例如，该事物是一篇文章，那么此field即可获取本文章关联的Tag、Topic etc */
  associate_with?: Maybe<ContentPage>;
  /** 被动关联，即获取主动关联了该事物的内容，例如，该事物是一个Tag，那么此field即可获取添加了本Tag的内容 */
  associated_by?: Maybe<ContentPage>;
  author?: Maybe<Author>;
  author_kind?: Maybe<AuthorKind>;
  /**
   * 资源前 N 条顶层评论（扁平）。复用 FetchItemComments 后端，已包含已删除评论的占位文案。
   * @deprecated 请使用顶层 query item_comments，提供分页、点赞态、子回复和占位文案；该字段保留以兼容老客户端。
   */
  comments?: Maybe<Array<Maybe<Comment>>>;
  counter?: Maybe<Counter>;
  cover_url?: Maybe<Scalars['String']['output']>;
  datetime?: Maybe<Scalars['Timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  detail?: Maybe<Detail>;
  kind?: Maybe<Scalars['Int']['output']>;
  pinned?: Maybe<Scalars['Boolean']['output']>;
  raw_id?: Maybe<Scalars['Int']['output']>;
  /** 是否可访问 */
  readable?: Maybe<Scalars['Boolean']['output']>;
  /** 被动关联，即获取主动关联了该事物的内容，例如，该事物是一个Tag，那么此field即可获取添加了本Tag的内容 */
  related_contents?: Maybe<ContentPage>;
  score?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tag_relations?: Maybe<Array<Maybe<TagRelation>>>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  title?: Maybe<Scalars['String']['output']>;
  vip_visibility?: Maybe<Scalars['Int']['output']>;
};


export type ContentAssociate_WithArgs = {
  kinds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type ContentAssociated_ByArgs = {
  end_time?: InputMaybe<Scalars['Timestamp']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  kinds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort_by?: InputMaybe<Scalars['String']['input']>;
  start_time?: InputMaybe<Scalars['Timestamp']['input']>;
  vip_visibility?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentCommentsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentPinnedArgs = {
  group?: InputMaybe<Scalars['Int']['input']>;
};


export type ContentRelated_ContentsArgs = {
  end_time?: InputMaybe<Scalars['Timestamp']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  kinds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort_by?: InputMaybe<Scalars['String']['input']>;
  start_time?: InputMaybe<Scalars['Timestamp']['input']>;
  vip_visibility?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentPage = {
  __typename?: 'ContentPage';
  items?: Maybe<Array<Maybe<Content>>>;
  page_info?: Maybe<PageInfo>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** 内容的状态 */
export enum ContentStatus {
  /** 用户组 */
  Deleted = 'DELETED',
  /** 单个用户 */
  Draft = 'DRAFT',
  /** 用户组 */
  Published = 'PUBLISHED'
}

export type Counter = {
  __typename?: 'Counter';
  collected?: Maybe<Scalars['Int']['output']>;
  commented?: Maybe<Scalars['Int']['output']>;
  item_id?: Maybe<Scalars['Int']['output']>;
  kind?: Maybe<Scalars['Int']['output']>;
  liked?: Maybe<Scalars['Int']['output']>;
  shared?: Maybe<Scalars['Int']['output']>;
  viewed?: Maybe<Scalars['Int']['output']>;
};

export type CouponPromotion = {
  __typename?: 'CouponPromotion';
  /** 有效时长（天） */
  duration_day?: Maybe<Scalars['Int']['output']>;
  /** 面值（注：折扣券则代表折扣额度） */
  face_value?: Maybe<Scalars['Int']['output']>;
  /** 优惠券库存 */
  inventory?: Maybe<Scalars['Int']['output']>;
  /** 是否可自动分发 */
  is_delivery?: Maybe<Scalars['Boolean']['output']>;
  /** 是否可公开领取 */
  is_public?: Maybe<Scalars['Boolean']['output']>;
  /** 最小使用金额 */
  min_amount?: Maybe<Scalars['Int']['output']>;
  /** 是否限制流通数量 */
  supply_limit?: Maybe<Scalars['Boolean']['output']>;
  /** 总发行量 */
  total_count?: Maybe<Scalars['Int']['output']>;
  /** 优惠券类型 */
  type?: Maybe<CouponPromotionType>;
  /** 有效期类型 */
  validity?: Maybe<CouponValidityType>;
  /** 无效时间 */
  validity_end?: Maybe<Scalars['Timestamp']['output']>;
  /** 起始有效期 */
  validity_start?: Maybe<Scalars['Timestamp']['output']>;
};

export type CouponPromotionInput = {
  /** 有效时长（天） */
  duration_day?: InputMaybe<Scalars['Int']['input']>;
  /** 面值（注：折扣券则代表折扣额度） */
  face_value?: InputMaybe<Scalars['Int']['input']>;
  /** 优惠券库存 */
  inventory?: InputMaybe<Scalars['Int']['input']>;
  /** 是否可自动分发 */
  is_delivery?: InputMaybe<Scalars['Boolean']['input']>;
  /** 是否可公开领取 */
  is_public?: InputMaybe<Scalars['Boolean']['input']>;
  /** 最小使用金额 */
  min_amount?: InputMaybe<Scalars['Int']['input']>;
  /** 是否限制流通数量 */
  supply_limit?: InputMaybe<Scalars['Boolean']['input']>;
  /** 总发行量 */
  total_count?: InputMaybe<Scalars['Int']['input']>;
  /** 优惠券类型 */
  type?: InputMaybe<CouponPromotionType>;
  /** 有效期类型 */
  validity?: InputMaybe<CouponValidityType>;
  /** 无效时间 */
  validity_end?: InputMaybe<Scalars['Timestamp']['input']>;
  /** 起始有效期 */
  validity_start?: InputMaybe<Scalars['Timestamp']['input']>;
};

/** 优惠券类型 */
export enum CouponPromotionType {
  /** 现金券 */
  Cash = 'CASH',
  /** 折扣券 */
  Discount = 'DISCOUNT',
  /** 满减券 */
  Reduce = 'REDUCE'
}

/** 优惠券有效期类型 */
export enum CouponValidityType {
  /** 时长（领取后） */
  Duration = 'DURATION',
  /** 永久有效 */
  Forever = 'FOREVER',
  /** 固定时间段 */
  Range = 'RANGE'
}

/** 下单参数 */
export type CreateOrderInput = {
  /** 是否自动领取优惠券 */
  auto_gain_coupons?: InputMaybe<Scalars['Boolean']['input']>;
  /** 黑金折算元会员活动专用, true进入折算逻辑 */
  blackgold_convert?: InputMaybe<Scalars['Boolean']['input']>;
  /** 收货人 */
  consignee_id: Scalars['Int']['input'];
  /** credit订阅升级专用, true进入升级逻辑 */
  credit_sub_upgrade?: InputMaybe<Scalars['Boolean']['input']>;
  /** 默认使用优惠券 */
  default_use_coupon?: InputMaybe<Scalars['Boolean']['input']>;
  /** 默认使用会员抵扣 */
  default_use_reduction?: InputMaybe<Scalars['Boolean']['input']>;
  /** 额外参数 */
  extra?: InputMaybe<Scalars['Map']['input']>;
  /** 下单平台 */
  platform?: InputMaybe<Platform>;
  /** 下单项目 */
  project?: InputMaybe<Project>;
  /** 备注 */
  remark?: InputMaybe<Scalars['String']['input']>;
  /** 是否展示可领取优惠券 */
  show_gainable_coupons?: InputMaybe<Scalars['Boolean']['input']>;
  /** 购买的sku列表 */
  skus?: InputMaybe<Array<SkuQuantity>>;
  /** 优惠券列表 */
  user_coupon_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

/** 积分价格类型 */
export enum CreditExpenseKind {
  /** AI聊天 */
  Aichat = 'AICHAT',
  /** 购买内容 */
  Resource = 'RESOURCE'
}

/** 积分价格项 */
export type CreditPrice = {
  __typename?: 'CreditPrice';
  /** 种类 */
  kind?: Maybe<CreditExpenseKind>;
  /** 价格 */
  price?: Maybe<Scalars['Int']['output']>;
};

/** 积分订阅计划 */
export enum CreditSubscriptionPlan {
  /** 未订阅 */
  NoneSub = 'NONE_SUB',
  /** 普通计划 */
  Normal = 'NORMAL',
  /** pro计划 */
  Pro = 'PRO',
  /** unlimited计划 */
  Unlimited = 'UNLIMITED'
}

/** 货币 */
export enum Currency {
  /** 人民币 */
  Cny = 'CNY',
  /** 美刀 */
  Usd = 'USD'
}

export type DeliveryOrderResp = {
  __typename?: 'DeliveryOrderResp';
  /** 订单详情 */
  order: Order;
};

/** 相对时间调整输入 */
export type DurationAdjustmentInput = {
  /** 数值（正数=延长，负数=缩短） */
  amount: Scalars['Int']['input'];
  /** 时间单位（天/月/年） */
  unit: DurationUnit;
};

/** 时间调整单位 */
export enum DurationUnit {
  /** 天 */
  Days = 'DAYS',
  /** 月 */
  Months = 'MONTHS',
  /** 年 */
  Years = 'YEARS'
}

export type ExternalItem = {
  __typename?: 'ExternalItem';
  /** 内容来源 */
  author?: Maybe<Author>;
  /** 外部文章的实际作者 */
  author_name?: Maybe<Scalars['String']['output']>;
  /** 原作者 */
  author_original?: Maybe<Scalars['String']['output']>;
  /** 正文 */
  content?: Maybe<Scalars['String']['output']>;
  /** 中文原文对照正文 */
  content_mix?: Maybe<Scalars['String']['output']>;
  /** 正文原文 */
  content_original?: Maybe<Scalars['String']['output']>;
  /** 中文正文 */
  content_zh?: Maybe<Scalars['String']['output']>;
  /** 展示时间 */
  display_time?: Maybe<Scalars['Timestamp']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** 原文链接 */
  link?: Maybe<Scalars['String']['output']>;
  source_id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<ContentStatus>;
  /** 总结 */
  summary?: Maybe<Scalars['String']['output']>;
  /** 中文原文对照总结 */
  summary_mix?: Maybe<Scalars['String']['output']>;
  /** 总结原文 */
  summary_original?: Maybe<Scalars['String']['output']>;
  /** 中文总结 */
  summary_zh?: Maybe<Scalars['String']['output']>;
  /** tag配置 */
  tag_relations?: Maybe<Array<Maybe<TagRelation>>>;
  /** 标题 */
  title?: Maybe<Scalars['String']['output']>;
  /** 中文原文对照标题 */
  title_mix?: Maybe<Scalars['String']['output']>;
  /** 标题原文 */
  title_original?: Maybe<Scalars['String']['output']>;
  /** 中文标题 */
  title_zh?: Maybe<Scalars['String']['output']>;
};

/** 外部内容 */
export type ExternalItemInput = {
  /** 自定义作者 */
  author?: InputMaybe<Scalars['String']['input']>;
  /** 原作者 */
  author_original?: InputMaybe<Scalars['String']['input']>;
  /** 中文原文对照正文 */
  content_mix?: InputMaybe<Scalars['String']['input']>;
  /** 正文原文 */
  content_original?: InputMaybe<Scalars['String']['input']>;
  /** 中文正文 */
  content_zh?: InputMaybe<Scalars['String']['input']>;
  /** 展示时间 */
  display_time?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  /** 原文链接 */
  link?: InputMaybe<Scalars['String']['input']>;
  source_id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ContentStatus>;
  /** 中文原文对照总结 */
  summary_mix?: InputMaybe<Scalars['String']['input']>;
  /** 总结原文 */
  summary_original?: InputMaybe<Scalars['String']['input']>;
  /** 中文总结 */
  summary_zh?: InputMaybe<Scalars['String']['input']>;
  /** tag配置 */
  tag_relations?: InputMaybe<Array<InputMaybe<TagRelationInput>>>;
  /** 中文原文对照标题 */
  title_mix?: InputMaybe<Scalars['String']['input']>;
  /** 标题原文 */
  title_original?: InputMaybe<Scalars['String']['input']>;
  /** 中文标题 */
  title_zh?: InputMaybe<Scalars['String']['input']>;
};

/** 外部源 */
export type ExternalSource = Author & {
  __typename?: 'ExternalSource';
  /** 头像（同cover） */
  avatar?: Maybe<Scalars['String']['output']>;
  /** 外部源的封面图片地址 */
  cover?: Maybe<Scalars['String']['output']>;
  /** 外部源的描述 */
  description?: Maybe<Scalars['String']['output']>;
  /** 外部源的id */
  id?: Maybe<Scalars['Int']['output']>;
  /** 外部源的唯一key */
  key?: Maybe<Scalars['String']['output']>;
  /** 外部源的名称 */
  name?: Maybe<Scalars['String']['output']>;
  /** 昵称（同name） */
  nickname?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ContentStatus>;
  /** tag配置 */
  tag_relations?: Maybe<Array<Maybe<TagRelation>>>;
};

/** 外部源分组 */
export type ExternalSourceGroup = Author & {
  __typename?: 'ExternalSourceGroup';
  /** 头像（同cover） */
  avatar?: Maybe<Scalars['String']['output']>;
  /** 外部源分组的封面图片地址 */
  cover?: Maybe<Scalars['String']['output']>;
  /** 外部源分组的描述 */
  description?: Maybe<Scalars['String']['output']>;
  /** 外部源分组的id */
  id?: Maybe<Scalars['Int']['output']>;
  /** 外部源分组的名称 */
  name?: Maybe<Scalars['String']['output']>;
  /** 昵称（同name） */
  nickname?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ContentStatus>;
};

/** 外部源订阅操作 */
export type ExternalSourceSubscribeInput = {
  /** 来源所在分组名编号,订阅操作时需要传 */
  group_id?: InputMaybe<Scalars['Int']['input']>;
  /** 来源所在分组名称,订阅操作时需要传 */
  group_name?: InputMaybe<Scalars['String']['input']>;
  /** 订阅操作, 0-订阅 1-退订 */
  operation?: InputMaybe<Scalars['Int']['input']>;
  source_id?: InputMaybe<Scalars['Int']['input']>;
};

/** 家庭组信息 */
export type FamilyGroup = {
  __typename?: 'FamilyGroup';
  /** 创建时间 */
  created_at?: Maybe<Scalars['Timestamp']['output']>;
  /** 成员数量 */
  member_count?: Maybe<Scalars['Int']['output']>;
  /** 成员列表 */
  members?: Maybe<Array<Maybe<FamilyGroupMember>>>;
  /** 组长用户信息 - 可以获取昵称、头像等完整信息 */
  owner?: Maybe<User>;
  /** 组长用户ID */
  owner_id?: Maybe<Scalars['Int']['output']>;
  /** 更新时间 */
  updated_at?: Maybe<Scalars['Timestamp']['output']>;
};

/** 家庭组成员信息 */
export type FamilyGroupMember = {
  __typename?: 'FamilyGroupMember';
  /** 加入时间 */
  joined_at?: Maybe<Scalars['Timestamp']['output']>;
  /** 成员用户信息 - 可以获取昵称、头像等完整信息 */
  user?: Maybe<User>;
  /** 成员用户ID */
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type Faq = {
  __typename?: 'Faq';
  counter?: Maybe<Counter>;
  id?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Array<Maybe<FaqItem>>>;
  tag_relations?: Maybe<Array<Maybe<TagRelation>>>;
  tags?: Maybe<Array<Maybe<Tag>>>;
};

export type FaqItem = {
  __typename?: 'FaqItem';
  body?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type File = {
  __typename?: 'File';
  counter?: Maybe<Counter>;
  file_extension?: Maybe<Scalars['String']['output']>;
  file_meta?: Maybe<Scalars['String']['output']>;
  file_url?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  is_report?: Maybe<Scalars['Boolean']['output']>;
  only_institutional?: Maybe<Scalars['Boolean']['output']>;
  tag_relations?: Maybe<Array<Maybe<TagRelation>>>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  title?: Maybe<Scalars['String']['output']>;
  vip_visibility?: Maybe<Scalars['Int']['output']>;
};

/** 文件的基本信息 */
export type FileMeta = {
  __typename?: 'FileMeta';
  fsize?: Maybe<Scalars['BigInt']['output']>;
};

/** 过滤器操作符 */
export enum FilterOperator {
  /** 且 */
  And = 'AND',
  /** 或 */
  Or = 'OR'
}

export type FreebieItem = {
  __typename?: 'FreebieItem';
  /** 商品编号或者优惠券编号 */
  id?: Maybe<Scalars['Int']['output']>;
  /** 赠品数量 */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** 赠品收货人类型，默认为主商品购买人 */
  receiver_type?: Maybe<FreebieReceiverType>;
  /** 赠品类型，默认为普通商品 */
  type?: Maybe<FreebieItemType>;
};

export type FreebieItemInput = {
  /** 商品编号或者优惠券编号 */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** 赠品数量 */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** 赠品收货人类型，默认为主商品购买人 */
  receiver_type?: InputMaybe<FreebieReceiverType>;
  /** 赠品类型，默认为普通商品 */
  type?: InputMaybe<FreebieItemType>;
};

/** 赠品类型 */
export enum FreebieItemType {
  /** 优惠券 */
  Coupon = 'COUPON',
  /** 普通商品 */
  Sku = 'SKU'
}

export type FreebiePromotion = {
  __typename?: 'FreebiePromotion';
  /**
   * 赠品编号列表
   * @deprecated 请使用items支持更多feature
   */
  freebie_ids?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** 优先级高于freebie_ids */
  items?: Maybe<Array<Maybe<FreebieItem>>>;
  /** sku编号 */
  sku_id?: Maybe<Scalars['Int']['output']>;
};

export type FreebiePromotionInput = {
  /** 赠品编号列表，类型为普通商品，收货人为下单人 */
  freebie_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** 优先级高于freebie_ids */
  items?: InputMaybe<Array<InputMaybe<FreebieItemInput>>>;
  /** 主商品编号 */
  sku_id?: InputMaybe<Scalars['Int']['input']>;
};

/** 赠品收货人类型 */
export enum FreebieReceiverType {
  /** 主商品购买人的邀请人 */
  Inviter = 'INVITER',
  /** 主商品购买人 */
  Purchaser = 'PURCHASER'
}

/** 家庭组邀请信息 */
export type GroupInvitation = {
  __typename?: 'GroupInvitation';
  /** 创建时间 */
  created_at?: Maybe<Scalars['Timestamp']['output']>;
  /** 过期时间 */
  expires_at?: Maybe<Scalars['Timestamp']['output']>;
  /** 家庭组组长用户信息 */
  group_owner?: Maybe<User>;
  /** 家庭组组长用户ID */
  group_owner_id?: Maybe<Scalars['Int']['output']>;
  /** 邀请ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** 被邀请人用户信息 (如果已注册) */
  invitee?: Maybe<User>;
  /** 被邀请人用户ID (如果已注册) */
  invitee_id?: Maybe<Scalars['Int']['output']>;
  /** 邀请人用户信息 */
  inviter?: Maybe<User>;
  /** 邀请人用户ID */
  inviter_id?: Maybe<Scalars['Int']['output']>;
  /** 被邀请人手机号 */
  phone?: Maybe<Scalars['String']['output']>;
  /** 被邀请人手机国家码 */
  phone_code?: Maybe<Scalars['Int']['output']>;
  /** 响应时间 */
  responded_at?: Maybe<Scalars['Timestamp']['output']>;
  /** 邀请状态 */
  status?: Maybe<GroupInvitationStatus>;
  /** 邀请令牌 (用于未注册用户) */
  token?: Maybe<Scalars['String']['output']>;
  /** 更新时间 */
  updated_at?: Maybe<Scalars['Timestamp']['output']>;
};

export type GroupInvitationPage = {
  __typename?: 'GroupInvitationPage';
  items?: Maybe<Array<Maybe<GroupInvitation>>>;
  page_info?: Maybe<PageInfo>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** 家庭组邀请状态 */
export enum GroupInvitationStatus {
  /** 已接受 */
  Accepted = 'ACCEPTED',
  /** 已拒绝 */
  Declined = 'DECLINED',
  /** 已过期 */
  Expired = 'EXPIRED',
  /** 等待现有用户响应 */
  Pending = 'PENDING',
  /** 等待新用户注册 */
  PendingRegistration = 'PENDING_REGISTRATION'
}

/** 图片 */
export type Image = {
  __typename?: 'Image';
  counter?: Maybe<Counter>;
  /** 创建时间 */
  created_at?: Maybe<Scalars['Timestamp']['output']>;
  /** 图片描述 */
  description?: Maybe<Scalars['String']['output']>;
  /** 文件名 */
  filename?: Maybe<Scalars['String']['output']>;
  /** 图片哈希值 */
  hash?: Maybe<Scalars['String']['output']>;
  /** 图片高度 */
  height?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** MIME类型 */
  mime_type?: Maybe<Scalars['String']['output']>;
  /** 图片大小(字节) */
  size?: Maybe<Scalars['Int']['output']>;
  /** 标签关系 */
  tag_relations?: Maybe<Array<Maybe<TagRelation>>>;
  /** 标签 */
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** 图片标题 */
  title?: Maybe<Scalars['String']['output']>;
  /** 更新时间 */
  updated_at?: Maybe<Scalars['Timestamp']['output']>;
  /** 图片URL */
  url?: Maybe<Scalars['String']['output']>;
  /** VIP可见性 */
  vip_visibility?: Maybe<Scalars['Int']['output']>;
  /** 图片宽度 */
  width?: Maybe<Scalars['Int']['output']>;
};

/** 无效的订单商品详情 */
export type InvalidOrderItem = {
  __typename?: 'InvalidOrderItem';
  /** 基准总价 */
  base_amount?: Maybe<Scalars['Int']['output']>;
  /** 商品编号 */
  commodity_id?: Maybe<Scalars['Int']['output']>;
  /** 优惠详情 */
  discount?: Maybe<OrderDiscount>;
  /** 无效原因 */
  invalid_reason?: Maybe<Scalars['String']['output']>;
  /** 购买数量 */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** 实际支付金额 */
  real_pay_amount?: Maybe<Scalars['Int']['output']>;
  /** 备注 */
  remark?: Maybe<Scalars['String']['output']>;
  /** 对应的sku详情 */
  sku_detail?: Maybe<Sku>;
  /** sku编号 */
  sku_id?: Maybe<Scalars['Int']['output']>;
  /** 总价 */
  total_amount?: Maybe<Scalars['Int']['output']>;
  /** 类型 */
  type?: Maybe<OrderItemType>;
};

/** 邀请配额信息 */
export type InvitationQuotaInfo = {
  __typename?: 'InvitationQuotaInfo';
  /** 总限额 */
  limit?: Maybe<Scalars['Int']['output']>;
  /** 剩余数量 */
  remaining?: Maybe<Scalars['Int']['output']>;
  /** 已使用数量 */
  used?: Maybe<Scalars['Int']['output']>;
};

/** 资源评论列表 */
export type ItemCommentsList = {
  __typename?: 'ItemCommentsList';
  anchor?: Maybe<Scalars['String']['output']>;
  comment_count?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Array<Maybe<RootComment>>>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type ItemPromotion = {
  __typename?: 'ItemPromotion';
  /** 折扣（20表示20%%off，即8折） */
  discount?: Maybe<Scalars['Int']['output']>;
  /**
   * 赠品编号
   * @deprecated 请使用freebie_ids
   */
  freebie_id?: Maybe<Scalars['Int']['output']>;
  /** 赠品编号列表 */
  freebie_ids?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** 立减金额 */
  reduce?: Maybe<Scalars['Int']['output']>;
  /** sku编号 */
  sku_id?: Maybe<Scalars['Int']['output']>;
  /** 单品促销类型 */
  type?: Maybe<ItemPromotionType>;
};

export type ItemPromotionInput = {
  /** 折扣（20表示20%%off，即8折） */
  discount?: InputMaybe<Scalars['Int']['input']>;
  /** 立减金额 */
  reduce?: InputMaybe<Scalars['Int']['input']>;
  /** sku编号 */
  sku_id?: InputMaybe<Scalars['Int']['input']>;
  /** 单品促销类型 */
  type?: InputMaybe<ItemPromotionType>;
};

/** 单品促销类型 */
export enum ItemPromotionType {
  /** 减价 */
  Bargain = 'BARGAIN',
  /** 折扣 */
  Discount = 'DISCOUNT'
}

/** 链接 */
export type Link = {
  __typename?: 'Link';
  counter?: Maybe<Counter>;
  datetime?: Maybe<Scalars['Timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  tag_relations?: Maybe<Array<Maybe<TagRelation>>>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  title?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
  vip_visibility?: Maybe<Scalars['Int']['output']>;
};

/** 会员信息 */
export type MemberShip = {
  __typename?: 'MemberShip';
  /** 过期时间 */
  expired_at?: Maybe<Scalars['Timestamp']['output']>;
  level?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** newsletter 紧急停发开关状态 */
export type NewsletterKillSwitchState = {
  __typename?: 'NewsletterKillSwitchState';
  /** 是否生效 */
  active: Scalars['Boolean']['output'];
  /** 开启时间（unix seconds），未启用时为 0 */
  enabled_at?: Maybe<Scalars['Int']['output']>;
  /** 触发开关的用户 ID */
  enabled_by?: Maybe<Scalars['Int']['output']>;
  /** 失效时间（unix seconds），未启用时为 0；TTL 由 Redis 自动清理 */
  enabled_until?: Maybe<Scalars['Int']['output']>;
};

/** OIDC 接入方客户端 */
export type OauthClient = {
  __typename?: 'OauthClient';
  client_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['Timestamp']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  redirect_uris?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  scopes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  skip_consent?: Maybe<Scalars['Boolean']['output']>;
  updated_at?: Maybe<Scalars['Timestamp']['output']>;
};

/** OIDC 接入方创建结果 */
export type OauthClientCreateResult = {
  __typename?: 'OauthClientCreateResult';
  client?: Maybe<OauthClient>;
  /** 客户端密钥明文，仅创建/重置时返回一次 */
  client_secret?: Maybe<Scalars['String']['output']>;
  /** 发现文档地址，供接入方自检 */
  discovery_url?: Maybe<Scalars['String']['output']>;
  /** 本环境的 Issuer URL，接入方表单填这个 */
  issuer?: Maybe<Scalars['String']['output']>;
};

export type OauthClientsConnection = {
  __typename?: 'OauthClientsConnection';
  nodes?: Maybe<Array<Maybe<OauthClient>>>;
  page_info?: Maybe<PageInfo>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** 家庭组操作历史记录 */
export type OperationHistory = {
  __typename?: 'OperationHistory';
  /** 家庭组组长ID */
  group_owner_id?: Maybe<Scalars['Int']['output']>;
  /** 操作记录ID */
  operation_id?: Maybe<Scalars['Int']['output']>;
  /** 操作时间 */
  operation_time?: Maybe<Scalars['Timestamp']['output']>;
  /** 操作类型 */
  operation_type?: Maybe<OperationType>;
  /** 操作人用户信息 - 可以获取操作人的昵称、头像等 */
  operator?: Maybe<User>;
  /** 操作人用户ID */
  operator_id?: Maybe<Scalars['Int']['output']>;
  /** 目标用户信息 - 仅ADD_MEMBER和REMOVE_MEMBER操作有值,可以获取被添加/移除用户的信息 */
  target_user?: Maybe<User>;
  /** 目标用户ID - 仅ADD_MEMBER和REMOVE_MEMBER操作有值 */
  target_user_id?: Maybe<Scalars['Int']['output']>;
};

export type OperationHistoryPage = {
  __typename?: 'OperationHistoryPage';
  items?: Maybe<Array<Maybe<OperationHistory>>>;
  page_info?: Maybe<PageInfo>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** 家庭组操作类型 */
export enum OperationType {
  /** 接受邀请 */
  AcceptInvitation = 'ACCEPT_INVITATION',
  /** 激活邀请 */
  ActivateInvitation = 'ACTIVATE_INVITATION',
  /** 添加成员 */
  AddMember = 'ADD_MEMBER',
  /** 创建家庭组 */
  CreateGroup = 'CREATE_GROUP',
  /** 拒绝邀请 */
  DeclineInvitation = 'DECLINE_INVITATION',
  /** 解散家庭组 */
  DisbandGroup = 'DISBAND_GROUP',
  /** 成员离开家庭组 */
  LeaveGroup = 'LEAVE_GROUP',
  /** 移除成员 */
  RemoveMember = 'REMOVE_MEMBER',
  /** 发送邀请 */
  SendInvitation = 'SEND_INVITATION'
}

/** 订单信息 */
export type Order = {
  __typename?: 'Order';
  /** 订单售后状态 */
  after_status?: Maybe<OrderAfterStatus>;
  /** 子订单列表 */
  children?: Maybe<Array<Maybe<Order>>>;
  /** 创建时间 */
  created_at?: Maybe<Scalars['Timestamp']['output']>;
  /** 发货时间 */
  delivery_time?: Maybe<Scalars['Timestamp']['output']>;
  /** 优惠详情 */
  discount?: Maybe<OrderDiscount>;
  /** 订单事件列表 */
  events?: Maybe<Array<Maybe<OrderEventRecord>>>;
  /** 享首单优惠 */
  first_buy?: Maybe<Scalars['Boolean']['output']>;
  /** 订单id */
  id?: Maybe<Scalars['Int']['output']>;
  /** 发票信息 */
  invoice?: Maybe<OrderInvoice>;
  /** 开票备注 */
  invoice_remark?: Maybe<Scalars['String']['output']>;
  /** 开票状态 */
  invoice_status?: Maybe<OrderInvoiceStatus>;
  /** 订单的物理信息 */
  logistics?: Maybe<OrderLogisticsInfo>;
  /** 运费 */
  logistics_fee?: Maybe<Scalars['Int']['output']>;
  /** 商品详情（被拆分的订单此字段为空） */
  order_items?: Maybe<Array<Maybe<OrderItem>>>;
  /** 订单编号 */
  order_no?: Maybe<Scalars['String']['output']>;
  /** 订单状态 */
  order_status?: Maybe<OrderStatus>;
  /** 支付时间 */
  pay_time?: Maybe<Scalars['Timestamp']['output']>;
  /** 支付超时时间 */
  pay_timeout_at?: Maybe<Scalars['Timestamp']['output']>;
  /** 下单平台 */
  platform?: Maybe<Platform>;
  /** 下单项目 */
  project?: Maybe<Project>;
  /** 订单优惠详情列表 */
  promotions?: Maybe<Array<Maybe<OrderPromotion>>>;
  /** 实际支付金额 */
  real_pay_amount?: Maybe<Scalars['Int']['output']>;
  /** 订单会员抵扣列表 */
  reductions?: Maybe<Array<Maybe<OrderReduction>>>;
  /** 订单备注 */
  remark?: Maybe<Scalars['String']['output']>;
  /** 商家编号 */
  supplier_id?: Maybe<Scalars['Int']['output']>;
  /** 商家名称 */
  supplier_name?: Maybe<Scalars['String']['output']>;
  /** 总价 */
  total_amount?: Maybe<Scalars['Int']['output']>;
  /** 支付记录（子订单取父订单支付记录） */
  transactions?: Maybe<Array<Maybe<OrderTransaction>>>;
  /** 更新时间 */
  updated_at?: Maybe<Scalars['Timestamp']['output']>;
  /** 订单优惠券详情列表 */
  user_coupons?: Maybe<Array<Maybe<OrderUserCoupon>>>;
  /** 订单的用户信息 */
  user_info?: Maybe<OrderUserInfo>;
};

/** 订单售后状态 */
export enum OrderAfterStatus {
  /** 无 */
  None = 'NONE'
}

/** 支付凭证 */
export type OrderCharge = {
  __typename?: 'OrderCharge';
  charge_body: Scalars['Map']['output'];
  credential: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

/** 订单检查返回 */
export type OrderCheckInfo = {
  __typename?: 'OrderCheckInfo';
  /** 是否需要收件人信息 */
  consignee_required?: Maybe<Scalars['Boolean']['output']>;
  /** 优惠详情 */
  discount?: Maybe<OrderDiscount>;
  /** 首单优惠 */
  first_buy?: Maybe<Scalars['Boolean']['output']>;
  /** 优惠活动 */
  gainable_coupons?: Maybe<Array<Maybe<OrderPromotion>>>;
  /** 自动领取的优惠券数量 */
  gained_count?: Maybe<Scalars['Int']['output']>;
  /** 无效的商品列表 */
  invalid_items?: Maybe<Array<Maybe<InvalidOrderItem>>>;
  /** 运费 */
  logistics_fee?: Maybe<Scalars['Int']['output']>;
  /** 商品项 */
  order_items?: Maybe<Array<Maybe<OrderItem>>>;
  /** 优惠活动 */
  promotions?: Maybe<Array<Maybe<OrderPromotion>>>;
  /** 实际支付金额 */
  real_pay_amount?: Maybe<Scalars['Int']['output']>;
  /** 抵扣列表 */
  reductions?: Maybe<Array<Maybe<OrderReduction>>>;
  /** 订单总金额 */
  total_amount?: Maybe<Scalars['Int']['output']>;
  /** 可用的用户优惠券 */
  usable_user_coupons?: Maybe<Array<Maybe<UserCoupon>>>;
  /** 当前使用的用户优惠券 */
  user_coupons?: Maybe<Array<Maybe<OrderUserCoupon>>>;
  /** 用户信息 */
  user_info: OrderUserInfo;
};

/** 优惠详情 */
export type OrderDiscount = {
  __typename?: 'OrderDiscount';
  /** 总价促销优惠 */
  amount_discount?: Maybe<Scalars['Int']['output']>;
  /** 优惠券优惠 */
  coupon_discount?: Maybe<Scalars['Int']['output']>;
  /** 单品促销优惠 */
  item_discount?: Maybe<Scalars['Int']['output']>;
  /** 支付优惠 */
  pay_discount?: Maybe<Scalars['Int']['output']>;
  /** 会员抵扣优惠 */
  reduction_discount?: Maybe<Scalars['Int']['output']>;
};

/** 订单事件类型 */
export enum OrderEvent {
  /** 修改收货地址 */
  AlterAddress = 'ALTER_ADDRESS',
  /** 申请退款 */
  ApplyRefund = 'APPLY_REFUND',
  /** 取消订单 */
  Cancel = 'CANCEL',
  /** 发起支付 */
  Charge = 'CHARGE',
  /** 创建订单 */
  Create = 'CREATE',
  /** 订单发货 */
  Delivery = 'DELIVERY',
  /** 完成支付 */
  Paid = 'PAID',
  /** 确认收货 */
  Receive = 'RECEIVE',
  /** 退款成功 */
  Refund = 'REFUND'
}

/** 订单事件记录 */
export type OrderEventRecord = {
  __typename?: 'OrderEventRecord';
  /** 发生时间 */
  created_at?: Maybe<Scalars['Timestamp']['output']>;
  /** 操作人 */
  created_by?: Maybe<Scalars['Int']['output']>;
  /** 事件类型 */
  event?: Maybe<OrderEvent>;
  /** 起始状态 */
  from_status?: Maybe<OrderStatus>;
  /** 订单编号 */
  order_no?: Maybe<Scalars['String']['output']>;
  /** 结束状态 */
  to_status?: Maybe<OrderStatus>;
};

/** 订单开票信息 */
export type OrderInvoice = {
  __typename?: 'OrderInvoice';
  email?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  tax_no?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** 订单开票状态 */
export enum OrderInvoiceStatus {
  /** 已申请开票 */
  Applied = 'APPLIED',
  /** 可开票 */
  Available = 'AVAILABLE',
  /** 已开票 */
  Done = 'DONE',
  /** 无法开票 */
  Invalid = 'INVALID',
  /** 拒绝开票 */
  Rejected = 'REJECTED'
}

/** 订单商品详情 */
export type OrderItem = {
  __typename?: 'OrderItem';
  /** 基准总价 */
  base_amount?: Maybe<Scalars['Int']['output']>;
  /** 商品编号 */
  commodity_id?: Maybe<Scalars['Int']['output']>;
  /** 优惠详情 */
  discount?: Maybe<OrderDiscount>;
  /** 赠品来源 */
  freebie_source?: Maybe<Scalars['Int']['output']>;
  /** 详情编号 */
  id?: Maybe<Scalars['Int']['output']>;
  /** 商品优惠详情列表 */
  promotions?: Maybe<Array<Maybe<OrderPromotion>>>;
  /** 购买数量 */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** 实际支付金额 */
  real_pay_amount?: Maybe<Scalars['Int']['output']>;
  /** 收货人编号 */
  receiver_id?: Maybe<Scalars['Int']['output']>;
  /** 商品抵扣详情列表 */
  reductions?: Maybe<Array<Maybe<OrderPromotion>>>;
  /** 备注 */
  remark?: Maybe<Scalars['String']['output']>;
  /** 对应的sku详情 */
  sku_detail?: Maybe<Sku>;
  /** sku编号 */
  sku_id?: Maybe<Scalars['Int']['output']>;
  /** 总价 */
  total_amount?: Maybe<Scalars['Int']['output']>;
  /** 类型 */
  type?: Maybe<OrderItemType>;
  /** 商品优惠券详情列表 */
  user_coupons?: Maybe<Array<Maybe<OrderUserCoupon>>>;
};

/** 订单商品类型 */
export enum OrderItemType {
  /** 赠品 */
  Freebie = 'FREEBIE',
  /** 商品 */
  Sku = 'SKU'
}

/** 订单的物流信息 */
export type OrderLogisticsInfo = {
  __typename?: 'OrderLogisticsInfo';
  /** 收货人地址 */
  consignee_address?: Maybe<Scalars['String']['output']>;
  /** 收货人信息 */
  consignee_name?: Maybe<Scalars['String']['output']>;
  /** 收货人手机号 */
  consignee_phone_number?: Maybe<Scalars['String']['output']>;
  /** 收货人邮编 */
  consignee_zip?: Maybe<Scalars['String']['output']>;
  /** 发货时间 */
  delivery_time?: Maybe<Scalars['Timestamp']['output']>;
  /** 物流单号 */
  express_no?: Maybe<Scalars['String']['output']>;
  /** id */
  id?: Maybe<Scalars['Int']['output']>;
  /** 物流种类 */
  logistics_type?: Maybe<Scalars['String']['output']>;
  /** 订单编号 */
  order_no?: Maybe<Scalars['String']['output']>;
  /** 确认收货时间 */
  receive_time?: Maybe<Scalars['Timestamp']['output']>;
};

/** 订单优惠详情 */
export type OrderPromotion = {
  __typename?: 'OrderPromotion';
  /** 优惠金额 */
  discount?: Maybe<Scalars['Int']['output']>;
  /** 对应的促销活动 */
  promotion?: Maybe<Promotion>;
  /** sku编号列表 */
  sku_ids?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

/** 订单会员抵扣详情 */
export type OrderReduction = {
  __typename?: 'OrderReduction';
  /** 优惠金额 */
  discount?: Maybe<Scalars['Int']['output']>;
  /** 对应的促销活动 */
  promotion?: Maybe<Promotion>;
  /** sku编号列表 */
  sku_ids?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type OrderStatistic = {
  __typename?: 'OrderStatistic';
  /** 日期 */
  datetime?: Maybe<Scalars['Timestamp']['output']>;
  /** 订单数 */
  order_count?: Maybe<Scalars['BigInt']['output']>;
  /** 支付详情 */
  pay_channel_statistics?: Maybe<PayChannelStatistics>;
  /** 平台详情 */
  platform_statistics?: Maybe<PlatformStatistics>;
  /** 总收入 */
  revenue?: Maybe<Scalars['BigInt']['output']>;
  /** sku详情 */
  sku_statistics?: Maybe<SkuStatistics>;
};

export enum OrderStatisticPeriod {
  Day = 'DAY',
  Half = 'HALF',
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type OrderStatisticsConnection = {
  __typename?: 'OrderStatisticsConnection';
  nodes?: Maybe<Array<Maybe<OrderStatistic>>>;
  page_info?: Maybe<PageInfo>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** 订单状态 */
export enum OrderStatus {
  /** 已拆分 */
  BrokenUp = 'BROKEN_UP',
  /** 已取消 */
  Canceled = 'CANCELED',
  /** 已关闭 */
  Closed = 'CLOSED',
  /** 已完成 */
  Completed = 'COMPLETED',
  /** 已退款 */
  Refunded = 'REFUNDED',
  /** 退款中 */
  Refunding = 'REFUNDING',
  /** 待发货 */
  Undelivery = 'UNDELIVERY',
  /** 未支付 */
  Unpaid = 'UNPAID',
  /** 待收货 */
  Unreceived = 'UNRECEIVED'
}

/** 订单支付记录 */
export type OrderTransaction = {
  __typename?: 'OrderTransaction';
  /** 支付金额 */
  amount?: Maybe<Scalars['Int']['output']>;
  /** 创建时间 */
  created_at?: Maybe<Scalars['Timestamp']['output']>;
  /** 支付货币 */
  currency?: Maybe<Currency>;
  /** 第三方支付流水号 */
  excrow_charge_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** 订单编号 */
  order_no?: Maybe<Scalars['String']['output']>;
  /** 支付方式 */
  pay_channel?: Maybe<Scalars['String']['output']>;
  /** 支付完成时间 */
  pay_time?: Maybe<Scalars['Timestamp']['output']>;
  /** ping++的支付凭证 */
  pingpp_charge?: Maybe<Scalars['Map']['output']>;
  /** 备注 */
  remark?: Maybe<Scalars['String']['output']>;
  /** 更新时间 */
  updated_at?: Maybe<Scalars['Timestamp']['output']>;
};

/** 订单优惠券详情 */
export type OrderUserCoupon = {
  __typename?: 'OrderUserCoupon';
  /** 优惠金额 */
  discount?: Maybe<Scalars['Int']['output']>;
  /** sku编号列表 */
  sku_ids?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** 对应的促销活动 */
  user_coupon?: Maybe<UserCoupon>;
};

/** 订单的用户信息 */
export type OrderUserInfo = {
  __typename?: 'OrderUserInfo';
  /** 首次购买 */
  first_buy?: Maybe<Scalars['Boolean']['output']>;
  /** 用户编号 */
  user_id?: Maybe<Scalars['Int']['output']>;
  /** 用户等级 */
  user_level?: Maybe<Scalars['Int']['output']>;
};

export type OrdersConnection = {
  __typename?: 'OrdersConnection';
  nodes?: Maybe<Array<Maybe<Order>>>;
  page_info?: Maybe<PageInfo>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  end_cursor?: Maybe<Scalars['String']['output']>;
  has_next_page?: Maybe<Scalars['Boolean']['output']>;
};

export type PaginationInput = {
  /** 游标 */
  after?: InputMaybe<Scalars['String']['input']>;
  /** 每页数量 */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** 偏移量 */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PayChannelStatistics = {
  __typename?: 'PayChannelStatistics';
  amounts?: Maybe<Scalars['Map']['output']>;
  frequency?: Maybe<Scalars['Map']['output']>;
};

export type PayOrderResp = {
  __typename?: 'PayOrderResp';
  /** 订单详情 */
  order: Order;
};

/** 权限条目 */
export type PermissionEntry = {
  __typename?: 'PermissionEntry';
  /** 权限详细信息（预留扩展） */
  info?: Maybe<PermissionInfo>;
  /** 权限名称 */
  name?: Maybe<Scalars['String']['output']>;
};

/** 权限详细信息（目前为空，预留后续扩展） */
export type PermissionInfo = {
  __typename?: 'PermissionInfo';
  /** 权限名称 */
  name?: Maybe<Scalars['String']['output']>;
};

/** 用户平台 */
export enum Platform {
  /** 安卓app */
  Android = 'ANDROID',
  /** 桌面APP */
  Desktop = 'DESKTOP',
  /** 苹果app */
  Ios = 'IOS',
  /** 苹果app内购 */
  IosIap = 'IOS_IAP',
  /** 小程序 */
  MiniProgram = 'MINI_PROGRAM',
  /** 终端 */
  Terminal = 'TERMINAL',
  /** 第三方平台 */
  ThirdParty = 'THIRD_PARTY',
  /** 手机浏览器 */
  Wap = 'WAP',
  /** 主站 */
  Web = 'WEB',
  /** 微信浏览器 */
  Wechat = 'WECHAT'
}

export type PlatformStatistics = {
  __typename?: 'PlatformStatistics';
  amounts?: Maybe<Scalars['Map']['output']>;
  frequency?: Maybe<Scalars['Map']['output']>;
};

/** 帖子 */
export type Post = {
  __typename?: 'Post';
  author?: Maybe<User>;
  body?: Maybe<Scalars['String']['output']>;
  counter?: Maybe<Counter>;
  display_time?: Maybe<Scalars['Timestamp']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  image_urls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  is_digest?: Maybe<Scalars['Boolean']['output']>;
  is_hot?: Maybe<Scalars['Boolean']['output']>;
  tag_relations?: Maybe<Array<Maybe<TagRelation>>>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  title?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** 会员信息 */
export type Privilege = {
  __typename?: 'Privilege';
  /** 过期时间 */
  expired_at?: Maybe<Scalars['Timestamp']['output']>;
  /** 特权类型 */
  name?: Maybe<PrivilegeEnum>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** 特权类型 */
export enum PrivilegeEnum {
  /** 文章流权限（已弃用） */
  ArticleFlow = 'article_flow',
  /** 每日简报权限（预留） */
  DailyNewsletter = 'daily_newsletter',
  /** 研究报告权限（已弃用） */
  ResearchReport = 'research_report',
  /** 机构终端用户，拥有终端权限 */
  Terminal = 'terminal'
}

/** 项目 */
export enum Project {
  /** 先兆Omen投研AGI系统 */
  Omen = 'OMEN',
  /** 投研终端 */
  Omni = 'OMNI',
  /** 智堡 */
  Origin = 'ORIGIN'
}

export type Promotion = {
  __typename?: 'Promotion';
  /** 参加次数限制 */
  count_limit?: Maybe<Scalars['Int']['output']>;
  /** 促销描述 */
  description?: Maybe<Scalars['String']['output']>;
  /** 促销结束时间 */
  end_time?: Maybe<Scalars['Timestamp']['output']>;
  /** 促销编号 */
  id: Scalars['Int']['output'];
  /** 是否与其它优惠活动同享 */
  is_superposed?: Maybe<Scalars['Boolean']['output']>;
  /** 促销名称 */
  name?: Maybe<Scalars['String']['output']>;
  /** 推广链接 */
  page_uri?: Maybe<Scalars['String']['output']>;
  /** 促销平台 */
  platforms?: Maybe<Array<Maybe<Platform>>>;
  /** 促销项目 */
  projects?: Maybe<Array<Maybe<Project>>>;
  /** 促销类型 */
  promotion_type?: Maybe<PromotionType>;
  /** 活动备注 */
  remark?: Maybe<Scalars['String']['output']>;
  /** 规则详情 */
  rule?: Maybe<PromotionRule>;
  /** 商品范围 */
  scope?: Maybe<PromotionScope>;
  /** 商品范围 */
  scope_text?: Maybe<Scalars['String']['output']>;
  /** 促销开始时间 */
  start_time?: Maybe<Scalars['Timestamp']['output']>;
  /** 促销状态 */
  status?: Maybe<PromotionStatus>;
  /** 用户范围 */
  user_scopes?: Maybe<Array<Maybe<UserScope>>>;
};

export type PromotionInput = {
  /** 参加次数限制 */
  count_limit?: InputMaybe<Scalars['Int']['input']>;
  /** 促销描述 */
  description?: InputMaybe<Scalars['String']['input']>;
  /** 促销结束时间 */
  end_time?: InputMaybe<Scalars['Timestamp']['input']>;
  /** 促销编号 */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** 是否与其他优惠活动同享 */
  is_superposed?: InputMaybe<Scalars['Boolean']['input']>;
  /** 促销名称 */
  name?: InputMaybe<Scalars['String']['input']>;
  /** 推广链接 */
  page_uri?: InputMaybe<Scalars['String']['input']>;
  /** 促销平台 */
  platforms?: InputMaybe<Array<InputMaybe<Platform>>>;
  /** 促销项目 */
  projects?: InputMaybe<Array<InputMaybe<Project>>>;
  /** 促销类型 */
  promotion_type?: InputMaybe<PromotionType>;
  /** 活动备注 */
  remark?: InputMaybe<Scalars['String']['input']>;
  /** 详情设置（单品促销、总价促销、优惠券） */
  rule?: InputMaybe<PromotionRuleInput>;
  /** 商品范围 */
  scope?: InputMaybe<PromotionScopeInput>;
  /** 促销开始时间 */
  start_time?: InputMaybe<Scalars['Timestamp']['input']>;
  /** 促销状态 */
  status?: InputMaybe<PromotionStatus>;
  /** 用户范围 */
  user_scopes?: InputMaybe<Array<InputMaybe<UserScope>>>;
};

export type PromotionRule = {
  __typename?: 'PromotionRule';
  /** 总价促销设置 */
  amount?: Maybe<AmountPromotion>;
  /** 优惠券设置 */
  coupon?: Maybe<CouponPromotion>;
  /** 赠品促销设置 */
  freebie?: Maybe<FreebiePromotion>;
  /** 单品促销设置 */
  item?: Maybe<ItemPromotion>;
  /** 抵扣配置 */
  reduction?: Maybe<ReductionPromotion>;
};

export type PromotionRuleInput = {
  /** 总价促销设置 */
  amount?: InputMaybe<AmountPromotionInput>;
  /** 优惠券设置 */
  coupon?: InputMaybe<CouponPromotionInput>;
  /** 赠品促销设置 */
  freebie?: InputMaybe<FreebiePromotionInput>;
  /** 单品促销设置 */
  item?: InputMaybe<ItemPromotionInput>;
  /** 抵扣配置 */
  reduction?: InputMaybe<ReductionPromotionInput>;
};

export type PromotionScope = {
  __typename?: 'PromotionScope';
  /** 排除的商品范围 */
  exclude?: Maybe<Array<Maybe<PromotionScopeRule>>>;
  /** 包含的商品范围 */
  include?: Maybe<Array<Maybe<PromotionScopeRule>>>;
};

export type PromotionScopeInput = {
  /** 排除的商品范围 */
  exclude?: InputMaybe<Array<InputMaybe<PromotionScopeRuleInput>>>;
  /** 包含的商品范围 */
  include?: InputMaybe<Array<InputMaybe<PromotionScopeRuleInput>>>;
};

export type PromotionScopeRule = {
  __typename?: 'PromotionScopeRule';
  /** 范围类型 */
  type: PromotionScopeType;
  /** 值列表 */
  values?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type PromotionScopeRuleInput = {
  /** 范围类型 */
  type?: InputMaybe<PromotionScopeType>;
  /** 值列表(如果是sku范围，则代表sku编号列表) */
  values?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

/** 促销商品范围 */
export enum PromotionScopeType {
  /** 全部商品 */
  All = 'ALL',
  /** 某些品类 */
  Category = 'CATEGORY',
  /** 某些商品 */
  Commodity = 'COMMODITY',
  /** 某些类型 */
  Kind = 'KIND',
  /** 某些sku */
  Sku = 'SKU'
}

/** 促销状态 */
export enum PromotionStatus {
  /** 删除状态 */
  Deleted = 'DELETED',
  /** 草稿状态 */
  Draft = 'DRAFT',
  /** 发布状态 */
  Published = 'PUBLISHED'
}

/** 促销类型 */
export enum PromotionType {
  /** 总价促销 */
  Amount = 'AMOUNT',
  /** 优惠券 */
  Coupon = 'COUPON',
  /** 赠品促销 */
  Freebie = 'FREEBIE',
  /** 单品促销 */
  Item = 'ITEM',
  /** 会员抵扣 */
  Reduction = 'REDUCTION'
}

export type PromotionsConnection = {
  __typename?: 'PromotionsConnection';
  nodes?: Maybe<Array<Maybe<Promotion>>>;
  page_info?: Maybe<PageInfo>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** 广播下发结果 */
export type PushBroadcastResult = {
  __typename?: 'PushBroadcastResult';
  group_id?: Maybe<Scalars['String']['output']>;
  tasks?: Maybe<Array<Maybe<PushTask>>>;
};

/** 推送目标平台 */
export enum PushPlatform {
  /** 全平台 */
  All = 'ALL',
  /** 安卓 */
  Android = 'ANDROID',
  /** 苹果 */
  Ios = 'IOS'
}

/** 推送厂商 */
export enum PushProvider {
  /** 阿里云移动推送 */
  Aliyun = 'ALIYUN',
  /** 友盟推送(过渡期存量设备) */
  Umeng = 'UMENG'
}

/** 推送任务 */
export type PushTask = {
  __typename?: 'PushTask';
  body?: Maybe<Scalars['String']['output']>;
  created_time?: Maybe<Scalars['String']['output']>;
  dismiss_count?: Maybe<Scalars['Int']['output']>;
  error_message?: Maybe<Scalars['String']['output']>;
  /** 离线过期时间 */
  expire_time?: Maybe<Scalars['String']['output']>;
  /** 透传参数 */
  extra?: Maybe<Scalars['Map']['output']>;
  /** 任务组ID，同一次推送的任务共享 */
  group_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  open_count?: Maybe<Scalars['Int']['output']>;
  platform?: Maybe<PushPlatform>;
  provider?: Maybe<PushProvider>;
  /** 厂商侧任务标识 */
  provider_task_id?: Maybe<Scalars['String']['output']>;
  sent_count?: Maybe<Scalars['Int']['output']>;
  /** 定时发送时间 */
  start_time?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PushTaskStatus>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** 推送任务状态 */
export enum PushTaskStatus {
  /** 发送失败 */
  Failed = 'FAILED',
  /** 已撤销 */
  Revoked = 'REVOKED',
  /** 定时任务未开始 */
  Scheduled = 'SCHEDULED',
  /** 发送中 */
  Sending = 'SENDING',
  /** 发送完成 */
  Sent = 'SENT'
}

export type PushTasksConnection = {
  __typename?: 'PushTasksConnection';
  nodes?: Maybe<Array<Maybe<PushTask>>>;
  page_info?: Maybe<PageInfo>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type Raffle = {
  __typename?: 'Raffle';
  /** 参加次数限制 */
  count_limit?: Maybe<Scalars['Int']['output']>;
  /** 抽奖封面 */
  cover_uri?: Maybe<Scalars['String']['output']>;
  /** 抽奖描述 */
  description?: Maybe<Scalars['String']['output']>;
  /** 抽奖结束时间 */
  end_time?: Maybe<Scalars['Timestamp']['output']>;
  /** 抽奖编号 */
  id: Scalars['Int']['output'];
  /** 抽奖名称 */
  name?: Maybe<Scalars['String']['output']>;
  /** 推广链接 */
  page_uri?: Maybe<Scalars['String']['output']>;
  /** 抽奖平台 */
  platforms?: Maybe<Array<Maybe<Platform>>>;
  /** 抽奖备注 */
  remark?: Maybe<Scalars['String']['output']>;
  /** 商品范围 */
  scope?: Maybe<PromotionScope>;
  /** 抽奖开始时间 */
  start_time?: Maybe<Scalars['Timestamp']['output']>;
  /** 抽奖状态 */
  status?: Maybe<RaffleStatus>;
  /** 用户范围 */
  user_scopes?: Maybe<Array<Maybe<UserScope>>>;
};

export type RaffleInput = {
  /** 参加次数限制 */
  count_limit?: InputMaybe<Scalars['Int']['input']>;
  /** 抽奖封面 */
  cover_uri?: InputMaybe<Scalars['String']['input']>;
  /** 抽奖描述 */
  description?: InputMaybe<Scalars['String']['input']>;
  /** 抽奖结束时间 */
  end_time?: InputMaybe<Scalars['Timestamp']['input']>;
  /** 抽奖编号 */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** 抽奖名称 */
  name?: InputMaybe<Scalars['String']['input']>;
  /** 推广链接 */
  page_uri?: InputMaybe<Scalars['String']['input']>;
  /** 抽奖平台 */
  platforms?: InputMaybe<Array<InputMaybe<Platform>>>;
  /** 抽奖项目 */
  projects?: InputMaybe<Array<InputMaybe<Project>>>;
  /** 活动备注 */
  remark?: InputMaybe<Scalars['String']['input']>;
  /** 商品范围 */
  scope?: InputMaybe<PromotionScopeInput>;
  /** 抽奖开始时间 */
  start_time?: InputMaybe<Scalars['Timestamp']['input']>;
  /** 抽奖状态 */
  status?: InputMaybe<RaffleStatus>;
  /** 用户范围 */
  user_scopes?: InputMaybe<Array<InputMaybe<UserScope>>>;
};

/** 抽奖活动状态 */
export enum RaffleStatus {
  /** 删除状态 */
  Deleted = 'DELETED',
  /** 草稿状态 */
  Draft = 'DRAFT',
  /** 发布状态 */
  Published = 'PUBLISHED'
}

export type RafflesConnection = {
  __typename?: 'RafflesConnection';
  nodes?: Maybe<Array<Maybe<Raffle>>>;
  page_info?: Maybe<PageInfo>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type ReceiveOrderResp = {
  __typename?: 'ReceiveOrderResp';
  /** 订单详情 */
  order: Order;
};

/** 抵扣配置 */
export type ReductionPromotion = {
  __typename?: 'ReductionPromotion';
  /** 最大抵扣量 */
  max_value?: Maybe<Scalars['Int']['output']>;
  /** 抵扣比例，比如使用黑金会员抵扣，ratio设置为150，则表示一天黑金会员可抵1.5元 */
  ratio?: Maybe<Scalars['Int']['output']>;
  /** 抵扣类型 */
  type?: Maybe<ReductionPromotionType>;
};

/** 抵扣配置 */
export type ReductionPromotionInput = {
  /** 最大抵扣量 */
  max_value?: InputMaybe<Scalars['Int']['input']>;
  /** 抵扣比例，比如使用黑金会员抵扣，ratio设置为150，则表示一天黑金会员可抵1.5元 */
  ratio?: InputMaybe<Scalars['Int']['input']>;
  /** 抵扣类型 */
  type?: InputMaybe<ReductionPromotionType>;
};

/** 抵扣类型 */
export enum ReductionPromotionType {
  /** 使用黑金会员有效期来抵扣 */
  Blackgold = 'BLACKGOLD',
  /** OMEN普通计划补差价升级 */
  CreditNotmalUpgrade = 'CREDIT_NOTMAL_UPGRADE',
  /** OMEN专业计划补差价升级 */
  CreditProUpgrade = 'CREDIT_PRO_UPGRADE'
}

export type Referral = {
  __typename?: 'Referral';
  /** 是否激活 */
  activated?: Maybe<Scalars['Boolean']['output']>;
  /** 拉新活动编号 */
  activity_id?: Maybe<Scalars['Int']['output']>;
  /** 邀请编号 */
  id?: Maybe<Scalars['Int']['output']>;
  /** 被邀请人编号 */
  invitee_id?: Maybe<Scalars['Int']['output']>;
  /** 被邀请人手机号码 */
  invitee_phone?: Maybe<Scalars['String']['output']>;
  /** 被邀请人国家编号 */
  invitee_phone_code?: Maybe<Scalars['Int']['output']>;
  /** 赠品促销编号 */
  promotion_id?: Maybe<Scalars['Int']['output']>;
  /** 邀请人编号 */
  uid?: Maybe<Scalars['Int']['output']>;
};

export type ReferralActivity = {
  __typename?: 'ReferralActivity';
  /** 过期时间 */
  expired_at?: Maybe<Scalars['Timestamp']['output']>;
  /** 拉新活动编号 */
  id?: Maybe<Scalars['Int']['output']>;
  /** 活动描述 */
  long_description?: Maybe<Scalars['String']['output']>;
  /** 最大次数 */
  max_count?: Maybe<Scalars['Int']['output']>;
  /** 赠品促销编号 */
  promotion_id?: Maybe<Scalars['Int']['output']>;
};

export type ReferralActivityInput = {
  /** 过期时间 */
  expired_at?: InputMaybe<Scalars['Timestamp']['input']>;
  /** 拉新活动编号 */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** 活动描述 */
  long_description?: InputMaybe<Scalars['String']['input']>;
  /** 最大次数 */
  max_count?: InputMaybe<Scalars['Int']['input']>;
  /** 赠品促销编号 */
  promotion_id?: InputMaybe<Scalars['Int']['input']>;
};

export type ReferralInput = {
  /** 拉新活动编号 */
  activity_id?: InputMaybe<Scalars['Int']['input']>;
  /** 邀请编号 */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** 被邀请人编号 */
  invitee_id?: InputMaybe<Scalars['Int']['input']>;
  /** 被邀请人手机号码 */
  invitee_phone?: InputMaybe<Scalars['BigInt']['input']>;
  /** 被邀请人国家编号 */
  invitee_phone_code?: InputMaybe<Scalars['Int']['input']>;
  /** 邀请人编号 */
  uid?: InputMaybe<Scalars['Int']['input']>;
};

export type ReferralsConnection = {
  __typename?: 'ReferralsConnection';
  nodes?: Maybe<Array<Maybe<Referral>>>;
  page_info?: Maybe<PageInfo>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type RelationFilter = {
  /** 排除还是包含 */
  exclude?: InputMaybe<Scalars['Boolean']['input']>;
  /** 组编号列表，如果提供，则表示包含其中一个即可 */
  groups?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** 关系编号，如果为0代表只需要满足kind即可 */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** 关系类型 */
  kind: RelationKind;
};

/** 关系类型 */
export enum RelationKind {
  /** [23] 日历专题 */
  CalendarTopic = 'CALENDAR_TOPIC',
  /** [20] 外部源 */
  ExternalSource = 'EXTERNAL_SOURCE',
  /** [21] 外部源分组 */
  ExternalSourceGroup = 'EXTERNAL_SOURCE_GROUP',
  /** [0] 原特殊和tag */
  None = 'NONE',
  /** [14] 新的普通tag */
  Tag = 'TAG',
  /** [19] 新专题 */
  Topic = 'TOPIC'
}

/** 研究报告 */
export type Report = {
  __typename?: 'Report';
  ai_content?: Maybe<Scalars['String']['output']>;
  /** body音频url */
  body_audio_url?: Maybe<Scalars['String']['output']>;
  content_url?: Maybe<Scalars['String']['output']>;
  counter?: Maybe<Counter>;
  /** 积分费用 */
  credit_expense?: Maybe<Scalars['Int']['output']>;
  /** 是否需要积分购买 */
  credit_paywall?: Maybe<Scalars['Boolean']['output']>;
  display_time?: Maybe<Scalars['Timestamp']['output']>;
  document_content_url?: Maybe<Scalars['String']['output']>;
  downloadable?: Maybe<Scalars['Boolean']['output']>;
  /** 文件后缀 */
  extension?: Maybe<Scalars['String']['output']>;
  /** feed音频url */
  feed_audio_url?: Maybe<Scalars['String']['output']>;
  /** LLM生成的资讯 */
  feed_info?: Maybe<Scalars['String']['output']>;
  /** 生成资讯的AI 模型 */
  feed_info_model?: Maybe<Scalars['String']['output']>;
  file_meta?: Maybe<FileMeta>;
  /** 报告导出的html内容 */
  html?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  images?: Maybe<Array<Maybe<ReportImage>>>;
  /** 报告导出的内容，主要用于LLM输出 */
  llm_text?: Maybe<Scalars['String']['output']>;
  /** 报告导出的markdown内容 */
  markdown?: Maybe<Scalars['String']['output']>;
  /** 报告导出的纯文本内容 */
  plain_text?: Maybe<Scalars['String']['output']>;
  /** AI聊天中的引用内容块 */
  reference_blocks?: Maybe<Scalars['String']['output']>;
  /** document对应的url */
  reference_blocks_url?: Maybe<Scalars['String']['output']>;
  /** LLM生成的summary */
  summary?: Maybe<Scalars['String']['output']>;
  /** summary音频url */
  summary_audio_url?: Maybe<Scalars['String']['output']>;
  /** 生成summary的AI 模型 */
  summary_model?: Maybe<Scalars['String']['output']>;
  tag_relations?: Maybe<Array<Maybe<TagRelation>>>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** 如果prefix存在，则为prefix-原标题 */
  title?: Maybe<Scalars['String']['output']>;
  title_prefix?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
  vip_visibility?: Maybe<Scalars['Int']['output']>;
};

/** 报告的AI 衍生内容 */
export type ReportAiDerivative = {
  __typename?: 'ReportAIDerivative';
  content?: Maybe<Scalars['String']['output']>;
  content_kind?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['Timestamp']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Timestamp']['output']>;
};

/** 报告中的图片 */
export type ReportImage = {
  __typename?: 'ReportImage';
  created_at?: Maybe<Scalars['Timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  display_time?: Maybe<Scalars['Timestamp']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  /** 图片id，用来更新 */
  id?: Maybe<Scalars['Int']['output']>;
  /** 图片的引用id */
  image_id?: Maybe<Scalars['String']['output']>;
  /** 报告id */
  media_id?: Maybe<Scalars['Int']['output']>;
  /** 图片的序号 */
  serial_number?: Maybe<Scalars['Int']['output']>;
  /** tag配置 */
  tag_relations?: Maybe<Array<Maybe<TagRelation>>>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Timestamp']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

/** 报告图片修改内容 */
export type ReportImageInput = {
  /** 可选，图片描述 */
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  /** tag配置 */
  tag_relations?: InputMaybe<Array<InputMaybe<TagRelationInput>>>;
  /** 可选，图片标题 */
  title?: InputMaybe<Scalars['String']['input']>;
  /** 可选，图片地址 */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** 报告的统计信息 */
export type ReportStatisticProperty = {
  __typename?: 'ReportStatisticProperty';
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['BigInt']['output']>;
};

/** 路线图 */
export type RoadMap = {
  __typename?: 'RoadMap';
  content?: Maybe<Scalars['String']['output']>;
  counter?: Maybe<Counter>;
  id?: Maybe<Scalars['Int']['output']>;
  tag_relations?: Maybe<Array<Maybe<TagRelation>>>;
  tags?: Maybe<Array<Maybe<Tag>>>;
};

/** 路演 */
export type Roadshow = {
  __typename?: 'Roadshow';
  body?: Maybe<Scalars['String']['output']>;
  counter?: Maybe<Counter>;
  created_at?: Maybe<Scalars['Timestamp']['output']>;
  end_time?: Maybe<Scalars['Timestamp']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  live_method?: Maybe<Scalars['String']['output']>;
  live_status?: Maybe<Scalars['String']['output']>;
  people?: Maybe<Scalars['String']['output']>;
  poster?: Maybe<Scalars['String']['output']>;
  start_time?: Maybe<Scalars['Timestamp']['output']>;
  status?: Maybe<ContentStatus>;
  summary?: Maybe<Scalars['String']['output']>;
  tag_relations?: Maybe<Array<Maybe<TagRelation>>>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** 腾讯会议配置 */
  tencent_meeting?: Maybe<TcMeetingConfig>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Timestamp']['output']>;
  video?: Maybe<Video>;
  video_id?: Maybe<Scalars['Int']['output']>;
  vip_visibility?: Maybe<Scalars['Int']['output']>;
};

/** 路演 */
export type RoadshowInput = {
  /** 付费解锁内容 */
  body?: InputMaybe<Scalars['String']['input']>;
  /** 会议结束时间 */
  end_time?: InputMaybe<Scalars['Timestamp']['input']>;
  /** 路演ID */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** 路演方式 */
  live_method?: InputMaybe<Scalars['String']['input']>;
  /** 主讲人 */
  people?: InputMaybe<Scalars['String']['input']>;
  /** 封面 */
  poster?: InputMaybe<Scalars['String']['input']>;
  /** 会议结束时间 */
  start_time?: InputMaybe<Scalars['Timestamp']['input']>;
  /** 路演状态 */
  status?: InputMaybe<ContentStatus>;
  summary?: InputMaybe<Scalars['String']['input']>;
  /** tag配置 */
  tag_relations?: InputMaybe<Array<InputMaybe<TagRelationInput>>>;
  /** 腾讯会议配置 */
  tencent_meeting?: InputMaybe<TcMeetingConfigInput>;
  /** 标题 */
  title?: InputMaybe<Scalars['String']['input']>;
  /** 录像视频ID */
  video_id?: InputMaybe<Scalars['Int']['input']>;
  /** 付费等级 */
  vip_visibility?: InputMaybe<Scalars['Int']['input']>;
};

/** 路演用户 */
export type RoadshowUser = {
  __typename?: 'RoadshowUser';
  /** 国家代码（如86,不带+） */
  area: Scalars['String']['output'];
  /** 昵称 */
  nickname?: Maybe<Scalars['String']['output']>;
  /** 手机号 */
  phone_number: Scalars['String']['output'];
};

/** 路演用户组 */
export type RoadshowUserGroup = {
  __typename?: 'RoadshowUserGroup';
  /** 组id */
  id: Scalars['Int']['output'];
  /** 组名 */
  name: Scalars['String']['output'];
  /** 用户列表 */
  users?: Maybe<Array<Maybe<RoadshowUser>>>;
};

export type RoadshowUserGroupConnection = {
  __typename?: 'RoadshowUserGroupConnection';
  nodes?: Maybe<Array<Maybe<RoadshowUserGroup>>>;
  page_info?: Maybe<PageInfo>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** 路演用户组 */
export type RoadshowUserGroupInput = {
  /** 组id */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** 组名 */
  name?: InputMaybe<Scalars['String']['input']>;
  /** 用户列表 */
  users?: InputMaybe<Array<InputMaybe<RoadshowUserInput>>>;
};

/** 路演用户 */
export type RoadshowUserInput = {
  /** 国家代码（如86,不带+） */
  area?: InputMaybe<Scalars['String']['input']>;
  /** 昵称 */
  nickname?: InputMaybe<Scalars['String']['input']>;
  /** 手机号 */
  phone_number: Scalars['String']['input'];
};

/** 路演白名单Item类型 */
export enum RoadshowWhiteListItemKind {
  /** 用户组 */
  Group = 'GROUP',
  /** 单个用户 */
  User = 'USER'
}

/** 角色操作历史记录 */
export type RoleOperationHistory = {
  __typename?: 'RoleOperationHistory';
  /** 额外数据（JSON格式，包含adjustment_unit, adjustment_amount, expires_at, reason, error 等） */
  extra_data?: Maybe<Scalars['String']['output']>;
  /** 操作记录ID */
  id?: Maybe<Scalars['Int']['output']>;
  /** 操作的唯一标识ID (UUID) */
  operation_id?: Maybe<Scalars['String']['output']>;
  /** 操作发生时间 */
  operation_time?: Maybe<Scalars['Timestamp']['output']>;
  /** 操作类型 */
  operation_type?: Maybe<RoleOperationType>;
  /** 执行操作的用户信息 */
  operator?: Maybe<User>;
  /** 执行操作的用户ID（管理员或系统） */
  operator_id?: Maybe<Scalars['Int']['output']>;
  /** 角色名称（如 meta_member, omen_ai_pro 等） */
  role_name?: Maybe<Scalars['String']['output']>;
  /** 被修改角色的用户信息 */
  user?: Maybe<User>;
  /** 被修改角色的用户ID */
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type RoleOperationHistoryPage = {
  __typename?: 'RoleOperationHistoryPage';
  items?: Maybe<Array<Maybe<RoleOperationHistory>>>;
  page_info?: Maybe<PageInfo>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** 角色操作类型 */
export enum RoleOperationType {
  /** 成功更新角色有效期 */
  UpdateRoleValidity = 'UPDATE_ROLE_VALIDITY',
  /** 更新角色有效期失败 */
  UpdateRoleValidityFailed = 'UPDATE_ROLE_VALIDITY_FAILED'
}

/** 角色来源类型 */
export enum RoleSource {
  /** 派生角色（从家庭组长继承） */
  Derived = 'DERIVED',
  /** 直接分配的角色（用户自己订阅） */
  Direct = 'DIRECT'
}

/** 角色期限变更输入 */
export type RoleValidityChangeInput = {
  /** 相对时间调整（与 expires_at 二选一） */
  adjustment?: InputMaybe<DurationAdjustmentInput>;
  /** 绝对到期时间（与 adjustment 二选一） */
  expires_at?: InputMaybe<Scalars['Timestamp']['input']>;
  /** 角色名称（例如 meta_member, omen_ai_pro 等） */
  role_name: Scalars['String']['input'];
};

/** 顶层评论及其子回复 */
export type RootComment = {
  __typename?: 'RootComment';
  active?: Maybe<Scalars['Boolean']['output']>;
  children?: Maybe<Array<Maybe<CommentNode>>>;
  comment?: Maybe<Comment>;
};

/** 发送邀请响应 */
export type SendInvitationResponse = {
  __typename?: 'SendInvitationResponse';
  /** 邀请ID */
  invitation_id?: Maybe<Scalars['Int']['output']>;
  /** 用户友好的提示信息 */
  message?: Maybe<Scalars['String']['output']>;
  /** 配额信息 */
  quota?: Maybe<InvitationQuotaInfo>;
  /** 邀请状态 */
  status?: Maybe<GroupInvitationStatus>;
  /** 邀请令牌 (用于生成邀请链接) */
  token?: Maybe<Scalars['String']['output']>;
};

export type Sku = {
  __typename?: 'Sku';
  /** 所属的商品编号 */
  commodity_id: Scalars['Int']['output'];
  /** 成本价 */
  cost_price?: Maybe<Scalars['Int']['output']>;
  /** 商品封面 */
  cover_uri?: Maybe<Scalars['String']['output']>;
  /** 描述 */
  description?: Maybe<Scalars['String']['output']>;
  /** 自动发货代码 */
  dispatch_code?: Maybe<Scalars['String']['output']>;
  /** sku的ID */
  id: Scalars['Int']['output'];
  /** 库存数目 */
  in_stock?: Maybe<Scalars['Int']['output']>;
  /** 详细描述 */
  long_description?: Maybe<Scalars['String']['output']>;
  /** 单次最大购买数量 */
  maximum_per_purchase?: Maybe<Scalars['Int']['output']>;
  /** sku的编号 */
  name?: Maybe<Scalars['String']['output']>;
  /** 是否上架 */
  on_sale?: Maybe<Scalars['Boolean']['output']>;
  /** 平台 */
  platforms?: Maybe<Array<Maybe<Platform>>>;
  /** 售价 */
  price?: Maybe<Scalars['Int']['output']>;
  /** 项目 */
  projects?: Maybe<Array<Maybe<Project>>>;
  /** 促销列表 */
  promotions?: Maybe<PromotionsConnection>;
  /** 销量 */
  saled_number?: Maybe<Scalars['Int']['output']>;
  /** sku规格属性列表 */
  spec_attrs?: Maybe<Array<Maybe<CommodityAttribute>>>;
  /** 交易成功后的提醒消息 */
  system_message?: Maybe<Scalars['String']['output']>;
  /** 用户范围 */
  user_scopes?: Maybe<Array<Maybe<UserScope>>>;
};


export type SkuPromotionsArgs = {
  platform?: InputMaybe<Platform>;
  project?: InputMaybe<Project>;
};

export type SkuInput = {
  /** 成本价 */
  cost_price?: InputMaybe<Scalars['Int']['input']>;
  /** 商品封面 */
  cover_uri?: InputMaybe<Scalars['String']['input']>;
  /** 描述 */
  description?: InputMaybe<Scalars['String']['input']>;
  /** 自动发货代码 */
  dispatch_code?: InputMaybe<Scalars['String']['input']>;
  /** sku的ID */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** 库存数目 */
  in_stock?: InputMaybe<Scalars['Int']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  /** 详细描述 */
  long_description?: InputMaybe<Scalars['String']['input']>;
  /** 单次最大购买数量 */
  maximum_per_purchase?: InputMaybe<Scalars['Int']['input']>;
  /** sku标题 */
  name?: InputMaybe<Scalars['String']['input']>;
  /** 是否上架 */
  on_sale?: InputMaybe<Scalars['Boolean']['input']>;
  /** 售卖平台 */
  platforms?: InputMaybe<Array<InputMaybe<Platform>>>;
  /** 售价 */
  price?: InputMaybe<Scalars['Int']['input']>;
  /** 售卖项目 */
  projects?: InputMaybe<Array<InputMaybe<Project>>>;
  /** 销量 */
  saled_number?: InputMaybe<Scalars['Int']['input']>;
  /** sku规格属性列表 */
  spec_attrs?: InputMaybe<Array<InputMaybe<CommodityAttributeInput>>>;
  /** sku的规格 */
  specs?: InputMaybe<Array<InputMaybe<CommodityAttributeInput>>>;
  /** 交易成功后的提醒消息 */
  system_message?: InputMaybe<Scalars['String']['input']>;
  /** 用户范围 */
  user_scopes?: InputMaybe<Array<InputMaybe<UserScope>>>;
};

export type SkuQuantity = {
  /** 购买数量 */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** 商品购买备注 */
  remark?: InputMaybe<Scalars['String']['input']>;
  /** sku编号 */
  sku_id?: InputMaybe<Scalars['Int']['input']>;
};

export type SkuStatistics = {
  __typename?: 'SkuStatistics';
  amounts?: Maybe<Scalars['Map']['output']>;
  frequency?: Maybe<Scalars['Map']['output']>;
  names?: Maybe<Scalars['Map']['output']>;
};

export type SkusConnection = {
  __typename?: 'SkusConnection';
  nodes?: Maybe<Array<Maybe<Sku>>>;
  page_info?: Maybe<PageInfo>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** 排序 */
export type SortBy = {
  /** 是否升序 */
  asc?: InputMaybe<Scalars['Boolean']['input']>;
  /** 排序字段 */
  field?: InputMaybe<Scalars['String']['input']>;
};

/** 外部源分组 */
export type SourceGroupInput = {
  /** 外部源分组的封面 */
  cover?: InputMaybe<Scalars['String']['input']>;
  /** 外部源分组的描述 */
  description?: InputMaybe<Scalars['String']['input']>;
  /** 外部源分组的id */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** 外部源分组的名称 */
  name?: InputMaybe<Scalars['String']['input']>;
  /** 外部源分组的状态 */
  status?: InputMaybe<ContentStatus>;
};

/** 外部源 */
export type SourceInput = {
  /** 外部源的封面 */
  cover?: InputMaybe<Scalars['String']['input']>;
  /** 外部源的描述 */
  description?: InputMaybe<Scalars['String']['input']>;
  /** 外部源的id */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** 外部源的唯一key */
  key?: InputMaybe<Scalars['String']['input']>;
  /** 外部源的名称 */
  name?: InputMaybe<Scalars['String']['input']>;
  /** 外部源的状态 */
  status?: InputMaybe<ContentStatus>;
  /** tag配置 */
  tag_relations?: InputMaybe<Array<InputMaybe<TagRelationInput>>>;
};

/** 外部源订阅记录 */
export type Subscription = {
  __typename?: 'Subscription';
  /** 订阅时间 */
  created_at?: Maybe<Scalars['Timestamp']['output']>;
  /** 分组名称 */
  group_name?: Maybe<Scalars['String']['output']>;
  /** 外部源的封面图片地址 */
  source?: Maybe<ExternalSource>;
  /** 外部源的id */
  source_id?: Maybe<Scalars['Int']['output']>;
};

export type Tag = {
  __typename?: 'Tag';
  /** 该Tag下包含的内容 */
  contents?: Maybe<ContentPage>;
  cover_url?: Maybe<Scalars['String']['output']>;
  debug?: Maybe<Scalars['Int']['output']>;
  /** 标签描述 */
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  is_private?: Maybe<Scalars['Boolean']['output']>;
  /** 是否为外部源的分组标签 */
  is_source_group?: Maybe<Scalars['Boolean']['output']>;
  /** 是否为专题标签 */
  is_topic?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};


export type TagContentsArgs = {
  end_time?: InputMaybe<Scalars['Timestamp']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  kinds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort_by?: InputMaybe<Scalars['String']['input']>;
  start_time?: InputMaybe<Scalars['Timestamp']['input']>;
  tag_id?: InputMaybe<Scalars['Int']['input']>;
  vip_visibility?: InputMaybe<Scalars['Int']['input']>;
};

export type TagRelation = {
  __typename?: 'TagRelation';
  group?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  k?: Maybe<RelationKind>;
  score?: Maybe<Scalars['Int']['output']>;
};

export type TagRelationInput = {
  group?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  k?: InputMaybe<RelationKind>;
  score?: InputMaybe<Scalars['Int']['input']>;
};

/** 标签订阅操作 */
export type TagSubscribeInput = {
  /** 标签子分组名编号,默认为0 */
  group_id?: InputMaybe<Scalars['Int']['input']>;
  /** 订阅操作, 0-订阅 1-退订 */
  operation?: InputMaybe<Scalars['Int']['input']>;
  /** 标签id */
  tag_id?: InputMaybe<Scalars['Int']['input']>;
  /** 标签名称,订阅操作时需要传 */
  tag_name?: InputMaybe<Scalars['String']['input']>;
};

/** 标签订阅记录 */
export type TagSubscription = {
  __typename?: 'TagSubscription';
  /** 订阅时间 */
  created_at?: Maybe<Scalars['Timestamp']['output']>;
  /** 子分组id */
  group_id?: Maybe<Scalars['Int']['output']>;
  /** 标签详情 */
  tag?: Maybe<Tag>;
  /** 标签id */
  tag_id?: Maybe<Scalars['Int']['output']>;
};

/** 腾讯会议配置 */
export type TcMeetingConfig = {
  __typename?: 'TcMeetingConfig';
  /** 腾讯会议ID */
  meeting_id?: Maybe<Scalars['String']['output']>;
  /** 参会密码 */
  password?: Maybe<Scalars['String']['output']>;
  /** 是否自动上传录像（保留字段） */
  upload_video_record?: Maybe<Scalars['Boolean']['output']>;
  /** 排除的组 */
  wl_exclude?: Maybe<Array<Maybe<TcMeetingWhiteListItem>>>;
  /** 包含的组 */
  wl_include?: Maybe<Array<Maybe<TcMeetingWhiteListItem>>>;
};

/** 腾讯会议配置 */
export type TcMeetingConfigInput = {
  /** 腾讯会议ID */
  meeting_id?: InputMaybe<Scalars['String']['input']>;
  /** 参会密码 */
  password?: InputMaybe<Scalars['String']['input']>;
  /** 是否自动上传录像（保留字段） */
  upload_video_record?: InputMaybe<Scalars['Boolean']['input']>;
  /** 排除的组 */
  wl_exclude?: InputMaybe<Array<InputMaybe<TcMeetingWhiteListItemInput>>>;
  /** 包含的组 */
  wl_include?: InputMaybe<Array<InputMaybe<TcMeetingWhiteListItemInput>>>;
};

/** 路演白名单单项 */
export type TcMeetingWhiteListItem = {
  __typename?: 'TcMeetingWhiteListItem';
  /** 用户为 <86 1761111111>，用户组则为 <组id> */
  key: Scalars['String']['output'];
  /** 用户 or 用户组 */
  kind: RoadshowWhiteListItemKind;
  /** 用户昵称 or 组名 */
  name?: Maybe<Scalars['String']['output']>;
};

/** 路演白名单单项参数 */
export type TcMeetingWhiteListItemInput = {
  /** 用户为 <86 1761111111>，用户组则为 <组id> */
  key: Scalars['String']['input'];
  /** 用户 or 用户组 */
  kind: RoadshowWhiteListItemKind;
  /** 用户昵称 or 组名 */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** 抽奖参数 */
export type TryToRaffleInput = {
  /** 收货人 */
  consignee_id: Scalars['Int']['input'];
  /** 下单平台 */
  platform?: InputMaybe<Platform>;
  /** 抽奖编号 */
  raffle_id: Scalars['Int']['input'];
};

/** 角色更新失败条目 */
export type UpdateRoleValiditiesFailedEntry = {
  __typename?: 'UpdateRoleValiditiesFailedEntry';
  /** 错误信息 */
  error?: Maybe<Scalars['String']['output']>;
  /** 角色名称 */
  role_name?: Maybe<Scalars['String']['output']>;
};

/** 批量更新角色有效期响应 */
export type UpdateRoleValiditiesResponse = {
  __typename?: 'UpdateRoleValiditiesResponse';
  /** 失败的角色列表 */
  failed_roles?: Maybe<Array<Maybe<UpdateRoleValiditiesFailedEntry>>>;
  /** 操作记录ID */
  operation_id?: Maybe<Scalars['Int']['output']>;
  /** 成功更新的角色列表 */
  updated_roles?: Maybe<Array<Maybe<UpdateRoleValiditiesResultEntry>>>;
};

/** 角色更新结果条目 */
export type UpdateRoleValiditiesResultEntry = {
  __typename?: 'UpdateRoleValiditiesResultEntry';
  /** 更新后的角色信息 */
  role?: Maybe<UserRole>;
  /** 角色名称 */
  role_name?: Maybe<Scalars['String']['output']>;
};

export type User = Author & {
  __typename?: 'User';
  /** @deprecated typo */
  Institution?: Maybe<Scalars['String']['output']>;
  /** Apple UUID */
  apple_uuid?: Maybe<Scalars['String']['output']>;
  /** 头像地址 */
  avatar?: Maybe<Scalars['String']['output']>;
  /** 收藏数量（需要从其他服务获取） */
  collection_count?: Maybe<Scalars['Int']['output']>;
  /** 国家 */
  country?: Maybe<Scalars['String']['output']>;
  country_code?: Maybe<Scalars['Int']['output']>;
  /** 创建时间 */
  created_at?: Maybe<Scalars['Timestamp']['output']>;
  /** 用户积分订阅详情 */
  credit_subscription?: Maybe<UserCreditSubscription>;
  /** 用户描述 */
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /** 是否有微信 OpenID */
  has_open_id?: Maybe<Scalars['Boolean']['output']>;
  /** 用户编号 */
  id?: Maybe<Scalars['Int']['output']>;
  /** 行业 */
  industry?: Maybe<Scalars['String']['output']>;
  institution?: Maybe<Scalars['String']['output']>;
  /** 邀请人编号 */
  inviter_id?: Maybe<Scalars['Int']['output']>;
  /** IP 地址列表 */
  ips?: Maybe<Scalars['String']['output']>;
  /** 是否为作者 */
  is_author?: Maybe<Scalars['Boolean']['output']>;
  /** 是否绑定微信 */
  is_wechat_bound?: Maybe<Scalars['Boolean']['output']>;
  /**
   * 用户会员信息列表
   * @deprecated 请使用role_profile
   */
  memberships?: Maybe<Array<Maybe<MemberShip>>>;
  /** 用户手机号 */
  mobile?: Maybe<Scalars['String']['output']>;
  /** 昵称 */
  nickname?: Maybe<Scalars['String']['output']>;
  /** 职业 */
  occupation?: Maybe<Scalars['String']['output']>;
  /** @deprecated 请使用role_profile */
  privileges?: Maybe<Array<Maybe<Privilege>>>;
  /** 剩余推广分享次数（需要从推广服务获取） */
  remaining_promotion_share_count?: Maybe<Scalars['Int']['output']>;
  /** 用户角色配置文件，包含所有角色和权限 */
  role_profile?: Maybe<UserRoleProfile>;
  /** 性别（0: 未知, 1: 男, 2: 女） */
  sex?: Maybe<Scalars['Int']['output']>;
  /** 注册方式 */
  sign_up_method?: Maybe<Scalars['String']['output']>;
  /** 用户账户状态 */
  status?: Maybe<Scalars['String']['output']>;
  /** 订阅者数量 */
  subscriber_count?: Maybe<Scalars['Int']['output']>;
  /** 订阅数量（需要从其他服务获取） */
  subscription_count?: Maybe<Scalars['Int']['output']>;
  /** 更新时间 */
  updated_at?: Maybe<Scalars['Timestamp']['output']>;
  verified_name?: Maybe<Scalars['String']['output']>;
  /** 验证名称（verified_name 别名） */
  verify_name?: Maybe<Scalars['String']['output']>;
  /** 微信 OpenID */
  wechat_open_id?: Maybe<Scalars['String']['output']>;
  /** 微信 UnionID */
  wechat_union_id?: Maybe<Scalars['String']['output']>;
};

export type UserCollectionPage = {
  __typename?: 'UserCollectionPage';
  items?: Maybe<Array<Maybe<Content>>>;
  page_info?: Maybe<PageInfo>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** 用户优惠券 */
export type UserCoupon = {
  __typename?: 'UserCoupon';
  /** 优惠券活动编号 */
  coupon_id?: Maybe<Scalars['Int']['output']>;
  /** 过期时间 */
  expire_at?: Maybe<Scalars['Timestamp']['output']>;
  /** 记录编号 */
  id?: Maybe<Scalars['Int']['output']>;
  /** 是否为系统发送 */
  is_send?: Maybe<Scalars['Boolean']['output']>;
  /** 优惠券名称 */
  name?: Maybe<Scalars['String']['output']>;
  /** 优惠详情 */
  promotion?: Maybe<Promotion>;
  /** 起始时间 */
  start_at?: Maybe<Scalars['Timestamp']['output']>;
  /** 优惠券状态 */
  status?: Maybe<UserCouponStatus>;
  /** 优惠券类型 */
  type?: Maybe<CouponPromotionType>;
  /** 使用时间 */
  used_at?: Maybe<Scalars['Timestamp']['output']>;
  /** 用户编号 */
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** 生成用户优惠券的参数 */
export type UserCouponInput = {
  /** 优惠券活动编号 */
  coupon_id?: InputMaybe<Scalars['Int']['input']>;
  /** 记录编号 */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** 用户编号 */
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** 用户优惠券的状态 */
export enum UserCouponStatus {
  /** 已过期 */
  Expired = 'EXPIRED',
  /** 已作废 */
  Invalid = 'INVALID',
  /** 未使用 */
  Unused = 'UNUSED',
  /** 已使用 */
  Used = 'USED'
}

export type UserCouponsConnection = {
  __typename?: 'UserCouponsConnection';
  nodes?: Maybe<Array<Maybe<UserCoupon>>>;
  page_info?: Maybe<PageInfo>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type UserCreditInfo = {
  __typename?: 'UserCreditInfo';
  amount?: Maybe<Scalars['Int']['output']>;
  /** 重置时间 */
  expired_at?: Maybe<Scalars['Timestamp']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type UserCreditSubscription = {
  __typename?: 'UserCreditSubscription';
  /** 积分详情 */
  credit_info?: Maybe<UserCreditInfo>;
  /** 过期时间 */
  expired_at?: Maybe<Scalars['Timestamp']['output']>;
  /** 是否试用中 */
  is_trial?: Maybe<Scalars['Boolean']['output']>;
  plan?: Maybe<CreditSubscriptionPlan>;
  /** 起始时间 */
  started_at?: Maybe<Scalars['Timestamp']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type UserPage = {
  __typename?: 'UserPage';
  items?: Maybe<Array<Maybe<User>>>;
  page_info?: Maybe<PageInfo>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** 用户角色信息 */
export type UserRole = {
  __typename?: 'UserRole';
  /** 角色到期时间 */
  expires_at?: Maybe<Scalars['Timestamp']['output']>;
  /** 角色名称（例如 meta_member, derived_meta_member） */
  name?: Maybe<Scalars['String']['output']>;
  /** 角色来源 */
  source?: Maybe<RoleSource>;
  /** 来源所有者用户ID（仅用于派生角色） */
  source_owner_id?: Maybe<Scalars['Int']['output']>;
};

/** 用户角色配置文件，包含所有角色和权限 */
export type UserRoleProfile = {
  __typename?: 'UserRoleProfile';
  /** 所有权限名称列表（便捷字段，仅返回权限名称） */
  permission_names?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** 所有权限详情列表（包含权限名称和信息） */
  permissions?: Maybe<Array<Maybe<PermissionEntry>>>;
  /** 权限 Map 对象（key: 权限名, value: 权限信息）- 返回 {"perm1": {}, "perm2": {}} 格式 */
  permissions_map?: Maybe<Scalars['Map']['output']>;
  /** 所有角色列表（直接角色和派生角色） */
  roles?: Maybe<Array<Maybe<UserRole>>>;
  /** 用户ID */
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** 促销用户类型 */
export enum UserScope {
  /** 黑金会员 */
  Blackgold = 'BLACKGOLD',
  /** 首次购买用户 */
  FirstBuy = 'FIRST_BUY',
  /** 免费用户 */
  Free = 'FREE',
  /** 元会员 */
  Meta = 'META',
  /** 非首次购买 */
  NotFirstBuy = 'NOT_FIRST_BUY'
}

export type UsersConnection = {
  __typename?: 'UsersConnection';
  nodes?: Maybe<Array<Maybe<User>>>;
  page_info?: Maybe<PageInfo>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** 视频 */
export type Video = {
  __typename?: 'Video';
  author?: Maybe<Author>;
  counter?: Maybe<Counter>;
  cover_url?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  display_time?: Maybe<Scalars['Timestamp']['output']>;
  episodes?: Maybe<Array<Maybe<VideoEpisode>>>;
  /** 是否含有译文 */
  has_translation?: Maybe<Scalars['Boolean']['output']>;
  /** 视频导出的html内容 */
  html?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** 视频导出的内容，主要用于LLM输出 */
  llm_text?: Maybe<Scalars['String']['output']>;
  /** 视频导出的markdown内容 */
  markdown?: Maybe<Scalars['String']['output']>;
  /** 媒体类型（MIME type） */
  media_type?: Maybe<Scalars['String']['output']>;
  /** 视频导出的纯文本内容 */
  plain_text?: Maybe<Scalars['String']['output']>;
  planned_published_at?: Maybe<Scalars['Timestamp']['output']>;
  /** AI聊天中的引用内容块 */
  reference_blocks?: Maybe<Scalars['String']['output']>;
  /** document对应的url */
  reference_blocks_url?: Maybe<Scalars['String']['output']>;
  related_article_ids?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  related_articles?: Maybe<Array<Maybe<Article>>>;
  related_report_ids?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  related_reports?: Maybe<Array<Maybe<Report>>>;
  /** 发言人ID到名称的映射 */
  speaker_names?: Maybe<Scalars['Map']['output']>;
  /** 转写识别的发言人ID列表 */
  speakers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  status?: Maybe<Scalars['String']['output']>;
  /** 视频摘要 */
  summary?: Maybe<Scalars['String']['output']>;
  tag_relations?: Maybe<Array<Maybe<TagRelation>>>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  title?: Maybe<Scalars['String']['output']>;
  /** 转写 markdown */
  transcription?: Maybe<Scalars['String']['output']>;
  /** 双语转写 markdown（含翻译） */
  transcription_bilingual?: Maybe<Scalars['String']['output']>;
  /** 中文文字稿 markdown */
  transcription_cn?: Maybe<Scalars['String']['output']>;
  /** 视频文件地址 */
  url?: Maybe<Scalars['String']['output']>;
  vip_visibility?: Maybe<Scalars['Int']['output']>;
};

/** 视频分片 */
export type VideoEpisode = {
  __typename?: 'VideoEpisode';
  created_at?: Maybe<Scalars['Timestamp']['output']>;
  display_time?: Maybe<Scalars['Timestamp']['output']>;
  /** 视频时长 */
  duration?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** 预览时长 */
  preview_duration?: Maybe<Scalars['Int']['output']>;
  /** 预览视频地址 */
  preview_url?: Maybe<Scalars['String']['output']>;
  series_id?: Maybe<Scalars['Int']['output']>;
  /** 视频文件大小 */
  size?: Maybe<Scalars['Int']['output']>;
  /** 缩略图列表 */
  thumbnail_urls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** 视频文件地址 */
  url?: Maybe<Scalars['String']['output']>;
  vip_visibility?: Maybe<Scalars['Int']['output']>;
};

export type WscnArticle = {
  __typename?: 'WscnArticle';
  content?: Maybe<Scalars['String']['output']>;
  /** 展示时间 */
  display_time?: Maybe<Scalars['Timestamp']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  /** 原始更新时间 */
  original_updated_at?: Maybe<Scalars['Timestamp']['output']>;
  status?: Maybe<ContentStatus>;
  summary?: Maybe<Scalars['String']['output']>;
  /** tag配置 */
  tag_relations?: Maybe<Array<Maybe<TagRelation>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type WscnArticleInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ContentStatus>;
  /** tag配置 */
  tag_relations?: InputMaybe<Array<InputMaybe<TagRelationInput>>>;
};

export type WscnLive = {
  __typename?: 'WscnLive';
  /** body音频url */
  body_audio_url?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  content_more?: Maybe<Scalars['String']['output']>;
  /** 展示时间 */
  display_time?: Maybe<Scalars['Timestamp']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  images?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  /** 原始更新时间 */
  original_updated_at?: Maybe<Scalars['Timestamp']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<ContentStatus>;
  /** tag配置 */
  tag_relations?: Maybe<Array<Maybe<TagRelation>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type WscnLiveInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ContentStatus>;
  /** tag配置 */
  tag_relations?: InputMaybe<Array<InputMaybe<TagRelationInput>>>;
};

export type Detail = AShareIrManagement | Article | Audio | AudioEpisode | CalendarEvent | CalendarTopic | Comment | ExternalItem | ExternalSource | ExternalSourceGroup | Faq | Image | Link | Post | Report | ReportImage | RoadMap | Roadshow | Tag | Video | WscnArticle | WscnLive;

export type Mutation = {
  __typename?: 'mutation';
  /** 新建AI聊天对话 */
  aichatConversationCreate?: Maybe<AiChatConversation>;
  /** 插入AI聊天对话消息 */
  aichatMessagesInsert?: Maybe<Array<Maybe<AiChatMessage>>>;
  /** 创建 API Key */
  apiKeyCreate?: Maybe<ApiKeyCreated>;
  /** 撤销 API Key */
  apiKeyRevoke?: Maybe<Scalars['Boolean']['output']>;
  /** 苹果iap支付验证 */
  appleIapVerify?: Maybe<Order>;
  /** 新建日历事件 */
  calendarEventCreate: CalendarEvent;
  /** 更新日历事件 */
  calendarEventUpdate: CalendarEvent;
  /** 批量创建日历事件 */
  calendarEventsCreate?: Maybe<Array<Maybe<CalendarEvent>>>;
  /** 新建日历项专题 */
  calendarTopicCreate: CalendarTopic;
  /** 更新日历项专题 */
  calendarTopicUpdate: CalendarTopic;
  /** 创建 Bot */
  clawbot_create: Scalars['String']['output'];
  /** 删除 Bot */
  clawbot_delete?: Maybe<Scalars['Boolean']['output']>;
  /** 扫码登录 */
  clawbot_login?: Maybe<ClawbotLoginResult>;
  /** 重新启动 Bot */
  clawbot_start?: Maybe<Scalars['Boolean']['output']>;
  /** 停止 Bot */
  clawbot_stop?: Maybe<Scalars['Boolean']['output']>;
  /** 添加到收藏 */
  collectionAdd?: Maybe<Scalars['Boolean']['output']>;
  /** 从收藏移除 */
  collectionRemove?: Maybe<Scalars['Boolean']['output']>;
  /** 发表评论 */
  commentAdd?: Maybe<Comment>;
  /** 管理后台删除评论 */
  commentAdminDelete?: Maybe<Scalars['Boolean']['output']>;
  /** 点赞评论 */
  commentThumbUp?: Maybe<Scalars['Int']['output']>;
  /** 取消点赞 */
  commentThumbUpCancel?: Maybe<Scalars['Int']['output']>;
  /** 清空我的未读评论消息数 */
  commentUnreadClear?: Maybe<Scalars['Int']['output']>;
  /** 新建商品 */
  commodityCreate?: Maybe<Commodity>;
  /** 更新商品 */
  commodityUpdate: Commodity;
  /** 添加收货人信息 */
  consigneeCreate: Consignee;
  /** 删除收货人信息 */
  consigneeDelete?: Maybe<Scalars['Boolean']['output']>;
  consigneeUpdate: Consignee;
  /** 管理员帮用户退订 */
  creditInternalUnsubscribe: UserCreditSubscription;
  /** 使用credit购买内容 */
  creditPurchaseContent?: Maybe<UserCreditInfo>;
  /** 设置积分价格 */
  creditSetExpense: Scalars['Boolean']['output'];
  /** 解绑用户邮箱（账号必须保留至少一种登录方式） */
  emailUnbind?: Maybe<Scalars['Boolean']['output']>;
  /** 更新外部内容 */
  externalItemUpdate: ExternalItem;
  /** 更新外部源 */
  externalSourceCreate: ExternalSource;
  /** 创建外部源分组 */
  externalSourceGroupCreate: ExternalSourceGroup;
  /** 更新外部源分组 */
  externalSourceGroupUpdate: ExternalSourceGroup;
  /** 订阅外部源 */
  externalSourceSubscribe?: Maybe<Subscription>;
  /** 退订外部源 */
  externalSourceUnSubscribe?: Maybe<Scalars['Boolean']['output']>;
  /** 更新外部源 */
  externalSourceUpdate: ExternalSource;
  /** 创建家庭组 */
  familyGroupCreate: FamilyGroup;
  /** 解散家庭组 */
  familyGroupDisband?: Maybe<Scalars['Boolean']['output']>;
  /** 接受家庭组邀请 */
  familyGroupInvitationAccept?: Maybe<Scalars['Boolean']['output']>;
  /** 拒绝家庭组邀请 */
  familyGroupInvitationDecline?: Maybe<Scalars['Boolean']['output']>;
  /** 发送家庭组邀请 */
  familyGroupInvitationSend: SendInvitationResponse;
  /** 组员主动离开家庭组 */
  familyGroupLeave?: Maybe<Scalars['Boolean']['output']>;
  /** 添加家庭组成员 */
  familyGroupMemberAdd?: Maybe<Scalars['Boolean']['output']>;
  /** 移除家庭组成员 */
  familyGroupMemberRemove?: Maybe<Scalars['Boolean']['output']>;
  /** 开启或关闭 newsletter 紧急停发开关（管理员） */
  newsletterKillSwitchSet: NewsletterKillSwitchState;
  /** 创建 OIDC 接入方客户端（管理员） */
  oauthClientCreate: OauthClientCreateResult;
  /** 删除 OIDC 接入方客户端（管理员） */
  oauthClientDelete: Scalars['Boolean']['output'];
  /** 重置 OIDC 接入方密钥（管理员），旧密钥立即失效 */
  oauthClientSecretReset: Scalars['String']['output'];
  /** 更新 OIDC 接入方客户端（管理员），未传字段不变更 */
  oauthClientUpdate: OauthClient;
  /** 修改订单收货地址 */
  orderAlterAddress?: Maybe<OrderLogisticsInfo>;
  orderApplyInvoice: OrderInvoice;
  /** 订单申请退款（付款后，发货前） */
  orderApplyRefund: ApplyRefundOrderResp;
  /** 取消订单 */
  orderCancel?: Maybe<Order>;
  orderCancelInvoice?: Maybe<Scalars['Boolean']['output']>;
  /** 发起订单支付 */
  orderCharge?: Maybe<OrderCharge>;
  /** 下单前，核对订单 */
  orderCheck: OrderCheckInfo;
  /** 下单 */
  orderCreate: Order;
  /** 订单发货 */
  orderDelivery: DeliveryOrderResp;
  orderInvoice?: Maybe<Scalars['Boolean']['output']>;
  /** 订单完成支付(测试用) */
  orderPay: PayOrderResp;
  /** 订单确认收货 */
  orderReceive: ReceiveOrderResp;
  /** paypal支付验证 */
  paypalVerify?: Maybe<Order>;
  /** 新建促销活动 */
  promotionCreate: Promotion;
  /** 更新促销活动 */
  promotionUpdate: Promotion;
  /** 创建推送广播任务（管理员） */
  pushBroadcastCreate: PushBroadcastResult;
  /** 注册推送设备，未登录时注册为游客设备 */
  pushDeviceRegister: Scalars['Boolean']['output'];
  /** 调试用：直接向指定deviceId推送一条通知，绕过用户绑定（管理员） */
  pushDeviceTest: PushTask;
  /** 撤销尚未开始的推送定时任务（管理员） */
  pushTaskRevoke: Scalars['Boolean']['output'];
  /** 主动向厂商拉取推送任务统计（管理员） */
  pushTaskStatsRefresh: PushTask;
  /** 向指定用户推送通知，覆盖其名下全部有效设备（管理员） */
  pushUnicastCreate: PushBroadcastResult;
  /** 新建抽奖活动 */
  raffleCreate: Raffle;
  /** 更新抽奖活动 */
  raffleUpdate: Raffle;
  /** 新建拉新活动 */
  referralActivityCreate: ReferralActivity;
  /** 新建拉新活动 */
  referralActivityUpdate: ReferralActivity;
  /** 邀请其他用户 */
  referralCreate: Referral;
  /** 更新报告图片 */
  reportImageUpdate: ReportImage;
  /** 新建路演 */
  roadshowCreate: Roadshow;
  /** 更新路演 */
  roadshowUpdate: Roadshow;
  /** 创建路演用户组 */
  roadshowUserGroupCreate: RoadshowUserGroup;
  /** 删除路演用户组 */
  roadshowUserGroupDelete: Scalars['Boolean']['output'];
  /** 更新路演用户组 */
  roadshowUserGroupUpdate: RoadshowUserGroup;
  /** 订阅标签 */
  tagSubscribe?: Maybe<TagSubscription>;
  /** 退订标签 */
  tagUnSubscribe?: Maybe<Scalars['Boolean']['output']>;
  /** 用户抽奖 */
  tryToRaffle?: Maybe<Order>;
  /** 批量给用户发送优惠券 */
  userCouponBatchSend: BatchTask;
  /** 删除用户优惠券 */
  userCouponDelete: Scalars['Boolean']['output'];
  /** 用户领取优惠券 */
  userCouponGain?: Maybe<UserCoupon>;
  /** 给用户发送优惠券 */
  userCouponSend: UserCoupon;
  /** 更新用户优惠券 */
  userCouponUpdate: UserCoupon;
  /** 批量更新用户角色的有效期（仅管理员） */
  userRoleValiditiesUpdate: UpdateRoleValiditiesResponse;
  /** 更新外部见闻文章状态 */
  wscnArticleUpdate: WscnArticle;
  /** 更新外部见闻快讯状态 */
  wscnLiveUpdate: WscnLive;
};


export type MutationAichatConversationCreateArgs = {
  conversation: AiChatConversationInput;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationAichatMessagesInsertArgs = {
  conversation_id: Scalars['String']['input'];
  messages?: InputMaybe<Array<InputMaybe<AiChatMessageInput>>>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationApiKeyCreateArgs = {
  expires_at?: InputMaybe<Scalars['Timestamp']['input']>;
  name: Scalars['String']['input'];
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationApiKeyRevokeArgs = {
  key_id: Scalars['Int']['input'];
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationAppleIapVerifyArgs = {
  charge_id: Scalars['String']['input'];
  order_no: Scalars['String']['input'];
  receipt_data: Scalars['String']['input'];
  transaction_id: Scalars['String']['input'];
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCalendarEventCreateArgs = {
  event: CalendarEventInput;
};


export type MutationCalendarEventUpdateArgs = {
  event: CalendarEventInput;
};


export type MutationCalendarEventsCreateArgs = {
  events?: InputMaybe<Array<CalendarEventInput>>;
};


export type MutationCalendarTopicCreateArgs = {
  topic: CalendarTopicInput;
};


export type MutationCalendarTopicUpdateArgs = {
  topic: CalendarTopicInput;
};


export type MutationClawbot_CreateArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationClawbot_DeleteArgs = {
  bot_id: Scalars['String']['input'];
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationClawbot_LoginArgs = {
  bot_id: Scalars['String']['input'];
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationClawbot_StartArgs = {
  bot_id: Scalars['String']['input'];
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationClawbot_StopArgs = {
  bot_id: Scalars['String']['input'];
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCollectionAddArgs = {
  kind: Scalars['Int']['input'];
  raw_id: Scalars['Int']['input'];
};


export type MutationCollectionRemoveArgs = {
  kind: Scalars['Int']['input'];
  raw_id: Scalars['Int']['input'];
};


export type MutationCommentAddArgs = {
  at_users?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  content: Scalars['String']['input'];
  find_words?: InputMaybe<Scalars['Boolean']['input']>;
  image_url?: InputMaybe<Scalars['String']['input']>;
  item_id?: InputMaybe<Scalars['Int']['input']>;
  item_type?: InputMaybe<Scalars['Int']['input']>;
  reply_to_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCommentAdminDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationCommentThumbUpArgs = {
  reply_to_id: Scalars['Int']['input'];
};


export type MutationCommentThumbUpCancelArgs = {
  reply_to_id: Scalars['Int']['input'];
};


export type MutationCommodityCreateArgs = {
  commodity: CommodityInput;
};


export type MutationCommodityUpdateArgs = {
  commodity: CommodityInput;
};


export type MutationConsigneeCreateArgs = {
  receiver: ConsigneeInput;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationConsigneeDeleteArgs = {
  id: Scalars['Int']['input'];
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationConsigneeUpdateArgs = {
  receiver: ConsigneeInput;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreditInternalUnsubscribeArgs = {
  plan: CreditSubscriptionPlan;
  user_id: Scalars['Int']['input'];
};


export type MutationCreditPurchaseContentArgs = {
  content_id: Scalars['Int']['input'];
  kind: Scalars['Int']['input'];
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreditSetExpenseArgs = {
  amount: Scalars['Int']['input'];
  kind: CreditExpenseKind;
};


export type MutationEmailUnbindArgs = {
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationExternalItemUpdateArgs = {
  item: ExternalItemInput;
};


export type MutationExternalSourceCreateArgs = {
  source: SourceInput;
};


export type MutationExternalSourceGroupCreateArgs = {
  group: SourceGroupInput;
};


export type MutationExternalSourceGroupUpdateArgs = {
  group: SourceGroupInput;
};


export type MutationExternalSourceSubscribeArgs = {
  input: ExternalSourceSubscribeInput;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationExternalSourceUnSubscribeArgs = {
  input: ExternalSourceSubscribeInput;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationExternalSourceUpdateArgs = {
  source: SourceInput;
};


export type MutationFamilyGroupCreateArgs = {
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationFamilyGroupDisbandArgs = {
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationFamilyGroupInvitationAcceptArgs = {
  invitation_id: Scalars['Int']['input'];
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationFamilyGroupInvitationDeclineArgs = {
  invitation_id: Scalars['Int']['input'];
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationFamilyGroupInvitationSendArgs = {
  phone: Scalars['Int']['input'];
  phone_code: Scalars['Int']['input'];
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationFamilyGroupLeaveArgs = {
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationFamilyGroupMemberAddArgs = {
  member_user_id: Scalars['Int']['input'];
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationFamilyGroupMemberRemoveArgs = {
  member_user_id: Scalars['Int']['input'];
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationNewsletterKillSwitchSetArgs = {
  enabled: Scalars['Boolean']['input'];
};


export type MutationOauthClientCreateArgs = {
  name: Scalars['String']['input'];
  redirect_uris: Array<InputMaybe<Scalars['String']['input']>>;
  scopes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  skip_consent?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationOauthClientDeleteArgs = {
  client_id: Scalars['String']['input'];
};


export type MutationOauthClientSecretResetArgs = {
  client_id: Scalars['String']['input'];
};


export type MutationOauthClientUpdateArgs = {
  client_id: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  redirect_uris?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scopes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  skip_consent?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationOrderAlterAddressArgs = {
  consignee_address?: InputMaybe<Scalars['String']['input']>;
  consignee_name?: InputMaybe<Scalars['String']['input']>;
  consignee_phone_number?: InputMaybe<Scalars['String']['input']>;
  consignee_zip?: InputMaybe<Scalars['String']['input']>;
  order_no: Scalars['String']['input'];
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationOrderApplyInvoiceArgs = {
  email: Scalars['String']['input'];
  order_no: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  tax_no: Scalars['String']['input'];
  title: Scalars['String']['input'];
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationOrderApplyRefundArgs = {
  order_no: Scalars['String']['input'];
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationOrderCancelArgs = {
  order_no: Scalars['String']['input'];
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationOrderCancelInvoiceArgs = {
  order_no: Scalars['String']['input'];
  remark?: InputMaybe<Scalars['String']['input']>;
  set_invalid?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationOrderChargeArgs = {
  extra?: InputMaybe<Scalars['Map']['input']>;
  order_no: Scalars['String']['input'];
  pay_channel: Scalars['String']['input'];
  pay_currency?: InputMaybe<Currency>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationOrderCheckArgs = {
  input: CreateOrderInput;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationOrderCreateArgs = {
  input: CreateOrderInput;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationOrderDeliveryArgs = {
  express_no?: InputMaybe<Scalars['String']['input']>;
  logistics_type: Scalars['String']['input'];
  order_no: Scalars['String']['input'];
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationOrderInvoiceArgs = {
  order_no: Scalars['String']['input'];
  remark?: InputMaybe<Scalars['String']['input']>;
};


export type MutationOrderPayArgs = {
  charge_id: Scalars['String']['input'];
  order_no: Scalars['String']['input'];
};


export type MutationOrderReceiveArgs = {
  order_no: Scalars['String']['input'];
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationPaypalVerifyArgs = {
  order_no: Scalars['String']['input'];
  paypal_order_id: Scalars['String']['input'];
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationPromotionCreateArgs = {
  promotion: PromotionInput;
};


export type MutationPromotionUpdateArgs = {
  promotion: PromotionInput;
};


export type MutationPushBroadcastCreateArgs = {
  body: Scalars['String']['input'];
  expire_time?: InputMaybe<Scalars['String']['input']>;
  extra?: InputMaybe<Scalars['Map']['input']>;
  platform: PushPlatform;
  start_time?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};


export type MutationPushDeviceRegisterArgs = {
  device_id: Scalars['String']['input'];
  platform: PushPlatform;
  provider?: InputMaybe<PushProvider>;
  user_agent?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPushDeviceTestArgs = {
  body: Scalars['String']['input'];
  device_id: Scalars['String']['input'];
  extra?: InputMaybe<Scalars['Map']['input']>;
  platform: PushPlatform;
  provider?: InputMaybe<PushProvider>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};


export type MutationPushTaskRevokeArgs = {
  id: Scalars['Int']['input'];
};


export type MutationPushTaskStatsRefreshArgs = {
  id: Scalars['Int']['input'];
};


export type MutationPushUnicastCreateArgs = {
  body: Scalars['String']['input'];
  extra?: InputMaybe<Scalars['Map']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  user_ids: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type MutationRaffleCreateArgs = {
  raffle: RaffleInput;
};


export type MutationRaffleUpdateArgs = {
  raffle: RaffleInput;
};


export type MutationReferralActivityCreateArgs = {
  activity: ReferralActivityInput;
};


export type MutationReferralActivityUpdateArgs = {
  activity: ReferralActivityInput;
};


export type MutationReferralCreateArgs = {
  input: ReferralInput;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationReportImageUpdateArgs = {
  item: ReportImageInput;
};


export type MutationRoadshowCreateArgs = {
  roadshow: RoadshowInput;
};


export type MutationRoadshowUpdateArgs = {
  roadshow: RoadshowInput;
};


export type MutationRoadshowUserGroupCreateArgs = {
  group: RoadshowUserGroupInput;
};


export type MutationRoadshowUserGroupDeleteArgs = {
  group_id: Scalars['Int']['input'];
};


export type MutationRoadshowUserGroupUpdateArgs = {
  group: RoadshowUserGroupInput;
};


export type MutationTagSubscribeArgs = {
  input: TagSubscribeInput;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationTagUnSubscribeArgs = {
  input: TagSubscribeInput;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationTryToRaffleArgs = {
  input: TryToRaffleInput;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUserCouponBatchSendArgs = {
  coupon_id?: InputMaybe<Scalars['Int']['input']>;
  notify?: InputMaybe<Scalars['Boolean']['input']>;
  precheck?: InputMaybe<Scalars['Boolean']['input']>;
  task_name?: InputMaybe<Scalars['String']['input']>;
  user_ids: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type MutationUserCouponDeleteArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUserCouponGainArgs = {
  user_coupon?: InputMaybe<UserCouponInput>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUserCouponSendArgs = {
  user_coupon?: InputMaybe<UserCouponInput>;
};


export type MutationUserCouponUpdateArgs = {
  user_coupon?: InputMaybe<UserCouponInput>;
};


export type MutationUserRoleValiditiesUpdateArgs = {
  changes: Array<RoleValidityChangeInput>;
  reason?: InputMaybe<Scalars['String']['input']>;
  user_id: Scalars['Int']['input'];
};


export type MutationWscnArticleUpdateArgs = {
  item: WscnArticleInput;
};


export type MutationWscnLiveUpdateArgs = {
  item: WscnLiveInput;
};

export type Query = {
  __typename?: 'query';
  /** AI聊天对话列表 */
  aichat_conversations?: Maybe<AiChatConversationPage>;
  /** AI对话消息列表 */
  aichat_messages?: Maybe<AiChatMessagePage>;
  /** 获取用户的 API Key 列表 */
  api_keys?: Maybe<Array<Maybe<ApiKeyInfo>>>;
  /** 单个文章查询接口 */
  article?: Maybe<Article>;
  articles?: Maybe<ArticlePage>;
  audio?: Maybe<Audio>;
  audio_episode?: Maybe<AudioEpisode>;
  calendar_event?: Maybe<CalendarEvent>;
  calendar_topic?: Maybe<CalendarTopic>;
  /** 列出当前用户的 Bot */
  clawbot_bots?: Maybe<Array<Maybe<ClawbotBotInfo>>>;
  /** 获取 Bot 状态 */
  clawbot_status?: Maybe<ClawbotStatusResult>;
  /** 管理后台查看单条评论 */
  comment_admin?: Maybe<Comment>;
  /** 管理后台评论列表 */
  comment_admin_list?: Maybe<AdminCommentList>;
  /** 我的评论消息列表 */
  comment_messages?: Maybe<CommentMessageList>;
  /** 我的未读评论消息数 */
  comment_unread_count?: Maybe<Scalars['Int']['output']>;
  /** 获取商品列表 */
  commodities: CommodityConnection;
  /** 获取单个商品详情 */
  commodity: Commodity;
  content?: Maybe<Content>;
  content_collected?: Maybe<Scalars['Boolean']['output']>;
  contents?: Maybe<ContentPage>;
  counter?: Maybe<Counter>;
  /** 积分花费列表 */
  credit_expense: Array<Maybe<CreditPrice>>;
  daily_topk?: Maybe<Array<Maybe<Content>>>;
  external_item?: Maybe<ExternalItem>;
  external_source?: Maybe<ExternalSource>;
  external_subscriptions?: Maybe<Array<Maybe<Subscription>>>;
  /** 查询用户的家庭组信息，自动判断用户是组长还是成员 */
  familyGroupGet?: Maybe<FamilyGroup>;
  /** 通过邀请令牌获取家庭组邀请详情 (公开，无需登录) */
  familyGroupInvitationGetByToken?: Maybe<GroupInvitation>;
  /** 查询家庭组组长发出的所有邀请，支持按状态过滤 */
  familyGroupInvitationsListByOwner?: Maybe<GroupInvitationPage>;
  /** 查询用户收到的待处理家庭组邀请列表 */
  familyGroupInvitationsPending?: Maybe<GroupInvitationPage>;
  /** 查询家庭组的操作历史,支持分页 */
  familyGroupOperationHistoryList?: Maybe<OperationHistoryPage>;
  faq?: Maybe<Faq>;
  history_topk?: Maybe<Array<Maybe<Content>>>;
  /** 资源评论列表 */
  item_comments?: Maybe<ItemCommentsList>;
  /** 获取 newsletter 紧急停发开关状态（管理员） */
  newsletterKillSwitch: NewsletterKillSwitchState;
  /** OIDC 接入方客户端详情（管理员） */
  oauth_client: OauthClient;
  /** OIDC 接入方客户端列表（管理员） */
  oauth_clients: OauthClientsConnection;
  /** 通过订单编号获取订单信息 */
  order?: Maybe<Order>;
  /** 订单统计列表 */
  order_statistics?: Maybe<OrderStatisticsConnection>;
  /** 订单列表 */
  orders?: Maybe<OrdersConnection>;
  post?: Maybe<Post>;
  promotion: Promotion;
  promotions: PromotionsConnection;
  /** 推送任务详情（管理员） */
  push_task: PushTask;
  /** 推送任务列表（管理员） */
  push_tasks: PushTasksConnection;
  raffle: Raffle;
  raffles: RafflesConnection;
  /** 获取拉新活动详情 */
  referralActivity?: Maybe<ReferralActivity>;
  /** 获取当前登录用户在指定活动中的拉新记录 */
  referrals?: Maybe<ReferralsConnection>;
  report_derivatives?: Maybe<Array<Maybe<ReportAiDerivative>>>;
  reports_statistics?: Maybe<Array<Maybe<ReportStatisticProperty>>>;
  roadshow?: Maybe<Roadshow>;
  /** 获取路演用户组列表 */
  roadshow_user_groups: RoadshowUserGroupConnection;
  /** 查询用户的角色操作历史,支持分页（仅管理员可用） */
  roleOperationHistoryList?: Maybe<RoleOperationHistoryPage>;
  /** 获取单个sku */
  sku: Sku;
  /** 获取sku列表 */
  skus: SkusConnection;
  /** Get a tag by id */
  tag?: Maybe<Tag>;
  tag_subscriptions?: Maybe<Array<Maybe<TagSubscription>>>;
  /** Query tags by conditions */
  tags?: Maybe<Array<Maybe<Tag>>>;
  user?: Maybe<User>;
  userConsignees?: Maybe<ConsigneesConnection>;
  /** 用户优惠券列表 */
  userCoupons: UserCouponsConnection;
  /** 用户收藏列表 */
  user_collections?: Maybe<UserCollectionPage>;
  users?: Maybe<UserPage>;
  users_v2?: Maybe<UsersConnection>;
  video?: Maybe<Video>;
};


export type QueryAichat_ConversationsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAichat_MessagesArgs = {
  conversation_id?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryApi_KeysArgs = {
  status?: InputMaybe<ApiKeyStatus>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryArticleArgs = {
  id: Scalars['Int']['input'];
};


export type QueryArticlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  is_cooperation?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
  tag_id?: InputMaybe<Scalars['Int']['input']>;
  track?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  vip_visibility?: InputMaybe<Scalars['Int']['input']>;
  wc_gt?: InputMaybe<Scalars['Int']['input']>;
  wc_lt?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAudioArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAudio_EpisodeArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCalendar_EventArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCalendar_TopicArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryClawbot_BotsArgs = {
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryClawbot_StatusArgs = {
  bot_id: Scalars['String']['input'];
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryComment_AdminArgs = {
  id: Scalars['Int']['input'];
};


export type QueryComment_Admin_ListArgs = {
  comment_type?: InputMaybe<Scalars['Int']['input']>;
  from_user_id?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
  to_user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryComment_MessagesArgs = {
  from_user_id?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCommoditiesArgs = {
  category?: InputMaybe<Scalars['Int']['input']>;
  commodity_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  kind?: InputMaybe<CommodityKind>;
  on_sale?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  platform?: InputMaybe<Platform>;
  project?: InputMaybe<Project>;
  sku_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sort_by?: InputMaybe<Array<InputMaybe<SortBy>>>;
  track?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCommodityArgs = {
  id: Scalars['Int']['input'];
};


export type QueryContentArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  kind?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryContent_CollectedArgs = {
  kind: Scalars['Int']['input'];
  raw_id: Scalars['Int']['input'];
};


export type QueryContentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  ai_query?: InputMaybe<Scalars['String']['input']>;
  authors?: InputMaybe<Array<InputMaybe<AuthorFilter>>>;
  end_time?: InputMaybe<Scalars['Timestamp']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  kinds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  min_score?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  ralations_op?: InputMaybe<FilterOperator>;
  relations?: InputMaybe<Array<InputMaybe<RelationFilter>>>;
  sort_by?: InputMaybe<Scalars['String']['input']>;
  start_time?: InputMaybe<Scalars['Timestamp']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
  synonyms_keywords?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tag_followed?: InputMaybe<Scalars['Boolean']['input']>;
  tag_id?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  track?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
  vip_visibilities?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  vip_visibility?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCounterArgs = {
  item_id?: InputMaybe<Scalars['Int']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDaily_TopkArgs = {
  day?: InputMaybe<Scalars['Timestamp']['input']>;
  k?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryExternal_ItemArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryExternal_SourceArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryExternal_SubscriptionsArgs = {
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFamilyGroupGetArgs = {
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFamilyGroupInvitationGetByTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryFamilyGroupInvitationsListByOwnerArgs = {
  pagination?: InputMaybe<PaginationInput>;
  status?: InputMaybe<GroupInvitationStatus>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFamilyGroupInvitationsPendingArgs = {
  pagination?: InputMaybe<PaginationInput>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFamilyGroupOperationHistoryListArgs = {
  pagination?: InputMaybe<PaginationInput>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFaqArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryHistory_TopkArgs = {
  after?: InputMaybe<Scalars['Timestamp']['input']>;
  before?: InputMaybe<Scalars['Timestamp']['input']>;
  count_kind?: InputMaybe<Scalars['Int']['input']>;
  k?: InputMaybe<Scalars['Int']['input']>;
  kinds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryItem_CommentsArgs = {
  item_id: Scalars['Int']['input'];
  item_type: Scalars['Int']['input'];
  order_by?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOauth_ClientArgs = {
  client_id: Scalars['String']['input'];
};


export type QueryOauth_ClientsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryOrderArgs = {
  order_no: Scalars['String']['input'];
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrder_StatisticsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  period?: InputMaybe<OrderStatisticPeriod>;
};


export type QueryOrdersArgs = {
  broken_up?: InputMaybe<Scalars['Boolean']['input']>;
  invoice_status?: InputMaybe<OrderInvoiceStatus>;
  order_no?: InputMaybe<Scalars['String']['input']>;
  order_status?: InputMaybe<OrderStatus>;
  pagination?: InputMaybe<PaginationInput>;
  project?: InputMaybe<Project>;
  sort_by?: InputMaybe<Array<InputMaybe<SortBy>>>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPostArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPromotionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPromotionsArgs = {
  commodity?: InputMaybe<CommodityFilter>;
  pagination?: InputMaybe<PaginationInput>;
  platform?: InputMaybe<Platform>;
  project?: InputMaybe<Project>;
  promotion_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  promotion_type?: InputMaybe<PromotionType>;
  sort_by?: InputMaybe<Array<InputMaybe<SortBy>>>;
  status?: InputMaybe<PromotionStatus>;
  track?: InputMaybe<Scalars['String']['input']>;
  user_scopes?: InputMaybe<Array<InputMaybe<UserScope>>>;
};


export type QueryPush_TaskArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPush_TasksArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  platform?: InputMaybe<PushPlatform>;
  provider?: InputMaybe<PushProvider>;
  status?: InputMaybe<PushTaskStatus>;
};


export type QueryRaffleArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRafflesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  platform?: InputMaybe<Platform>;
  project?: InputMaybe<Project>;
  raffle_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sort_by?: InputMaybe<Array<InputMaybe<SortBy>>>;
  status?: InputMaybe<PromotionStatus>;
  track?: InputMaybe<Scalars['String']['input']>;
  user_scopes?: InputMaybe<Array<InputMaybe<UserScope>>>;
};


export type QueryReferralActivityArgs = {
  activity_id: Scalars['Int']['input'];
};


export type QueryReferralsArgs = {
  activity_id: Scalars['Int']['input'];
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryReport_DerivativesArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRoadshowArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRoadshow_User_GroupsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  track?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRoleOperationHistoryListArgs = {
  pagination?: InputMaybe<PaginationInput>;
  user_id: Scalars['Int']['input'];
};


export type QuerySkuArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySkusArgs = {
  category?: InputMaybe<Scalars['Int']['input']>;
  commodity_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  kind?: InputMaybe<CommodityKind>;
  on_sale?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  platform?: InputMaybe<Platform>;
  project?: InputMaybe<Project>;
  sku_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sort_by?: InputMaybe<Array<InputMaybe<SortBy>>>;
  track?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTagArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTag_SubscriptionsArgs = {
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Scalars['String']['input']>;
  is_private?: InputMaybe<Scalars['Boolean']['input']>;
  is_source_group?: InputMaybe<Scalars['Boolean']['input']>;
  is_topic?: InputMaybe<Scalars['Boolean']['input']>;
  kw?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserConsigneesArgs = {
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserCouponsArgs = {
  coupon_id?: InputMaybe<Scalars['Int']['input']>;
  kind?: InputMaybe<CouponPromotionType>;
  pagination?: InputMaybe<PaginationInput>;
  sort_by?: InputMaybe<Array<InputMaybe<SortBy>>>;
  status?: InputMaybe<UserCouponStatus>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUser_CollectionsArgs = {
  kinds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  pagination?: InputMaybe<PaginationInput>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  institution?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUsers_V2Args = {
  email?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  institution_name?: InputMaybe<Scalars['String']['input']>;
  mobile_number?: InputMaybe<Scalars['BigInt']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  sort_by?: InputMaybe<Array<InputMaybe<SortBy>>>;
  status?: InputMaybe<Scalars['String']['input']>;
  user_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryVideoArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type CalendarEventCreateMutationVariables = Exact<{
  event: CalendarEventInput;
}>;


export type CalendarEventCreateMutation = { __typename?: 'mutation', calendarEventCreate: { __typename?: 'CalendarEvent', country?: string | null, event?: string | null, id?: number | null, importance?: number | null, source?: CalendarSource | null, status?: ContentStatus | null, title?: string | null, display_time?: any | null, forecast?: string | null, revised?: string | null, previous?: string | null, actual?: string | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null } };

export type CalendarEventsCreateMutationVariables = Exact<{
  events?: InputMaybe<Array<CalendarEventInput> | CalendarEventInput>;
}>;


export type CalendarEventsCreateMutation = { __typename?: 'mutation', calendarEventsCreate?: Array<{ __typename?: 'CalendarEvent', country?: string | null, event?: string | null, id?: number | null, importance?: number | null, source?: CalendarSource | null, status?: ContentStatus | null, title?: string | null, display_time?: any | null, forecast?: string | null, revised?: string | null, previous?: string | null, actual?: string | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null } | null> | null };

export type CalendarTopicCreateMutationVariables = Exact<{
  topic: CalendarTopicInput;
}>;


export type CalendarTopicCreateMutation = { __typename?: 'mutation', calendarTopicCreate: { __typename?: 'CalendarTopic', id?: number | null, name?: string | null, status?: ContentStatus | null, description?: string | null, period?: string | null, website?: string | null, organization?: string | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null } };

export type ExternalSourceCreateMutationVariables = Exact<{
  source: SourceInput;
}>;


export type ExternalSourceCreateMutation = { __typename?: 'mutation', externalSourceCreate: { __typename?: 'ExternalSource', status?: ContentStatus | null, nickname?: string | null, name?: string | null, key?: string | null, id?: number | null, description?: string | null, cover?: string | null, avatar?: string | null, tag_relations?: Array<{ __typename?: 'TagRelation', k?: RelationKind | null, id?: number | null, group?: number | null } | null> | null } };

export type RoadshowCreateMutationVariables = Exact<{
  roadshow: RoadshowInput;
}>;


export type RoadshowCreateMutation = { __typename?: 'mutation', roadshowCreate: { __typename?: 'Roadshow', body?: string | null, created_at?: any | null, end_time?: any | null, id?: number | null, live_method?: string | null, live_status?: string | null, people?: string | null, poster?: string | null, start_time?: any | null, status?: ContentStatus | null, summary?: string | null, title?: string | null, updated_at?: any | null, vip_visibility?: number | null, video_id?: number | null, tag_relations?: Array<{ __typename?: 'TagRelation', group?: number | null, id?: number | null } | null> | null, tags?: Array<{ __typename?: 'Tag', id?: number | null, is_topic?: boolean | null, name?: string | null, cover_url?: string | null, description?: string | null } | null> | null, tencent_meeting?: { __typename?: 'TcMeetingConfig', password?: string | null, wl_include?: Array<{ __typename?: 'TcMeetingWhiteListItem', key: string, kind: RoadshowWhiteListItemKind, name?: string | null } | null> | null, wl_exclude?: Array<{ __typename?: 'TcMeetingWhiteListItem', key: string, kind: RoadshowWhiteListItemKind, name?: string | null } | null> | null } | null, video?: { __typename?: 'Video', id?: number | null, title?: string | null, cover_url?: string | null, status?: string | null } | null } };

export type RoadshowUserGroupCreateMutationVariables = Exact<{
  group: RoadshowUserGroupInput;
}>;


export type RoadshowUserGroupCreateMutation = { __typename?: 'mutation', roadshowUserGroupCreate: { __typename?: 'RoadshowUserGroup', id: number, name: string, users?: Array<{ __typename?: 'RoadshowUser', area: string, nickname?: string | null, phone_number: string } | null> | null } };

export type ExternalSourceGroupCreateMutationVariables = Exact<{
  group: SourceGroupInput;
}>;


export type ExternalSourceGroupCreateMutation = { __typename?: 'mutation', externalSourceGroupCreate: { __typename?: 'ExternalSourceGroup', status?: ContentStatus | null, nickname?: string | null, name?: string | null, id?: number | null, description?: string | null, cover?: string | null, avatar?: string | null } };

export type RoadshowUserGroupDeleteMutationVariables = Exact<{
  groupId: Scalars['Int']['input'];
}>;


export type RoadshowUserGroupDeleteMutation = { __typename?: 'mutation', roadshowUserGroupDelete: boolean };

export type BaseContentFragment = { __typename?: 'Content', raw_id?: number | null, status?: string | null, title?: string | null, description?: string | null, datetime?: any | null, vip_visibility?: number | null, kind?: number | null, cover_url?: string | null, readable?: boolean | null, author?: { __typename?: 'ExternalSource', id?: number | null, nickname?: string | null, avatar?: string | null } | { __typename?: 'ExternalSourceGroup', id?: number | null, nickname?: string | null, avatar?: string | null } | { __typename?: 'User', id?: number | null, nickname?: string | null, avatar?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id?: number | null, is_topic?: boolean | null, name?: string | null, cover_url?: string | null } | null> | null, counter?: { __typename?: 'Counter', viewed?: number | null, liked?: number | null, collected?: number | null, commented?: number | null } | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null };

export type ArticleFragment = { __typename?: 'Article', id?: number | null, title?: string | null, body?: string | null, cover_url?: string | null, display_time?: any | null, free_expired_at?: any | null, free_at?: any | null, planned_published_at?: any | null, summary?: string | null, preview?: string | null, source_url?: string | null, vip_visibility?: number | null, author?: { __typename?: 'ExternalSource', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null } | { __typename?: 'ExternalSourceGroup', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null } | { __typename?: 'User', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id?: number | null, name?: string | null, is_topic?: boolean | null, description?: string | null, cover_url?: string | null } | null> | null, attachments?: Array<{ __typename?: 'File', file_url?: string | null, file_extension?: string | null, title?: string | null, id?: number | null } | null> | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null };

export type VideoFragment = { __typename?: 'Video', id?: number | null, title?: string | null, cover_url?: string | null, description?: string | null, display_time?: any | null, vip_visibility?: number | null, related_article_ids?: Array<number | null> | null, related_report_ids?: Array<number | null> | null, episodes?: Array<{ __typename?: 'VideoEpisode', id?: number | null, name?: string | null, preview_url?: string | null, preview_duration?: number | null, size?: number | null, duration?: number | null, url?: string | null, display_time?: any | null, thumbnail_urls?: Array<string | null> | null } | null> | null, tags?: Array<{ __typename?: 'Tag', id?: number | null, name?: string | null, is_topic?: boolean | null, description?: string | null, cover_url?: string | null } | null> | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null, related_articles?: Array<{ __typename?: 'Article', id?: number | null, title?: string | null, body?: string | null, cover_url?: string | null, display_time?: any | null, free_expired_at?: any | null, free_at?: any | null, planned_published_at?: any | null, summary?: string | null, preview?: string | null, source_url?: string | null, vip_visibility?: number | null, author?: { __typename?: 'ExternalSource', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null } | { __typename?: 'ExternalSourceGroup', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null } | { __typename?: 'User', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id?: number | null, name?: string | null, is_topic?: boolean | null, description?: string | null, cover_url?: string | null } | null> | null, attachments?: Array<{ __typename?: 'File', file_url?: string | null, file_extension?: string | null, title?: string | null, id?: number | null } | null> | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null } | null> | null, related_reports?: Array<{ __typename?: 'Report', id?: number | null, title?: string | null, url?: string | null, extension?: string | null, vip_visibility?: number | null, display_time?: any | null, summary?: string | null, feed_info?: string | null, title_prefix?: string | null, content_url?: string | null, tags?: Array<{ __typename?: 'Tag', id?: number | null, name?: string | null, is_topic?: boolean | null, description?: string | null, cover_url?: string | null } | null> | null, counter?: { __typename?: 'Counter', viewed?: number | null, liked?: number | null, collected?: number | null, commented?: number | null } | null } | null> | null };

export type LinkFragment = { __typename?: 'Link', id?: number | null, title?: string | null, to?: string | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null, tags?: Array<{ __typename?: 'Tag', id?: number | null, name?: string | null, is_topic?: boolean | null, description?: string | null, cover_url?: string | null } | null> | null };

export type FaqFragment = { __typename?: 'Faq', id?: number | null, items?: Array<{ __typename?: 'FaqItem', title?: string | null, body?: string | null, link?: string | null } | null> | null };

export type CalendarEventFragment = { __typename?: 'CalendarEvent', country?: string | null, event?: string | null, id?: number | null, importance?: number | null, source?: CalendarSource | null, status?: ContentStatus | null, title?: string | null, display_time?: any | null, forecast?: string | null, revised?: string | null, previous?: string | null, actual?: string | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null };

export type CalendarTopicFragment = { __typename?: 'CalendarTopic', id?: number | null, name?: string | null, status?: ContentStatus | null, description?: string | null, period?: string | null, website?: string | null, organization?: string | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null };

export type ReportFragment = { __typename?: 'Report', id?: number | null, title?: string | null, url?: string | null, extension?: string | null, vip_visibility?: number | null, display_time?: any | null, summary?: string | null, feed_info?: string | null, title_prefix?: string | null, content_url?: string | null, tags?: Array<{ __typename?: 'Tag', id?: number | null, name?: string | null, is_topic?: boolean | null, description?: string | null, cover_url?: string | null } | null> | null, counter?: { __typename?: 'Counter', viewed?: number | null, liked?: number | null, collected?: number | null, commented?: number | null } | null };

export type RoadshowFragment = { __typename?: 'Roadshow', id?: number | null, title?: string | null, live_status?: string | null, live_method?: string | null, people?: string | null, poster?: string | null, start_time?: any | null, summary?: string | null, end_time?: any | null, vip_visibility?: number | null, body?: string | null, video_id?: number | null, tags?: Array<{ __typename?: 'Tag', id?: number | null, name?: string | null, is_topic?: boolean | null, description?: string | null, cover_url?: string | null } | null> | null };

export type ExternalSourceFragment = { __typename?: 'ExternalSource', avatar?: string | null, cover?: string | null, description?: string | null, id?: number | null, name?: string | null, nickname?: string | null, status?: ContentStatus | null, key?: string | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null };

export type ExternalSourceGroupFragment = { __typename?: 'ExternalSourceGroup', status?: ContentStatus | null, nickname?: string | null, name?: string | null, id?: number | null, description?: string | null, cover?: string | null, avatar?: string | null };

export type ExternalItemFragment = { __typename?: 'ExternalItem', title?: string | null, title_mix?: string | null, title_original?: string | null, title_zh?: string | null, summary?: string | null, summary_mix?: string | null, summary_original?: string | null, summary_zh?: string | null, status?: ContentStatus | null, source_id?: number | null, id?: number | null, display_time?: any | null, content?: string | null, content_mix?: string | null, content_original?: string | null, content_zh?: string | null, link?: string | null, author_name?: string | null, author_original?: string | null, author?: { __typename?: 'ExternalSource', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null } | { __typename?: 'ExternalSourceGroup', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null } | { __typename?: 'User', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null } | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null };

export type RoadMapFragment = { __typename?: 'RoadMap', content?: string | null, id?: number | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null };

export type TagFragment = { __typename?: 'Tag', id?: number | null, name?: string | null, is_topic?: boolean | null, description?: string | null, cover_url?: string | null };

type Author_ExternalSource_Fragment = { __typename?: 'ExternalSource', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null };

type Author_ExternalSourceGroup_Fragment = { __typename?: 'ExternalSourceGroup', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null };

type Author_User_Fragment = { __typename?: 'User', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null };

export type AuthorFragment = Author_ExternalSource_Fragment | Author_ExternalSourceGroup_Fragment | Author_User_Fragment;

export type CounterFragment = { __typename?: 'Counter', viewed?: number | null, liked?: number | null, collected?: number | null, commented?: number | null };

export type PageInfoFragment = { __typename?: 'PageInfo', end_cursor?: string | null, has_next_page?: boolean | null };

export type TagRelationFragment = { __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null };

export type WscnLiveFragment = { __typename?: 'WscnLive', content?: string | null, content_more?: string | null, id?: number | null, images?: Array<string | null> | null, score?: number | null, status?: ContentStatus | null, title?: string | null, is_deleted?: boolean | null, display_time?: any | null, original_updated_at?: any | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null };

export type ReportImageFragment = { __typename?: 'ReportImage', created_at?: any | null, description?: string | null, display_time?: any | null, height?: number | null, image_id?: string | null, media_id?: number | null, serial_number?: number | null, title?: string | null, updated_at?: any | null, url?: string | null, width?: number | null, id?: number | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null };

export type ImageFragment = { __typename?: 'Image', created_at?: any | null, title?: string | null, url?: string | null, id?: number | null, description?: string | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null };

export type PushTaskFragment = { __typename?: 'PushTask', body?: string | null, created_time?: string | null, dismiss_count?: number | null, error_message?: string | null, expire_time?: string | null, extra?: any | null, group_id?: string | null, id?: number | null, open_count?: number | null, platform?: PushPlatform | null, provider?: PushProvider | null, provider_task_id?: string | null, sent_count?: number | null, start_time?: string | null, status?: PushTaskStatus | null, subtitle?: string | null, title?: string | null, total_count?: number | null };

export type CreditSetExpenseMutationVariables = Exact<{
  kind: CreditExpenseKind;
  amount: Scalars['Int']['input'];
}>;


export type CreditSetExpenseMutation = { __typename?: 'mutation', creditSetExpense: boolean };

export type CreditInternalUnsubscribeMutationVariables = Exact<{
  plan: CreditSubscriptionPlan;
  userId: Scalars['Int']['input'];
}>;


export type CreditInternalUnsubscribeMutation = { __typename?: 'mutation', creditInternalUnsubscribe: { __typename?: 'UserCreditSubscription', expired_at?: any | null, started_at?: any | null, plan?: CreditSubscriptionPlan | null, user_id?: number | null, credit_info?: { __typename?: 'UserCreditInfo', user_id?: number | null, expired_at?: any | null, amount?: number | null } | null } };

export type NewsletterKillSwitchSetMutationVariables = Exact<{
  enabled: Scalars['Boolean']['input'];
}>;


export type NewsletterKillSwitchSetMutation = { __typename?: 'mutation', newsletterKillSwitchSet: { __typename?: 'NewsletterKillSwitchState', active: boolean, enabled_at?: number | null, enabled_by?: number | null, enabled_until?: number | null } };

export type PushBroadcastCreateMutationVariables = Exact<{
  body: Scalars['String']['input'];
  platform: PushPlatform;
  title: Scalars['String']['input'];
  subtitle?: InputMaybe<Scalars['String']['input']>;
  extra?: InputMaybe<Scalars['Map']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  expireTime?: InputMaybe<Scalars['String']['input']>;
}>;


export type PushBroadcastCreateMutation = { __typename?: 'mutation', pushBroadcastCreate: { __typename?: 'PushBroadcastResult', group_id?: string | null, tasks?: Array<{ __typename?: 'PushTask', body?: string | null, created_time?: string | null, dismiss_count?: number | null, error_message?: string | null, expire_time?: string | null, extra?: any | null, group_id?: string | null, id?: number | null, open_count?: number | null, platform?: PushPlatform | null, provider?: PushProvider | null, provider_task_id?: string | null, sent_count?: number | null, start_time?: string | null, status?: PushTaskStatus | null, subtitle?: string | null, title?: string | null, total_count?: number | null } | null> | null } };

export type PushTaskRevokeMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type PushTaskRevokeMutation = { __typename?: 'mutation', pushTaskRevoke: boolean };

export type PushTaskStatsRefreshMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type PushTaskStatsRefreshMutation = { __typename?: 'mutation', pushTaskStatsRefresh: { __typename?: 'PushTask', body?: string | null, created_time?: string | null, dismiss_count?: number | null, error_message?: string | null, expire_time?: string | null, extra?: any | null, group_id?: string | null, id?: number | null, open_count?: number | null, platform?: PushPlatform | null, provider?: PushProvider | null, provider_task_id?: string | null, sent_count?: number | null, start_time?: string | null, status?: PushTaskStatus | null, subtitle?: string | null, title?: string | null, total_count?: number | null } };

export type PushUnicastCreateMutationVariables = Exact<{
  title: Scalars['String']['input'];
  body: Scalars['String']['input'];
  userIds: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  extra?: InputMaybe<Scalars['Map']['input']>;
}>;


export type PushUnicastCreateMutation = { __typename?: 'mutation', pushUnicastCreate: { __typename?: 'PushBroadcastResult', group_id?: string | null, tasks?: Array<{ __typename?: 'PushTask', body?: string | null, created_time?: string | null, dismiss_count?: number | null, error_message?: string | null, expire_time?: string | null, extra?: any | null, group_id?: string | null, id?: number | null, open_count?: number | null, platform?: PushPlatform | null, provider?: PushProvider | null, provider_task_id?: string | null, sent_count?: number | null, start_time?: string | null, status?: PushTaskStatus | null, subtitle?: string | null, title?: string | null, total_count?: number | null } | null> | null } };

export type ReportImageUpdateMutationVariables = Exact<{
  item: ReportImageInput;
}>;


export type ReportImageUpdateMutation = { __typename?: 'mutation', reportImageUpdate: { __typename?: 'ReportImage', title?: string | null, url?: string | null, updated_at?: any | null, image_id?: string | null, description?: string | null } };

export type ContentDetailQueryVariables = Exact<{
  contentId?: InputMaybe<Scalars['Int']['input']>;
  kind?: InputMaybe<Scalars['Int']['input']>;
  lite?: InputMaybe<Scalars['Boolean']['input']>;
  kinds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  vipVisibility?: InputMaybe<Scalars['Int']['input']>;
  associateWithKinds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  associatedByKinds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ContentDetailQuery = { __typename?: 'query', content?: { __typename?: 'Content', raw_id?: number | null, status?: string | null, title?: string | null, description?: string | null, datetime?: any | null, vip_visibility?: number | null, kind?: number | null, cover_url?: string | null, readable?: boolean | null, detail?: { __typename?: 'AShareIRManagement' } | { __typename?: 'Article', id?: number | null, title?: string | null, body?: string | null, cover_url?: string | null, display_time?: any | null, free_expired_at?: any | null, free_at?: any | null, planned_published_at?: any | null, summary?: string | null, preview?: string | null, source_url?: string | null, vip_visibility?: number | null, author?: { __typename?: 'ExternalSource', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null } | { __typename?: 'ExternalSourceGroup', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null } | { __typename?: 'User', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id?: number | null, name?: string | null, is_topic?: boolean | null, description?: string | null, cover_url?: string | null } | null> | null, attachments?: Array<{ __typename?: 'File', file_url?: string | null, file_extension?: string | null, title?: string | null, id?: number | null } | null> | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null } | { __typename?: 'Audio' } | { __typename?: 'AudioEpisode' } | { __typename?: 'CalendarEvent' } | { __typename?: 'CalendarTopic' } | { __typename?: 'Comment' } | { __typename?: 'ExternalItem', title?: string | null, title_mix?: string | null, title_original?: string | null, title_zh?: string | null, summary?: string | null, summary_mix?: string | null, summary_original?: string | null, summary_zh?: string | null, status?: ContentStatus | null, source_id?: number | null, id?: number | null, display_time?: any | null, content?: string | null, content_mix?: string | null, content_original?: string | null, content_zh?: string | null, link?: string | null, author_name?: string | null, author_original?: string | null, author?: { __typename?: 'ExternalSource', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null } | { __typename?: 'ExternalSourceGroup', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null } | { __typename?: 'User', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null } | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null } | { __typename?: 'ExternalSource', avatar?: string | null, cover?: string | null, description?: string | null, id?: number | null, name?: string | null, nickname?: string | null, status?: ContentStatus | null, key?: string | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null } | { __typename?: 'ExternalSourceGroup', status?: ContentStatus | null, nickname?: string | null, name?: string | null, id?: number | null, description?: string | null, cover?: string | null, avatar?: string | null } | { __typename?: 'Faq' } | { __typename?: 'Image' } | { __typename?: 'Link' } | { __typename?: 'Post' } | { __typename?: 'Report', id?: number | null, title?: string | null, url?: string | null, extension?: string | null, markdown?: string | null, vip_visibility?: number | null, display_time?: any | null, summary?: string | null, feed_info?: string | null, body_audio_url?: string | null, content_url?: string | null, reference_blocks?: string | null, tags?: Array<{ __typename?: 'Tag', id?: number | null, name?: string | null, is_topic?: boolean | null, description?: string | null, cover_url?: string | null } | null> | null, counter?: { __typename?: 'Counter', viewed?: number | null, liked?: number | null, collected?: number | null, commented?: number | null } | null, images?: Array<{ __typename?: 'ReportImage', created_at?: any | null, description?: string | null, display_time?: any | null, height?: number | null, image_id?: string | null, media_id?: number | null, serial_number?: number | null, title?: string | null, updated_at?: any | null, url?: string | null, width?: number | null, id?: number | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null } | null> | null } | { __typename?: 'ReportImage' } | { __typename?: 'RoadMap' } | { __typename?: 'Roadshow', id?: number | null, title?: string | null, live_status?: string | null, live_method?: string | null, people?: string | null, poster?: string | null, start_time?: any | null, summary?: string | null, end_time?: any | null, vip_visibility?: number | null, body?: string | null, video_id?: number | null, tags?: Array<{ __typename?: 'Tag', id?: number | null, name?: string | null, is_topic?: boolean | null, description?: string | null, cover_url?: string | null } | null> | null } | { __typename?: 'Tag' } | { __typename?: 'Video', id?: number | null, title?: string | null, cover_url?: string | null, description?: string | null, display_time?: any | null, vip_visibility?: number | null, related_article_ids?: Array<number | null> | null, related_report_ids?: Array<number | null> | null, episodes?: Array<{ __typename?: 'VideoEpisode', id?: number | null, name?: string | null, preview_url?: string | null, preview_duration?: number | null, size?: number | null, duration?: number | null, url?: string | null, display_time?: any | null, thumbnail_urls?: Array<string | null> | null } | null> | null, tags?: Array<{ __typename?: 'Tag', id?: number | null, name?: string | null, is_topic?: boolean | null, description?: string | null, cover_url?: string | null } | null> | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null, related_articles?: Array<{ __typename?: 'Article', id?: number | null, title?: string | null, body?: string | null, cover_url?: string | null, display_time?: any | null, free_expired_at?: any | null, free_at?: any | null, planned_published_at?: any | null, summary?: string | null, preview?: string | null, source_url?: string | null, vip_visibility?: number | null, author?: { __typename?: 'ExternalSource', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null } | { __typename?: 'ExternalSourceGroup', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null } | { __typename?: 'User', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id?: number | null, name?: string | null, is_topic?: boolean | null, description?: string | null, cover_url?: string | null } | null> | null, attachments?: Array<{ __typename?: 'File', file_url?: string | null, file_extension?: string | null, title?: string | null, id?: number | null } | null> | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null } | null> | null, related_reports?: Array<{ __typename?: 'Report', id?: number | null, title?: string | null, url?: string | null, extension?: string | null, vip_visibility?: number | null, display_time?: any | null, summary?: string | null, feed_info?: string | null, title_prefix?: string | null, content_url?: string | null, tags?: Array<{ __typename?: 'Tag', id?: number | null, name?: string | null, is_topic?: boolean | null, description?: string | null, cover_url?: string | null } | null> | null, counter?: { __typename?: 'Counter', viewed?: number | null, liked?: number | null, collected?: number | null, commented?: number | null } | null } | null> | null } | { __typename?: 'WscnArticle' } | { __typename?: 'WscnLive' } | null, associate_with?: { __typename?: 'ContentPage', items?: Array<{ __typename?: 'Content', raw_id?: number | null, status?: string | null, title?: string | null, description?: string | null, datetime?: any | null, vip_visibility?: number | null, kind?: number | null, cover_url?: string | null, readable?: boolean | null, detail?: { __typename?: 'AShareIRManagement' } | { __typename?: 'Article', id?: number | null, title?: string | null, body?: string | null, cover_url?: string | null, display_time?: any | null, free_expired_at?: any | null, free_at?: any | null, planned_published_at?: any | null, summary?: string | null, preview?: string | null, source_url?: string | null, vip_visibility?: number | null, author?: { __typename?: 'ExternalSource', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null } | { __typename?: 'ExternalSourceGroup', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null } | { __typename?: 'User', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id?: number | null, name?: string | null, is_topic?: boolean | null, description?: string | null, cover_url?: string | null } | null> | null, attachments?: Array<{ __typename?: 'File', file_url?: string | null, file_extension?: string | null, title?: string | null, id?: number | null } | null> | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null } | { __typename?: 'Audio' } | { __typename?: 'AudioEpisode' } | { __typename?: 'CalendarEvent' } | { __typename?: 'CalendarTopic' } | { __typename?: 'Comment' } | { __typename?: 'ExternalItem', title?: string | null, title_mix?: string | null, title_original?: string | null, title_zh?: string | null, summary?: string | null, summary_mix?: string | null, summary_original?: string | null, summary_zh?: string | null, status?: ContentStatus | null, source_id?: number | null, id?: number | null, display_time?: any | null, content?: string | null, content_mix?: string | null, content_original?: string | null, content_zh?: string | null, link?: string | null, author_name?: string | null, author_original?: string | null, author?: { __typename?: 'ExternalSource', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null } | { __typename?: 'ExternalSourceGroup', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null } | { __typename?: 'User', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null } | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null } | { __typename?: 'ExternalSource', avatar?: string | null, cover?: string | null, description?: string | null, id?: number | null, name?: string | null, nickname?: string | null, status?: ContentStatus | null, key?: string | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null } | { __typename?: 'ExternalSourceGroup', status?: ContentStatus | null, nickname?: string | null, name?: string | null, id?: number | null, description?: string | null, cover?: string | null, avatar?: string | null } | { __typename?: 'Faq' } | { __typename?: 'Image' } | { __typename?: 'Link' } | { __typename?: 'Post' } | { __typename?: 'Report', id?: number | null, title?: string | null, url?: string | null, extension?: string | null, vip_visibility?: number | null, display_time?: any | null, summary?: string | null, feed_info?: string | null, title_prefix?: string | null, content_url?: string | null, tags?: Array<{ __typename?: 'Tag', id?: number | null, name?: string | null, is_topic?: boolean | null, description?: string | null, cover_url?: string | null } | null> | null, counter?: { __typename?: 'Counter', viewed?: number | null, liked?: number | null, collected?: number | null, commented?: number | null } | null } | { __typename?: 'ReportImage' } | { __typename?: 'RoadMap' } | { __typename?: 'Roadshow', id?: number | null, title?: string | null, live_status?: string | null, live_method?: string | null, people?: string | null, poster?: string | null, start_time?: any | null, summary?: string | null, end_time?: any | null, vip_visibility?: number | null, body?: string | null, video_id?: number | null, tags?: Array<{ __typename?: 'Tag', id?: number | null, name?: string | null, is_topic?: boolean | null, description?: string | null, cover_url?: string | null } | null> | null } | { __typename?: 'Tag', id?: number | null, name?: string | null, is_topic?: boolean | null, description?: string | null, cover_url?: string | null } | { __typename?: 'Video', id?: number | null, title?: string | null, cover_url?: string | null, description?: string | null, display_time?: any | null, vip_visibility?: number | null, related_article_ids?: Array<number | null> | null, related_report_ids?: Array<number | null> | null, episodes?: Array<{ __typename?: 'VideoEpisode', id?: number | null, name?: string | null, preview_url?: string | null, preview_duration?: number | null, size?: number | null, duration?: number | null, url?: string | null, display_time?: any | null, thumbnail_urls?: Array<string | null> | null } | null> | null, tags?: Array<{ __typename?: 'Tag', id?: number | null, name?: string | null, is_topic?: boolean | null, description?: string | null, cover_url?: string | null } | null> | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null, related_articles?: Array<{ __typename?: 'Article', id?: number | null, title?: string | null, body?: string | null, cover_url?: string | null, display_time?: any | null, free_expired_at?: any | null, free_at?: any | null, planned_published_at?: any | null, summary?: string | null, preview?: string | null, source_url?: string | null, vip_visibility?: number | null, author?: { __typename?: 'ExternalSource', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null } | { __typename?: 'ExternalSourceGroup', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null } | { __typename?: 'User', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id?: number | null, name?: string | null, is_topic?: boolean | null, description?: string | null, cover_url?: string | null } | null> | null, attachments?: Array<{ __typename?: 'File', file_url?: string | null, file_extension?: string | null, title?: string | null, id?: number | null } | null> | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null } | null> | null, related_reports?: Array<{ __typename?: 'Report', id?: number | null, title?: string | null, url?: string | null, extension?: string | null, vip_visibility?: number | null, display_time?: any | null, summary?: string | null, feed_info?: string | null, title_prefix?: string | null, content_url?: string | null, tags?: Array<{ __typename?: 'Tag', id?: number | null, name?: string | null, is_topic?: boolean | null, description?: string | null, cover_url?: string | null } | null> | null, counter?: { __typename?: 'Counter', viewed?: number | null, liked?: number | null, collected?: number | null, commented?: number | null } | null } | null> | null } | { __typename?: 'WscnArticle' } | { __typename?: 'WscnLive' } | null, author?: { __typename?: 'ExternalSource', id?: number | null, nickname?: string | null, avatar?: string | null } | { __typename?: 'ExternalSourceGroup', id?: number | null, nickname?: string | null, avatar?: string | null } | { __typename?: 'User', id?: number | null, nickname?: string | null, avatar?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id?: number | null, is_topic?: boolean | null, name?: string | null, cover_url?: string | null } | null> | null, counter?: { __typename?: 'Counter', viewed?: number | null, liked?: number | null, collected?: number | null, commented?: number | null } | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null } | null> | null } | null, associated_by?: { __typename?: 'ContentPage', total_count?: number | null, items?: Array<{ __typename?: 'Content', raw_id?: number | null, status?: string | null, title?: string | null, description?: string | null, datetime?: any | null, vip_visibility?: number | null, kind?: number | null, cover_url?: string | null, readable?: boolean | null, author?: { __typename?: 'ExternalSource', id?: number | null, nickname?: string | null, avatar?: string | null } | { __typename?: 'ExternalSourceGroup', id?: number | null, nickname?: string | null, avatar?: string | null } | { __typename?: 'User', id?: number | null, nickname?: string | null, avatar?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id?: number | null, is_topic?: boolean | null, name?: string | null, cover_url?: string | null } | null> | null, counter?: { __typename?: 'Counter', viewed?: number | null, liked?: number | null, collected?: number | null, commented?: number | null } | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null } | null> | null } | null, related_contents?: { __typename?: 'ContentPage', total_count?: number | null, page_info?: { __typename?: 'PageInfo', end_cursor?: string | null, has_next_page?: boolean | null } | null, items?: Array<{ __typename?: 'Content', raw_id?: number | null, status?: string | null, title?: string | null, description?: string | null, datetime?: any | null, vip_visibility?: number | null, kind?: number | null, cover_url?: string | null, readable?: boolean | null, detail?: { __typename?: 'AShareIRManagement' } | { __typename?: 'Article', id?: number | null, title?: string | null, body?: string | null, cover_url?: string | null, display_time?: any | null, free_expired_at?: any | null, free_at?: any | null, planned_published_at?: any | null, summary?: string | null, preview?: string | null, source_url?: string | null, vip_visibility?: number | null, author?: { __typename?: 'ExternalSource', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null } | { __typename?: 'ExternalSourceGroup', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null } | { __typename?: 'User', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id?: number | null, name?: string | null, is_topic?: boolean | null, description?: string | null, cover_url?: string | null } | null> | null, attachments?: Array<{ __typename?: 'File', file_url?: string | null, file_extension?: string | null, title?: string | null, id?: number | null } | null> | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null } | { __typename?: 'Audio' } | { __typename?: 'AudioEpisode' } | { __typename?: 'CalendarEvent' } | { __typename?: 'CalendarTopic' } | { __typename?: 'Comment' } | { __typename?: 'ExternalItem', title?: string | null, title_mix?: string | null, title_original?: string | null, title_zh?: string | null, summary?: string | null, summary_mix?: string | null, summary_original?: string | null, summary_zh?: string | null, status?: ContentStatus | null, source_id?: number | null, id?: number | null, display_time?: any | null, content?: string | null, content_mix?: string | null, content_original?: string | null, content_zh?: string | null, link?: string | null, author_name?: string | null, author_original?: string | null, author?: { __typename?: 'ExternalSource', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null } | { __typename?: 'ExternalSourceGroup', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null } | { __typename?: 'User', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null } | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null } | { __typename?: 'ExternalSource', avatar?: string | null, cover?: string | null, description?: string | null, id?: number | null, name?: string | null, nickname?: string | null, status?: ContentStatus | null, key?: string | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null } | { __typename?: 'ExternalSourceGroup', status?: ContentStatus | null, nickname?: string | null, name?: string | null, id?: number | null, description?: string | null, cover?: string | null, avatar?: string | null } | { __typename?: 'Faq' } | { __typename?: 'Image' } | { __typename?: 'Link' } | { __typename?: 'Post' } | { __typename?: 'Report', id?: number | null, title?: string | null, url?: string | null, extension?: string | null, vip_visibility?: number | null, display_time?: any | null, summary?: string | null, feed_info?: string | null, title_prefix?: string | null, content_url?: string | null, tags?: Array<{ __typename?: 'Tag', id?: number | null, name?: string | null, is_topic?: boolean | null, description?: string | null, cover_url?: string | null } | null> | null, counter?: { __typename?: 'Counter', viewed?: number | null, liked?: number | null, collected?: number | null, commented?: number | null } | null } | { __typename?: 'ReportImage' } | { __typename?: 'RoadMap' } | { __typename?: 'Roadshow', id?: number | null, title?: string | null, live_status?: string | null, live_method?: string | null, people?: string | null, poster?: string | null, start_time?: any | null, summary?: string | null, end_time?: any | null, vip_visibility?: number | null, body?: string | null, video_id?: number | null, tags?: Array<{ __typename?: 'Tag', id?: number | null, name?: string | null, is_topic?: boolean | null, description?: string | null, cover_url?: string | null } | null> | null } | { __typename?: 'Tag' } | { __typename?: 'Video', id?: number | null, title?: string | null, cover_url?: string | null, description?: string | null, display_time?: any | null, vip_visibility?: number | null, related_article_ids?: Array<number | null> | null, related_report_ids?: Array<number | null> | null, episodes?: Array<{ __typename?: 'VideoEpisode', id?: number | null, name?: string | null, preview_url?: string | null, preview_duration?: number | null, size?: number | null, duration?: number | null, url?: string | null, display_time?: any | null, thumbnail_urls?: Array<string | null> | null } | null> | null, tags?: Array<{ __typename?: 'Tag', id?: number | null, name?: string | null, is_topic?: boolean | null, description?: string | null, cover_url?: string | null } | null> | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null, related_articles?: Array<{ __typename?: 'Article', id?: number | null, title?: string | null, body?: string | null, cover_url?: string | null, display_time?: any | null, free_expired_at?: any | null, free_at?: any | null, planned_published_at?: any | null, summary?: string | null, preview?: string | null, source_url?: string | null, vip_visibility?: number | null, author?: { __typename?: 'ExternalSource', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null } | { __typename?: 'ExternalSourceGroup', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null } | { __typename?: 'User', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id?: number | null, name?: string | null, is_topic?: boolean | null, description?: string | null, cover_url?: string | null } | null> | null, attachments?: Array<{ __typename?: 'File', file_url?: string | null, file_extension?: string | null, title?: string | null, id?: number | null } | null> | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null } | null> | null, related_reports?: Array<{ __typename?: 'Report', id?: number | null, title?: string | null, url?: string | null, extension?: string | null, vip_visibility?: number | null, display_time?: any | null, summary?: string | null, feed_info?: string | null, title_prefix?: string | null, content_url?: string | null, tags?: Array<{ __typename?: 'Tag', id?: number | null, name?: string | null, is_topic?: boolean | null, description?: string | null, cover_url?: string | null } | null> | null, counter?: { __typename?: 'Counter', viewed?: number | null, liked?: number | null, collected?: number | null, commented?: number | null } | null } | null> | null } | { __typename?: 'WscnArticle' } | { __typename?: 'WscnLive' } | null, author?: { __typename?: 'ExternalSource', id?: number | null, nickname?: string | null, avatar?: string | null } | { __typename?: 'ExternalSourceGroup', id?: number | null, nickname?: string | null, avatar?: string | null } | { __typename?: 'User', id?: number | null, nickname?: string | null, avatar?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id?: number | null, is_topic?: boolean | null, name?: string | null, cover_url?: string | null } | null> | null, counter?: { __typename?: 'Counter', viewed?: number | null, liked?: number | null, collected?: number | null, commented?: number | null } | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null } | null> | null } | null, author?: { __typename?: 'ExternalSource', id?: number | null, nickname?: string | null, avatar?: string | null } | { __typename?: 'ExternalSourceGroup', id?: number | null, nickname?: string | null, avatar?: string | null } | { __typename?: 'User', id?: number | null, nickname?: string | null, avatar?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id?: number | null, is_topic?: boolean | null, name?: string | null, cover_url?: string | null } | null> | null, counter?: { __typename?: 'Counter', viewed?: number | null, liked?: number | null, collected?: number | null, commented?: number | null } | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null } | null };

export type ContentListQueryVariables = Exact<{
  sortBy?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['Timestamp']['input']>;
  kinds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['Timestamp']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  vipVisibility?: InputMaybe<Scalars['Int']['input']>;
  lite?: InputMaybe<Scalars['Boolean']['input']>;
  relations?: InputMaybe<Array<InputMaybe<RelationFilter>> | InputMaybe<RelationFilter>>;
  status?: InputMaybe<Scalars['Int']['input']>;
  track?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  relatedContentsFirst?: InputMaybe<Scalars['Int']['input']>;
  relatedContentsKinds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  associateWithKinds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  authors?: InputMaybe<Array<InputMaybe<AuthorFilter>> | InputMaybe<AuthorFilter>>;
  ralationsOp?: InputMaybe<FilterOperator>;
}>;


export type ContentListQuery = { __typename?: 'query', contents?: { __typename?: 'ContentPage', total_count?: number | null, page_info?: { __typename?: 'PageInfo', end_cursor?: string | null, has_next_page?: boolean | null } | null, items?: Array<{ __typename?: 'Content', raw_id?: number | null, status?: string | null, title?: string | null, description?: string | null, datetime?: any | null, vip_visibility?: number | null, kind?: number | null, cover_url?: string | null, readable?: boolean | null, counter?: { __typename?: 'Counter', viewed?: number | null, liked?: number | null, collected?: number | null, commented?: number | null } | null, detail?: { __typename?: 'AShareIRManagement' } | { __typename?: 'Article', planned_published_at?: any | null, id?: number | null, title?: string | null, body?: string | null, cover_url?: string | null, display_time?: any | null, free_expired_at?: any | null, free_at?: any | null, summary?: string | null, preview?: string | null, source_url?: string | null, vip_visibility?: number | null, author?: { __typename?: 'ExternalSource', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null } | { __typename?: 'ExternalSourceGroup', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null } | { __typename?: 'User', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id?: number | null, name?: string | null, is_topic?: boolean | null, description?: string | null, cover_url?: string | null } | null> | null, attachments?: Array<{ __typename?: 'File', file_url?: string | null, file_extension?: string | null, title?: string | null, id?: number | null } | null> | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null } | { __typename?: 'Audio' } | { __typename?: 'AudioEpisode' } | { __typename?: 'CalendarEvent', country?: string | null, event?: string | null, id?: number | null, importance?: number | null, source?: CalendarSource | null, status?: ContentStatus | null, title?: string | null, display_time?: any | null, forecast?: string | null, revised?: string | null, previous?: string | null, actual?: string | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null } | { __typename?: 'CalendarTopic', id?: number | null, name?: string | null, status?: ContentStatus | null, description?: string | null, period?: string | null, website?: string | null, organization?: string | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null } | { __typename?: 'Comment' } | { __typename?: 'ExternalItem', title?: string | null, title_mix?: string | null, title_original?: string | null, title_zh?: string | null, summary?: string | null, summary_mix?: string | null, summary_original?: string | null, summary_zh?: string | null, status?: ContentStatus | null, source_id?: number | null, id?: number | null, display_time?: any | null, content?: string | null, content_mix?: string | null, content_original?: string | null, content_zh?: string | null, link?: string | null, author_name?: string | null, author_original?: string | null, author?: { __typename?: 'ExternalSource', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null } | { __typename?: 'ExternalSourceGroup', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null } | { __typename?: 'User', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null } | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null } | { __typename?: 'ExternalSource', avatar?: string | null, cover?: string | null, description?: string | null, id?: number | null, name?: string | null, nickname?: string | null, status?: ContentStatus | null, key?: string | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null } | { __typename?: 'ExternalSourceGroup' } | { __typename?: 'Faq', id?: number | null, items?: Array<{ __typename?: 'FaqItem', title?: string | null, body?: string | null, link?: string | null } | null> | null } | { __typename?: 'Image', created_at?: any | null, title?: string | null, url?: string | null, id?: number | null, description?: string | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null } | { __typename?: 'Link', id?: number | null, title?: string | null, to?: string | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null, tags?: Array<{ __typename?: 'Tag', id?: number | null, name?: string | null, is_topic?: boolean | null, description?: string | null, cover_url?: string | null } | null> | null } | { __typename?: 'Post' } | { __typename?: 'Report', id?: number | null, title?: string | null, url?: string | null, extension?: string | null, vip_visibility?: number | null, display_time?: any | null, summary?: string | null, feed_info?: string | null, title_prefix?: string | null, content_url?: string | null, tags?: Array<{ __typename?: 'Tag', id?: number | null, name?: string | null, is_topic?: boolean | null, description?: string | null, cover_url?: string | null } | null> | null, counter?: { __typename?: 'Counter', viewed?: number | null, liked?: number | null, collected?: number | null, commented?: number | null } | null } | { __typename?: 'ReportImage', created_at?: any | null, description?: string | null, display_time?: any | null, height?: number | null, image_id?: string | null, media_id?: number | null, serial_number?: number | null, title?: string | null, updated_at?: any | null, url?: string | null, width?: number | null, id?: number | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null } | { __typename?: 'RoadMap', content?: string | null, id?: number | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null } | { __typename?: 'Roadshow' } | { __typename?: 'Tag' } | { __typename?: 'Video', summary?: string | null, episodes?: Array<{ __typename?: 'VideoEpisode', duration?: number | null } | null> | null } | { __typename?: 'WscnArticle' } | { __typename?: 'WscnLive', content?: string | null, content_more?: string | null, id?: number | null, images?: Array<string | null> | null, score?: number | null, status?: ContentStatus | null, title?: string | null, is_deleted?: boolean | null, display_time?: any | null, original_updated_at?: any | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null } | null, related_contents?: { __typename?: 'ContentPage', items?: Array<{ __typename?: 'Content', raw_id?: number | null, title?: string | null, kind?: number | null } | null> | null } | null, associate_with?: { __typename?: 'ContentPage', items?: Array<{ __typename?: 'Content', raw_id?: number | null, status?: string | null, title?: string | null, description?: string | null, datetime?: any | null, vip_visibility?: number | null, kind?: number | null, cover_url?: string | null, readable?: boolean | null, author?: { __typename?: 'ExternalSource', id?: number | null, nickname?: string | null, avatar?: string | null } | { __typename?: 'ExternalSourceGroup', id?: number | null, nickname?: string | null, avatar?: string | null } | { __typename?: 'User', id?: number | null, nickname?: string | null, avatar?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id?: number | null, is_topic?: boolean | null, name?: string | null, cover_url?: string | null } | null> | null, counter?: { __typename?: 'Counter', viewed?: number | null, liked?: number | null, collected?: number | null, commented?: number | null } | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null } | null> | null } | null, author?: { __typename?: 'ExternalSource', id?: number | null, nickname?: string | null, avatar?: string | null } | { __typename?: 'ExternalSourceGroup', id?: number | null, nickname?: string | null, avatar?: string | null } | { __typename?: 'User', id?: number | null, nickname?: string | null, avatar?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id?: number | null, is_topic?: boolean | null, name?: string | null, cover_url?: string | null } | null> | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null } | null> | null } | null };

export type Credit_ExpenseQueryVariables = Exact<{ [key: string]: never; }>;


export type Credit_ExpenseQuery = { __typename?: 'query', credit_expense: Array<{ __typename?: 'CreditPrice', kind?: CreditExpenseKind | null, price?: number | null } | null> };

export type FinanceEventContentsQueryVariables = Exact<{
  kinds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  startTime?: InputMaybe<Scalars['Timestamp']['input']>;
  endTime?: InputMaybe<Scalars['Timestamp']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type FinanceEventContentsQuery = { __typename?: 'query', contents?: { __typename?: 'ContentPage', total_count?: number | null, items?: Array<{ __typename?: 'Content', title?: string | null, raw_id?: number | null, datetime?: any | null, status?: string | null } | null> | null, page_info?: { __typename?: 'PageInfo', end_cursor?: string | null, has_next_page?: boolean | null } | null } | null };

export type QueryQueryVariables = Exact<{ [key: string]: never; }>;


export type QueryQuery = { __typename?: 'query', newsletterKillSwitch: { __typename?: 'NewsletterKillSwitchState', active: boolean, enabled_at?: number | null, enabled_by?: number | null, enabled_until?: number | null } };

export type Push_TaskQueryVariables = Exact<{
  pushTaskId: Scalars['Int']['input'];
}>;


export type Push_TaskQuery = { __typename?: 'query', push_task: { __typename?: 'PushTask', body?: string | null, created_time?: string | null, dismiss_count?: number | null, error_message?: string | null, expire_time?: string | null, extra?: any | null, group_id?: string | null, id?: number | null, open_count?: number | null, platform?: PushPlatform | null, provider?: PushProvider | null, provider_task_id?: string | null, sent_count?: number | null, start_time?: string | null, status?: PushTaskStatus | null, subtitle?: string | null, title?: string | null, total_count?: number | null } };

export type Push_TasksQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  platform?: InputMaybe<PushPlatform>;
  provider?: InputMaybe<PushProvider>;
  status?: InputMaybe<PushTaskStatus>;
  keyword?: InputMaybe<Scalars['String']['input']>;
}>;


export type Push_TasksQuery = { __typename?: 'query', push_tasks: { __typename?: 'PushTasksConnection', total_count?: number | null, nodes?: Array<{ __typename?: 'PushTask', body?: string | null, created_time?: string | null, dismiss_count?: number | null, error_message?: string | null, expire_time?: string | null, extra?: any | null, group_id?: string | null, id?: number | null, open_count?: number | null, platform?: PushPlatform | null, provider?: PushProvider | null, provider_task_id?: string | null, sent_count?: number | null, start_time?: string | null, status?: PushTaskStatus | null, subtitle?: string | null, title?: string | null, total_count?: number | null } | null> | null, page_info?: { __typename?: 'PageInfo', end_cursor?: string | null, has_next_page?: boolean | null } | null } };

export type RoadshowQueryVariables = Exact<{
  roadshowId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RoadshowQuery = { __typename?: 'query', roadshow?: { __typename?: 'Roadshow', body?: string | null, created_at?: any | null, end_time?: any | null, id?: number | null, live_method?: string | null, live_status?: string | null, people?: string | null, poster?: string | null, start_time?: any | null, status?: ContentStatus | null, summary?: string | null, title?: string | null, updated_at?: any | null, video_id?: number | null, vip_visibility?: number | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, k?: RelationKind | null, group?: number | null } | null> | null, tags?: Array<{ __typename?: 'Tag', id?: number | null, is_topic?: boolean | null, name?: string | null, description?: string | null, cover_url?: string | null } | null> | null, tencent_meeting?: { __typename?: 'TcMeetingConfig', password?: string | null, wl_include?: Array<{ __typename?: 'TcMeetingWhiteListItem', key: string, kind: RoadshowWhiteListItemKind, name?: string | null } | null> | null, wl_exclude?: Array<{ __typename?: 'TcMeetingWhiteListItem', key: string, kind: RoadshowWhiteListItemKind, name?: string | null } | null> | null } | null, video?: { __typename?: 'Video', id?: number | null, title?: string | null, cover_url?: string | null } | null } | null };

export type TagsQueryVariables = Exact<{
  isTopic?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  kw?: InputMaybe<Scalars['String']['input']>;
  contentsFirst?: InputMaybe<Scalars['Int']['input']>;
  kinds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  group?: InputMaybe<Scalars['Int']['input']>;
  getContents?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TagsQuery = { __typename?: 'query', tags?: Array<{ __typename?: 'Tag', id?: number | null, name?: string | null, is_topic?: boolean | null, description?: string | null, cover_url?: string | null, contents?: { __typename?: 'ContentPage', total_count?: number | null, items?: Array<{ __typename?: 'Content', raw_id?: number | null, title?: string | null } | null> | null } | null } | null> | null };

export type Roadshow_User_GroupsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
}>;


export type Roadshow_User_GroupsQuery = { __typename?: 'query', roadshow_user_groups: { __typename?: 'RoadshowUserGroupConnection', total_count?: number | null, page_info?: { __typename?: 'PageInfo', has_next_page?: boolean | null, end_cursor?: string | null } | null, nodes?: Array<{ __typename?: 'RoadshowUserGroup', id: number, name: string, users?: Array<{ __typename?: 'RoadshowUser', area: string, nickname?: string | null, phone_number: string } | null> | null } | null> | null } };

export type CalendarEventUpdateMutationVariables = Exact<{
  event: CalendarEventInput;
}>;


export type CalendarEventUpdateMutation = { __typename?: 'mutation', calendarEventUpdate: { __typename?: 'CalendarEvent', country?: string | null, event?: string | null, id?: number | null, importance?: number | null, source?: CalendarSource | null, status?: ContentStatus | null, title?: string | null, display_time?: any | null, forecast?: string | null, revised?: string | null, previous?: string | null, actual?: string | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null } };

export type CalendarTopicUpdateMutationVariables = Exact<{
  topic: CalendarTopicInput;
}>;


export type CalendarTopicUpdateMutation = { __typename?: 'mutation', calendarTopicUpdate: { __typename?: 'CalendarTopic', id?: number | null, name?: string | null, status?: ContentStatus | null, description?: string | null, period?: string | null, website?: string | null, organization?: string | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null } };

export type ExternalItemUpdateMutationVariables = Exact<{
  item: ExternalItemInput;
}>;


export type ExternalItemUpdateMutation = { __typename?: 'mutation', externalItemUpdate: { __typename?: 'ExternalItem', title?: string | null, title_mix?: string | null, title_original?: string | null, title_zh?: string | null, summary?: string | null, summary_mix?: string | null, summary_original?: string | null, summary_zh?: string | null, status?: ContentStatus | null, source_id?: number | null, id?: number | null, display_time?: any | null, content?: string | null, content_mix?: string | null, content_original?: string | null, content_zh?: string | null, link?: string | null, author_name?: string | null, author_original?: string | null, author?: { __typename?: 'ExternalSource', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null } | { __typename?: 'ExternalSourceGroup', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null } | { __typename?: 'User', id?: number | null, nickname?: string | null, description?: string | null, avatar?: string | null } | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null } };

export type ExternalSourceUpdateMutationVariables = Exact<{
  source: SourceInput;
}>;


export type ExternalSourceUpdateMutation = { __typename?: 'mutation', externalSourceUpdate: { __typename?: 'ExternalSource', avatar?: string | null, cover?: string | null, description?: string | null, id?: number | null, name?: string | null, nickname?: string | null, status?: ContentStatus | null, key?: string | null, tag_relations?: Array<{ __typename?: 'TagRelation', id?: number | null, group?: number | null, k?: RelationKind | null } | null> | null } };

export type RoadshowUpdateMutationVariables = Exact<{
  roadshow: RoadshowInput;
}>;


export type RoadshowUpdateMutation = { __typename?: 'mutation', roadshowUpdate: { __typename?: 'Roadshow', body?: string | null, created_at?: any | null, end_time?: any | null, id?: number | null, live_method?: string | null, live_status?: string | null, people?: string | null, poster?: string | null, start_time?: any | null, status?: ContentStatus | null, summary?: string | null, title?: string | null, updated_at?: any | null, vip_visibility?: number | null, video_id?: number | null, tag_relations?: Array<{ __typename?: 'TagRelation', group?: number | null, id?: number | null } | null> | null, tags?: Array<{ __typename?: 'Tag', id?: number | null, is_topic?: boolean | null, name?: string | null, cover_url?: string | null, description?: string | null } | null> | null, tencent_meeting?: { __typename?: 'TcMeetingConfig', password?: string | null, wl_include?: Array<{ __typename?: 'TcMeetingWhiteListItem', key: string, kind: RoadshowWhiteListItemKind, name?: string | null } | null> | null, wl_exclude?: Array<{ __typename?: 'TcMeetingWhiteListItem', key: string, kind: RoadshowWhiteListItemKind, name?: string | null } | null> | null } | null, video?: { __typename?: 'Video', id?: number | null, title?: string | null, cover_url?: string | null, status?: string | null } | null } };

export type RoadshowUserGroupUpdateMutationVariables = Exact<{
  group: RoadshowUserGroupInput;
}>;


export type RoadshowUserGroupUpdateMutation = { __typename?: 'mutation', roadshowUserGroupUpdate: { __typename?: 'RoadshowUserGroup', id: number, name: string, users?: Array<{ __typename?: 'RoadshowUser', area: string, nickname?: string | null, phone_number: string } | null> | null } };

export type ExternalSourceGroupUpdateMutationVariables = Exact<{
  group: SourceGroupInput;
}>;


export type ExternalSourceGroupUpdateMutation = { __typename?: 'mutation', externalSourceGroupUpdate: { __typename?: 'ExternalSourceGroup', status?: ContentStatus | null, nickname?: string | null, name?: string | null, id?: number | null, description?: string | null, cover?: string | null, avatar?: string | null } };

export type WscnLiveUpdateMutationVariables = Exact<{
  item: WscnLiveInput;
}>;


export type WscnLiveUpdateMutation = { __typename?: 'mutation', wscnLiveUpdate: { __typename?: 'WscnLive', id?: number | null, tag_relations?: Array<{ __typename?: 'TagRelation', k?: RelationKind | null, id?: number | null, group?: number | null } | null> | null } };

export const CounterFragmentDoc = gql`
    fragment Counter on Counter {
  viewed
  liked
  collected
  commented
}
    `;
export const TagRelationFragmentDoc = gql`
    fragment TagRelation on TagRelation {
  id
  group
  k
}
    `;
export const BaseContentFragmentDoc = gql`
    fragment BaseContent on Content {
  raw_id
  status
  author {
    id
    nickname
    avatar
  }
  title
  description
  tags {
    id
    is_topic
    name
    cover_url
  }
  datetime
  vip_visibility
  kind
  cover_url
  readable
  counter @skip(if: $lite) {
    ...Counter
  }
  tag_relations {
    ...TagRelation
  }
}
    ${CounterFragmentDoc}
${TagRelationFragmentDoc}`;
export const TagFragmentDoc = gql`
    fragment Tag on Tag {
  id
  name
  is_topic
  description
  cover_url
}
    `;
export const AuthorFragmentDoc = gql`
    fragment Author on Author {
  id
  nickname
  description
  avatar
}
    `;
export const ArticleFragmentDoc = gql`
    fragment Article on Article {
  id
  title
  author {
    ...Author
  }
  body
  cover_url
  display_time
  free_expired_at
  free_at
  planned_published_at
  summary
  preview
  source_url
  tags {
    ...Tag
  }
  attachments {
    file_url
    file_extension
    title
    id
  }
  tag_relations {
    ...TagRelation
  }
  vip_visibility
}
    ${AuthorFragmentDoc}
${TagFragmentDoc}
${TagRelationFragmentDoc}`;
export const ReportFragmentDoc = gql`
    fragment Report on Report {
  id
  title
  url
  extension
  vip_visibility
  display_time
  summary
  feed_info
  title_prefix
  content_url
  tags {
    ...Tag
  }
  counter {
    ...Counter
  }
}
    ${TagFragmentDoc}
${CounterFragmentDoc}`;
export const VideoFragmentDoc = gql`
    fragment Video on Video {
  id
  title
  cover_url
  description
  display_time
  episodes {
    id
    name
    preview_url
    preview_duration
    size
    duration
    url
    display_time
    thumbnail_urls
  }
  tags {
    ...Tag
  }
  tag_relations {
    ...TagRelation
  }
  vip_visibility
  related_articles {
    ...Article
  }
  related_reports {
    ...Report
  }
  related_article_ids
  related_report_ids
}
    ${TagFragmentDoc}
${TagRelationFragmentDoc}
${ArticleFragmentDoc}
${ReportFragmentDoc}`;
export const LinkFragmentDoc = gql`
    fragment Link on Link {
  id
  title
  to
  tag_relations {
    ...TagRelation
  }
  tags {
    ...Tag
  }
}
    ${TagRelationFragmentDoc}
${TagFragmentDoc}`;
export const FaqFragmentDoc = gql`
    fragment Faq on Faq {
  id
  items {
    title
    body
    link
  }
}
    `;
export const CalendarEventFragmentDoc = gql`
    fragment CalendarEvent on CalendarEvent {
  country
  event
  id
  importance
  source
  status
  title
  display_time
  tag_relations {
    ...TagRelation
  }
  forecast
  revised
  previous
  actual
}
    ${TagRelationFragmentDoc}`;
export const CalendarTopicFragmentDoc = gql`
    fragment CalendarTopic on CalendarTopic {
  id
  name
  status
  description
  period
  website
  organization
  tag_relations {
    ...TagRelation
  }
}
    ${TagRelationFragmentDoc}`;
export const RoadshowFragmentDoc = gql`
    fragment Roadshow on Roadshow {
  id
  title
  live_status
  live_method
  people
  poster
  start_time
  summary
  end_time
  vip_visibility
  tags {
    ...Tag
  }
  body
  video_id
}
    ${TagFragmentDoc}`;
export const ExternalSourceFragmentDoc = gql`
    fragment ExternalSource on ExternalSource {
  avatar
  cover
  description
  id
  name
  nickname
  status
  key
  tag_relations {
    ...TagRelation
  }
}
    ${TagRelationFragmentDoc}`;
export const ExternalSourceGroupFragmentDoc = gql`
    fragment ExternalSourceGroup on ExternalSourceGroup {
  status
  nickname
  name
  id
  description
  cover
  avatar
}
    `;
export const ExternalItemFragmentDoc = gql`
    fragment ExternalItem on ExternalItem {
  title
  title_mix
  title_original
  title_zh
  summary
  summary_mix
  summary_original
  summary_zh
  status
  source_id
  id
  display_time
  content
  content_mix
  content_original
  content_zh
  link
  author_name
  author_original
  author {
    ...Author
  }
  tag_relations {
    ...TagRelation
  }
}
    ${AuthorFragmentDoc}
${TagRelationFragmentDoc}`;
export const RoadMapFragmentDoc = gql`
    fragment RoadMap on RoadMap {
  content
  id
  tag_relations {
    ...TagRelation
  }
}
    ${TagRelationFragmentDoc}`;
export const PageInfoFragmentDoc = gql`
    fragment PageInfo on PageInfo {
  end_cursor
  has_next_page
}
    `;
export const WscnLiveFragmentDoc = gql`
    fragment WscnLive on WscnLive {
  content
  content_more
  id
  images
  score
  status
  tag_relations {
    ...TagRelation
  }
  title
  is_deleted
  display_time
  original_updated_at
}
    ${TagRelationFragmentDoc}`;
export const ReportImageFragmentDoc = gql`
    fragment ReportImage on ReportImage {
  created_at
  description
  display_time
  height
  image_id
  media_id
  serial_number
  title
  updated_at
  url
  width
  id
  tag_relations {
    ...TagRelation
  }
}
    ${TagRelationFragmentDoc}`;
export const ImageFragmentDoc = gql`
    fragment Image on Image {
  created_at
  title
  url
  id
  description
  tag_relations {
    ...TagRelation
  }
}
    ${TagRelationFragmentDoc}`;
export const PushTaskFragmentDoc = gql`
    fragment PushTask on PushTask {
  body
  created_time
  dismiss_count
  error_message
  expire_time
  extra
  group_id
  id
  open_count
  platform
  provider
  provider_task_id
  sent_count
  start_time
  status
  subtitle
  title
  total_count
}
    `;
export const CalendarEventCreateDocument = gql`
    mutation CalendarEventCreate($event: CalendarEventInput!) {
  calendarEventCreate(event: $event) {
    ...CalendarEvent
  }
}
    ${CalendarEventFragmentDoc}`;

/**
 * __useCalendarEventCreateMutation__
 *
 * To run a mutation, you first call `useCalendarEventCreateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventCreateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCalendarEventCreateMutation({
 *   variables: {
 *     event: // value for 'event'
 *   },
 * });
 */
export function useCalendarEventCreateMutation(options: VueApolloComposable.UseMutationOptions<CalendarEventCreateMutation, CalendarEventCreateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CalendarEventCreateMutation, CalendarEventCreateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CalendarEventCreateMutation, CalendarEventCreateMutationVariables>(CalendarEventCreateDocument, options);
}
export type CalendarEventCreateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CalendarEventCreateMutation, CalendarEventCreateMutationVariables>;
export const CalendarEventsCreateDocument = gql`
    mutation CalendarEventsCreate($events: [CalendarEventInput!]) {
  calendarEventsCreate(events: $events) {
    ...CalendarEvent
  }
}
    ${CalendarEventFragmentDoc}`;

/**
 * __useCalendarEventsCreateMutation__
 *
 * To run a mutation, you first call `useCalendarEventsCreateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventsCreateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCalendarEventsCreateMutation({
 *   variables: {
 *     events: // value for 'events'
 *   },
 * });
 */
export function useCalendarEventsCreateMutation(options: VueApolloComposable.UseMutationOptions<CalendarEventsCreateMutation, CalendarEventsCreateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CalendarEventsCreateMutation, CalendarEventsCreateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CalendarEventsCreateMutation, CalendarEventsCreateMutationVariables>(CalendarEventsCreateDocument, options);
}
export type CalendarEventsCreateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CalendarEventsCreateMutation, CalendarEventsCreateMutationVariables>;
export const CalendarTopicCreateDocument = gql`
    mutation CalendarTopicCreate($topic: CalendarTopicInput!) {
  calendarTopicCreate(topic: $topic) {
    ...CalendarTopic
  }
}
    ${CalendarTopicFragmentDoc}`;

/**
 * __useCalendarTopicCreateMutation__
 *
 * To run a mutation, you first call `useCalendarTopicCreateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCalendarTopicCreateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCalendarTopicCreateMutation({
 *   variables: {
 *     topic: // value for 'topic'
 *   },
 * });
 */
export function useCalendarTopicCreateMutation(options: VueApolloComposable.UseMutationOptions<CalendarTopicCreateMutation, CalendarTopicCreateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CalendarTopicCreateMutation, CalendarTopicCreateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CalendarTopicCreateMutation, CalendarTopicCreateMutationVariables>(CalendarTopicCreateDocument, options);
}
export type CalendarTopicCreateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CalendarTopicCreateMutation, CalendarTopicCreateMutationVariables>;
export const ExternalSourceCreateDocument = gql`
    mutation ExternalSourceCreate($source: SourceInput!) {
  externalSourceCreate(source: $source) {
    tag_relations {
      k
      id
      group
    }
    status
    nickname
    name
    key
    id
    description
    cover
    avatar
  }
}
    `;

/**
 * __useExternalSourceCreateMutation__
 *
 * To run a mutation, you first call `useExternalSourceCreateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useExternalSourceCreateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useExternalSourceCreateMutation({
 *   variables: {
 *     source: // value for 'source'
 *   },
 * });
 */
export function useExternalSourceCreateMutation(options: VueApolloComposable.UseMutationOptions<ExternalSourceCreateMutation, ExternalSourceCreateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ExternalSourceCreateMutation, ExternalSourceCreateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ExternalSourceCreateMutation, ExternalSourceCreateMutationVariables>(ExternalSourceCreateDocument, options);
}
export type ExternalSourceCreateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ExternalSourceCreateMutation, ExternalSourceCreateMutationVariables>;
export const RoadshowCreateDocument = gql`
    mutation RoadshowCreate($roadshow: RoadshowInput!) {
  roadshowCreate(roadshow: $roadshow) {
    body
    created_at
    end_time
    id
    live_method
    live_status
    people
    poster
    start_time
    status
    summary
    tag_relations {
      group
      id
    }
    tags {
      id
      is_topic
      name
      cover_url
      description
    }
    tencent_meeting {
      password
      wl_include {
        key
        kind
        name
      }
      wl_exclude {
        key
        kind
        name
      }
    }
    title
    updated_at
    video {
      id
      title
      cover_url
      status
    }
    vip_visibility
    video_id
  }
}
    `;

/**
 * __useRoadshowCreateMutation__
 *
 * To run a mutation, you first call `useRoadshowCreateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRoadshowCreateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRoadshowCreateMutation({
 *   variables: {
 *     roadshow: // value for 'roadshow'
 *   },
 * });
 */
export function useRoadshowCreateMutation(options: VueApolloComposable.UseMutationOptions<RoadshowCreateMutation, RoadshowCreateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RoadshowCreateMutation, RoadshowCreateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RoadshowCreateMutation, RoadshowCreateMutationVariables>(RoadshowCreateDocument, options);
}
export type RoadshowCreateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RoadshowCreateMutation, RoadshowCreateMutationVariables>;
export const RoadshowUserGroupCreateDocument = gql`
    mutation RoadshowUserGroupCreate($group: RoadshowUserGroupInput!) {
  roadshowUserGroupCreate(group: $group) {
    id
    name
    users {
      area
      nickname
      phone_number
    }
  }
}
    `;

/**
 * __useRoadshowUserGroupCreateMutation__
 *
 * To run a mutation, you first call `useRoadshowUserGroupCreateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRoadshowUserGroupCreateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRoadshowUserGroupCreateMutation({
 *   variables: {
 *     group: // value for 'group'
 *   },
 * });
 */
export function useRoadshowUserGroupCreateMutation(options: VueApolloComposable.UseMutationOptions<RoadshowUserGroupCreateMutation, RoadshowUserGroupCreateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RoadshowUserGroupCreateMutation, RoadshowUserGroupCreateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RoadshowUserGroupCreateMutation, RoadshowUserGroupCreateMutationVariables>(RoadshowUserGroupCreateDocument, options);
}
export type RoadshowUserGroupCreateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RoadshowUserGroupCreateMutation, RoadshowUserGroupCreateMutationVariables>;
export const ExternalSourceGroupCreateDocument = gql`
    mutation ExternalSourceGroupCreate($group: SourceGroupInput!) {
  externalSourceGroupCreate(group: $group) {
    ...ExternalSourceGroup
  }
}
    ${ExternalSourceGroupFragmentDoc}`;

/**
 * __useExternalSourceGroupCreateMutation__
 *
 * To run a mutation, you first call `useExternalSourceGroupCreateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useExternalSourceGroupCreateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useExternalSourceGroupCreateMutation({
 *   variables: {
 *     group: // value for 'group'
 *   },
 * });
 */
export function useExternalSourceGroupCreateMutation(options: VueApolloComposable.UseMutationOptions<ExternalSourceGroupCreateMutation, ExternalSourceGroupCreateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ExternalSourceGroupCreateMutation, ExternalSourceGroupCreateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ExternalSourceGroupCreateMutation, ExternalSourceGroupCreateMutationVariables>(ExternalSourceGroupCreateDocument, options);
}
export type ExternalSourceGroupCreateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ExternalSourceGroupCreateMutation, ExternalSourceGroupCreateMutationVariables>;
export const RoadshowUserGroupDeleteDocument = gql`
    mutation RoadshowUserGroupDelete($groupId: Int!) {
  roadshowUserGroupDelete(group_id: $groupId)
}
    `;

/**
 * __useRoadshowUserGroupDeleteMutation__
 *
 * To run a mutation, you first call `useRoadshowUserGroupDeleteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRoadshowUserGroupDeleteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRoadshowUserGroupDeleteMutation({
 *   variables: {
 *     groupId: // value for 'groupId'
 *   },
 * });
 */
export function useRoadshowUserGroupDeleteMutation(options: VueApolloComposable.UseMutationOptions<RoadshowUserGroupDeleteMutation, RoadshowUserGroupDeleteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RoadshowUserGroupDeleteMutation, RoadshowUserGroupDeleteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RoadshowUserGroupDeleteMutation, RoadshowUserGroupDeleteMutationVariables>(RoadshowUserGroupDeleteDocument, options);
}
export type RoadshowUserGroupDeleteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RoadshowUserGroupDeleteMutation, RoadshowUserGroupDeleteMutationVariables>;
export const CreditSetExpenseDocument = gql`
    mutation CreditSetExpense($kind: CreditExpenseKind!, $amount: Int!) {
  creditSetExpense(kind: $kind, amount: $amount)
}
    `;

/**
 * __useCreditSetExpenseMutation__
 *
 * To run a mutation, you first call `useCreditSetExpenseMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreditSetExpenseMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreditSetExpenseMutation({
 *   variables: {
 *     kind: // value for 'kind'
 *     amount: // value for 'amount'
 *   },
 * });
 */
export function useCreditSetExpenseMutation(options: VueApolloComposable.UseMutationOptions<CreditSetExpenseMutation, CreditSetExpenseMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreditSetExpenseMutation, CreditSetExpenseMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreditSetExpenseMutation, CreditSetExpenseMutationVariables>(CreditSetExpenseDocument, options);
}
export type CreditSetExpenseMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreditSetExpenseMutation, CreditSetExpenseMutationVariables>;
export const CreditInternalUnsubscribeDocument = gql`
    mutation CreditInternalUnsubscribe($plan: CreditSubscriptionPlan!, $userId: Int!) {
  creditInternalUnsubscribe(plan: $plan, user_id: $userId) {
    credit_info {
      user_id
      expired_at
      amount
    }
    expired_at
    started_at
    plan
    user_id
  }
}
    `;

/**
 * __useCreditInternalUnsubscribeMutation__
 *
 * To run a mutation, you first call `useCreditInternalUnsubscribeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreditInternalUnsubscribeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreditInternalUnsubscribeMutation({
 *   variables: {
 *     plan: // value for 'plan'
 *     userId: // value for 'userId'
 *   },
 * });
 */
export function useCreditInternalUnsubscribeMutation(options: VueApolloComposable.UseMutationOptions<CreditInternalUnsubscribeMutation, CreditInternalUnsubscribeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreditInternalUnsubscribeMutation, CreditInternalUnsubscribeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreditInternalUnsubscribeMutation, CreditInternalUnsubscribeMutationVariables>(CreditInternalUnsubscribeDocument, options);
}
export type CreditInternalUnsubscribeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreditInternalUnsubscribeMutation, CreditInternalUnsubscribeMutationVariables>;
export const NewsletterKillSwitchSetDocument = gql`
    mutation NewsletterKillSwitchSet($enabled: Boolean!) {
  newsletterKillSwitchSet(enabled: $enabled) {
    active
    enabled_at
    enabled_by
    enabled_until
  }
}
    `;

/**
 * __useNewsletterKillSwitchSetMutation__
 *
 * To run a mutation, you first call `useNewsletterKillSwitchSetMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useNewsletterKillSwitchSetMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useNewsletterKillSwitchSetMutation({
 *   variables: {
 *     enabled: // value for 'enabled'
 *   },
 * });
 */
export function useNewsletterKillSwitchSetMutation(options: VueApolloComposable.UseMutationOptions<NewsletterKillSwitchSetMutation, NewsletterKillSwitchSetMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<NewsletterKillSwitchSetMutation, NewsletterKillSwitchSetMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<NewsletterKillSwitchSetMutation, NewsletterKillSwitchSetMutationVariables>(NewsletterKillSwitchSetDocument, options);
}
export type NewsletterKillSwitchSetMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<NewsletterKillSwitchSetMutation, NewsletterKillSwitchSetMutationVariables>;
export const PushBroadcastCreateDocument = gql`
    mutation PushBroadcastCreate($body: String!, $platform: PushPlatform!, $title: String!, $subtitle: String, $extra: Map, $startTime: String, $expireTime: String) {
  pushBroadcastCreate(
    body: $body
    platform: $platform
    title: $title
    subtitle: $subtitle
    extra: $extra
    start_time: $startTime
    expire_time: $expireTime
  ) {
    group_id
    tasks {
      ...PushTask
    }
  }
}
    ${PushTaskFragmentDoc}`;

/**
 * __usePushBroadcastCreateMutation__
 *
 * To run a mutation, you first call `usePushBroadcastCreateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePushBroadcastCreateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePushBroadcastCreateMutation({
 *   variables: {
 *     body: // value for 'body'
 *     platform: // value for 'platform'
 *     title: // value for 'title'
 *     subtitle: // value for 'subtitle'
 *     extra: // value for 'extra'
 *     startTime: // value for 'startTime'
 *     expireTime: // value for 'expireTime'
 *   },
 * });
 */
export function usePushBroadcastCreateMutation(options: VueApolloComposable.UseMutationOptions<PushBroadcastCreateMutation, PushBroadcastCreateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<PushBroadcastCreateMutation, PushBroadcastCreateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<PushBroadcastCreateMutation, PushBroadcastCreateMutationVariables>(PushBroadcastCreateDocument, options);
}
export type PushBroadcastCreateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<PushBroadcastCreateMutation, PushBroadcastCreateMutationVariables>;
export const PushTaskRevokeDocument = gql`
    mutation PushTaskRevoke($id: Int!) {
  pushTaskRevoke(id: $id)
}
    `;

/**
 * __usePushTaskRevokeMutation__
 *
 * To run a mutation, you first call `usePushTaskRevokeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePushTaskRevokeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePushTaskRevokeMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function usePushTaskRevokeMutation(options: VueApolloComposable.UseMutationOptions<PushTaskRevokeMutation, PushTaskRevokeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<PushTaskRevokeMutation, PushTaskRevokeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<PushTaskRevokeMutation, PushTaskRevokeMutationVariables>(PushTaskRevokeDocument, options);
}
export type PushTaskRevokeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<PushTaskRevokeMutation, PushTaskRevokeMutationVariables>;
export const PushTaskStatsRefreshDocument = gql`
    mutation PushTaskStatsRefresh($id: Int!) {
  pushTaskStatsRefresh(id: $id) {
    ...PushTask
  }
}
    ${PushTaskFragmentDoc}`;

/**
 * __usePushTaskStatsRefreshMutation__
 *
 * To run a mutation, you first call `usePushTaskStatsRefreshMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePushTaskStatsRefreshMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePushTaskStatsRefreshMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function usePushTaskStatsRefreshMutation(options: VueApolloComposable.UseMutationOptions<PushTaskStatsRefreshMutation, PushTaskStatsRefreshMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<PushTaskStatsRefreshMutation, PushTaskStatsRefreshMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<PushTaskStatsRefreshMutation, PushTaskStatsRefreshMutationVariables>(PushTaskStatsRefreshDocument, options);
}
export type PushTaskStatsRefreshMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<PushTaskStatsRefreshMutation, PushTaskStatsRefreshMutationVariables>;
export const PushUnicastCreateDocument = gql`
    mutation PushUnicastCreate($title: String!, $body: String!, $userIds: [Int]!, $subtitle: String, $extra: Map) {
  pushUnicastCreate(
    title: $title
    body: $body
    user_ids: $userIds
    subtitle: $subtitle
    extra: $extra
  ) {
    group_id
    tasks {
      ...PushTask
    }
  }
}
    ${PushTaskFragmentDoc}`;

/**
 * __usePushUnicastCreateMutation__
 *
 * To run a mutation, you first call `usePushUnicastCreateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePushUnicastCreateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePushUnicastCreateMutation({
 *   variables: {
 *     title: // value for 'title'
 *     body: // value for 'body'
 *     userIds: // value for 'userIds'
 *     subtitle: // value for 'subtitle'
 *     extra: // value for 'extra'
 *   },
 * });
 */
export function usePushUnicastCreateMutation(options: VueApolloComposable.UseMutationOptions<PushUnicastCreateMutation, PushUnicastCreateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<PushUnicastCreateMutation, PushUnicastCreateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<PushUnicastCreateMutation, PushUnicastCreateMutationVariables>(PushUnicastCreateDocument, options);
}
export type PushUnicastCreateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<PushUnicastCreateMutation, PushUnicastCreateMutationVariables>;
export const ReportImageUpdateDocument = gql`
    mutation ReportImageUpdate($item: ReportImageInput!) {
  reportImageUpdate(item: $item) {
    title
    url
    updated_at
    image_id
    description
  }
}
    `;

/**
 * __useReportImageUpdateMutation__
 *
 * To run a mutation, you first call `useReportImageUpdateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReportImageUpdateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReportImageUpdateMutation({
 *   variables: {
 *     item: // value for 'item'
 *   },
 * });
 */
export function useReportImageUpdateMutation(options: VueApolloComposable.UseMutationOptions<ReportImageUpdateMutation, ReportImageUpdateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ReportImageUpdateMutation, ReportImageUpdateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ReportImageUpdateMutation, ReportImageUpdateMutationVariables>(ReportImageUpdateDocument, options);
}
export type ReportImageUpdateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ReportImageUpdateMutation, ReportImageUpdateMutationVariables>;
export const ContentDetailDocument = gql`
    query contentDetail($contentId: Int, $kind: Int, $lite: Boolean = false, $kinds: [Int], $first: Int, $vipVisibility: Int, $associateWithKinds: [Int], $associatedByKinds: [Int], $offset: Int) {
  content(id: $contentId, kind: $kind) {
    ...BaseContent
    detail {
      ...Article
      ...Video
      ... on Report {
        id
        title
        url
        extension
        markdown
        vip_visibility
        display_time
        summary
        feed_info
        body_audio_url
        content_url
        reference_blocks @skip(if: $lite)
        tags {
          ...Tag
        }
        counter {
          ...Counter
        }
        images {
          ...ReportImage
        }
      }
      ...Roadshow
      ...ExternalSource
      ...ExternalSourceGroup
      ...ExternalItem
    }
    associate_with(kinds: $associateWithKinds) {
      items {
        ...BaseContent
        detail @skip(if: $lite) {
          ...Article
          ...Video
          ...Report
          ...Roadshow
          ...ExternalSource
          ...ExternalSourceGroup
          ...ExternalItem
          ...Tag
        }
      }
    }
    associated_by(first: $first, kinds: $associatedByKinds, offset: $offset) {
      items {
        ...BaseContent
      }
      total_count
    }
    related_contents(kinds: $kinds, first: $first, vip_visibility: $vipVisibility) {
      total_count
      page_info {
        ...PageInfo
      }
      items {
        ...BaseContent
        detail @skip(if: $lite) {
          ...Article
          ...Video
          ...Report
          ...Roadshow
          ...ExternalSource
          ...ExternalSourceGroup
          ...ExternalItem
        }
      }
    }
  }
}
    ${BaseContentFragmentDoc}
${ArticleFragmentDoc}
${VideoFragmentDoc}
${TagFragmentDoc}
${CounterFragmentDoc}
${ReportImageFragmentDoc}
${RoadshowFragmentDoc}
${ExternalSourceFragmentDoc}
${ExternalSourceGroupFragmentDoc}
${ExternalItemFragmentDoc}
${ReportFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useContentDetailQuery__
 *
 * To run a query within a Vue component, call `useContentDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentDetailQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useContentDetailQuery({
 *   contentId: // value for 'contentId'
 *   kind: // value for 'kind'
 *   lite: // value for 'lite'
 *   kinds: // value for 'kinds'
 *   first: // value for 'first'
 *   vipVisibility: // value for 'vipVisibility'
 *   associateWithKinds: // value for 'associateWithKinds'
 *   associatedByKinds: // value for 'associatedByKinds'
 *   offset: // value for 'offset'
 * });
 */
export function useContentDetailQuery(variables: ContentDetailQueryVariables | VueCompositionApi.Ref<ContentDetailQueryVariables> | ReactiveFunction<ContentDetailQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ContentDetailQuery, ContentDetailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ContentDetailQuery, ContentDetailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ContentDetailQuery, ContentDetailQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ContentDetailQuery, ContentDetailQueryVariables>(ContentDetailDocument, variables, options);
}
export function useContentDetailLazyQuery(variables: ContentDetailQueryVariables | VueCompositionApi.Ref<ContentDetailQueryVariables> | ReactiveFunction<ContentDetailQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ContentDetailQuery, ContentDetailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ContentDetailQuery, ContentDetailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ContentDetailQuery, ContentDetailQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ContentDetailQuery, ContentDetailQueryVariables>(ContentDetailDocument, variables, options);
}
export type ContentDetailQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ContentDetailQuery, ContentDetailQueryVariables>;
export const ContentListDocument = gql`
    query contentList($sortBy: String, $startTime: Timestamp, $kinds: [Int], $after: String, $endTime: Timestamp, $first: Int, $vipVisibility: Int, $lite: Boolean = true, $relations: [RelationFilter], $status: Int, $track: String, $offset: Int, $userId: Int, $relatedContentsFirst: Int, $relatedContentsKinds: [Int], $associateWithKinds: [Int], $authors: [AuthorFilter], $ralationsOp: FilterOperator) {
  contents(
    sort_by: $sortBy
    start_time: $startTime
    kinds: $kinds
    after: $after
    end_time: $endTime
    first: $first
    vip_visibility: $vipVisibility
    relations: $relations
    status: $status
    track: $track
    offset: $offset
    user_id: $userId
    authors: $authors
    ralations_op: $ralationsOp
  ) {
    total_count
    page_info {
      ...PageInfo
    }
    items {
      ...BaseContent
      counter {
        ...Counter
      }
      detail {
        ... on Article {
          planned_published_at
          ...Article
        }
        ... on Video {
          episodes {
            duration
          }
          summary
        }
        ... on Report {
          ...Report
        }
        ... on Link {
          ...Link
        }
        ... on Faq {
          ...Faq
        }
        ... on RoadMap {
          ...RoadMap
        }
        ... on CalendarEvent {
          ...CalendarEvent
        }
        ... on CalendarTopic {
          ...CalendarTopic
        }
        ... on WscnLive {
          ...WscnLive
        }
        ... on ExternalSource @skip(if: $lite) {
          ...ExternalSource
        }
        ... on ExternalItem @skip(if: $lite) {
          ...ExternalItem
        }
        ... on ReportImage {
          ...ReportImage
        }
        ... on Image {
          ...Image
        }
      }
      related_contents(first: $relatedContentsFirst, kinds: $relatedContentsKinds) @skip(if: $lite) {
        items {
          raw_id
          title
          kind
        }
      }
      associate_with(kinds: $associateWithKinds) @skip(if: $lite) {
        items {
          ...BaseContent
        }
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${BaseContentFragmentDoc}
${CounterFragmentDoc}
${ArticleFragmentDoc}
${ReportFragmentDoc}
${LinkFragmentDoc}
${FaqFragmentDoc}
${RoadMapFragmentDoc}
${CalendarEventFragmentDoc}
${CalendarTopicFragmentDoc}
${WscnLiveFragmentDoc}
${ExternalSourceFragmentDoc}
${ExternalItemFragmentDoc}
${ReportImageFragmentDoc}
${ImageFragmentDoc}`;

/**
 * __useContentListQuery__
 *
 * To run a query within a Vue component, call `useContentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useContentListQuery({
 *   sortBy: // value for 'sortBy'
 *   startTime: // value for 'startTime'
 *   kinds: // value for 'kinds'
 *   after: // value for 'after'
 *   endTime: // value for 'endTime'
 *   first: // value for 'first'
 *   vipVisibility: // value for 'vipVisibility'
 *   lite: // value for 'lite'
 *   relations: // value for 'relations'
 *   status: // value for 'status'
 *   track: // value for 'track'
 *   offset: // value for 'offset'
 *   userId: // value for 'userId'
 *   relatedContentsFirst: // value for 'relatedContentsFirst'
 *   relatedContentsKinds: // value for 'relatedContentsKinds'
 *   associateWithKinds: // value for 'associateWithKinds'
 *   authors: // value for 'authors'
 *   ralationsOp: // value for 'ralationsOp'
 * });
 */
export function useContentListQuery(variables: ContentListQueryVariables | VueCompositionApi.Ref<ContentListQueryVariables> | ReactiveFunction<ContentListQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ContentListQuery, ContentListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ContentListQuery, ContentListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ContentListQuery, ContentListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ContentListQuery, ContentListQueryVariables>(ContentListDocument, variables, options);
}
export function useContentListLazyQuery(variables: ContentListQueryVariables | VueCompositionApi.Ref<ContentListQueryVariables> | ReactiveFunction<ContentListQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<ContentListQuery, ContentListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ContentListQuery, ContentListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ContentListQuery, ContentListQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ContentListQuery, ContentListQueryVariables>(ContentListDocument, variables, options);
}
export type ContentListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ContentListQuery, ContentListQueryVariables>;
export const Credit_ExpenseDocument = gql`
    query Credit_expense {
  credit_expense {
    kind
    price
  }
}
    `;

/**
 * __useCredit_ExpenseQuery__
 *
 * To run a query within a Vue component, call `useCredit_ExpenseQuery` and pass it any options that fit your needs.
 * When your component renders, `useCredit_ExpenseQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCredit_ExpenseQuery();
 */
export function useCredit_ExpenseQuery(options: VueApolloComposable.UseQueryOptions<Credit_ExpenseQuery, Credit_ExpenseQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Credit_ExpenseQuery, Credit_ExpenseQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Credit_ExpenseQuery, Credit_ExpenseQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Credit_ExpenseQuery, Credit_ExpenseQueryVariables>(Credit_ExpenseDocument, {}, options);
}
export function useCredit_ExpenseLazyQuery(options: VueApolloComposable.UseQueryOptions<Credit_ExpenseQuery, Credit_ExpenseQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Credit_ExpenseQuery, Credit_ExpenseQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Credit_ExpenseQuery, Credit_ExpenseQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Credit_ExpenseQuery, Credit_ExpenseQueryVariables>(Credit_ExpenseDocument, {}, options);
}
export type Credit_ExpenseQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Credit_ExpenseQuery, Credit_ExpenseQueryVariables>;
export const FinanceEventContentsDocument = gql`
    query FinanceEventContents($kinds: [Int], $first: Int, $offset: Int, $status: Int, $group: Int, $startTime: Timestamp, $endTime: Timestamp, $after: String) {
  contents(
    kinds: $kinds
    first: $first
    offset: $offset
    status: $status
    group: $group
    start_time: $startTime
    end_time: $endTime
    after: $after
  ) {
    items {
      title
      raw_id
      datetime
      status
    }
    total_count
    page_info {
      end_cursor
      has_next_page
    }
  }
}
    `;

/**
 * __useFinanceEventContentsQuery__
 *
 * To run a query within a Vue component, call `useFinanceEventContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinanceEventContentsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFinanceEventContentsQuery({
 *   kinds: // value for 'kinds'
 *   first: // value for 'first'
 *   offset: // value for 'offset'
 *   status: // value for 'status'
 *   group: // value for 'group'
 *   startTime: // value for 'startTime'
 *   endTime: // value for 'endTime'
 *   after: // value for 'after'
 * });
 */
export function useFinanceEventContentsQuery(variables: FinanceEventContentsQueryVariables | VueCompositionApi.Ref<FinanceEventContentsQueryVariables> | ReactiveFunction<FinanceEventContentsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<FinanceEventContentsQuery, FinanceEventContentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FinanceEventContentsQuery, FinanceEventContentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FinanceEventContentsQuery, FinanceEventContentsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FinanceEventContentsQuery, FinanceEventContentsQueryVariables>(FinanceEventContentsDocument, variables, options);
}
export function useFinanceEventContentsLazyQuery(variables: FinanceEventContentsQueryVariables | VueCompositionApi.Ref<FinanceEventContentsQueryVariables> | ReactiveFunction<FinanceEventContentsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<FinanceEventContentsQuery, FinanceEventContentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FinanceEventContentsQuery, FinanceEventContentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FinanceEventContentsQuery, FinanceEventContentsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FinanceEventContentsQuery, FinanceEventContentsQueryVariables>(FinanceEventContentsDocument, variables, options);
}
export type FinanceEventContentsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FinanceEventContentsQuery, FinanceEventContentsQueryVariables>;
export const QueryDocument = gql`
    query query {
  newsletterKillSwitch {
    active
    enabled_at
    enabled_by
    enabled_until
  }
}
    `;

/**
 * __useQueryQuery__
 *
 * To run a query within a Vue component, call `useQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useQueryQuery();
 */
export function useQueryQuery(options: VueApolloComposable.UseQueryOptions<QueryQuery, QueryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QueryQuery, QueryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QueryQuery, QueryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<QueryQuery, QueryQueryVariables>(QueryDocument, {}, options);
}
export function useQueryLazyQuery(options: VueApolloComposable.UseQueryOptions<QueryQuery, QueryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<QueryQuery, QueryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<QueryQuery, QueryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<QueryQuery, QueryQueryVariables>(QueryDocument, {}, options);
}
export type QueryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<QueryQuery, QueryQueryVariables>;
export const Push_TaskDocument = gql`
    query Push_task($pushTaskId: Int!) {
  push_task(id: $pushTaskId) {
    ...PushTask
  }
}
    ${PushTaskFragmentDoc}`;

/**
 * __usePush_TaskQuery__
 *
 * To run a query within a Vue component, call `usePush_TaskQuery` and pass it any options that fit your needs.
 * When your component renders, `usePush_TaskQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePush_TaskQuery({
 *   pushTaskId: // value for 'pushTaskId'
 * });
 */
export function usePush_TaskQuery(variables: Push_TaskQueryVariables | VueCompositionApi.Ref<Push_TaskQueryVariables> | ReactiveFunction<Push_TaskQueryVariables>, options: VueApolloComposable.UseQueryOptions<Push_TaskQuery, Push_TaskQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Push_TaskQuery, Push_TaskQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Push_TaskQuery, Push_TaskQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Push_TaskQuery, Push_TaskQueryVariables>(Push_TaskDocument, variables, options);
}
export function usePush_TaskLazyQuery(variables: Push_TaskQueryVariables | VueCompositionApi.Ref<Push_TaskQueryVariables> | ReactiveFunction<Push_TaskQueryVariables>, options: VueApolloComposable.UseQueryOptions<Push_TaskQuery, Push_TaskQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Push_TaskQuery, Push_TaskQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Push_TaskQuery, Push_TaskQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Push_TaskQuery, Push_TaskQueryVariables>(Push_TaskDocument, variables, options);
}
export type Push_TaskQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Push_TaskQuery, Push_TaskQueryVariables>;
export const Push_TasksDocument = gql`
    query Push_tasks($pagination: PaginationInput, $platform: PushPlatform, $provider: PushProvider, $status: PushTaskStatus, $keyword: String) {
  push_tasks(
    pagination: $pagination
    platform: $platform
    provider: $provider
    status: $status
    keyword: $keyword
  ) {
    nodes {
      ...PushTask
    }
    page_info {
      end_cursor
      has_next_page
    }
    total_count
  }
}
    ${PushTaskFragmentDoc}`;

/**
 * __usePush_TasksQuery__
 *
 * To run a query within a Vue component, call `usePush_TasksQuery` and pass it any options that fit your needs.
 * When your component renders, `usePush_TasksQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePush_TasksQuery({
 *   pagination: // value for 'pagination'
 *   platform: // value for 'platform'
 *   provider: // value for 'provider'
 *   status: // value for 'status'
 *   keyword: // value for 'keyword'
 * });
 */
export function usePush_TasksQuery(variables: Push_TasksQueryVariables | VueCompositionApi.Ref<Push_TasksQueryVariables> | ReactiveFunction<Push_TasksQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Push_TasksQuery, Push_TasksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Push_TasksQuery, Push_TasksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Push_TasksQuery, Push_TasksQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Push_TasksQuery, Push_TasksQueryVariables>(Push_TasksDocument, variables, options);
}
export function usePush_TasksLazyQuery(variables: Push_TasksQueryVariables | VueCompositionApi.Ref<Push_TasksQueryVariables> | ReactiveFunction<Push_TasksQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Push_TasksQuery, Push_TasksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Push_TasksQuery, Push_TasksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Push_TasksQuery, Push_TasksQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Push_TasksQuery, Push_TasksQueryVariables>(Push_TasksDocument, variables, options);
}
export type Push_TasksQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Push_TasksQuery, Push_TasksQueryVariables>;
export const RoadshowDocument = gql`
    query Roadshow($roadshowId: Int) {
  roadshow(id: $roadshowId) {
    body
    created_at
    end_time
    id
    live_method
    live_status
    people
    poster
    start_time
    status
    summary
    tag_relations {
      id
      k
      group
    }
    tags {
      id
      is_topic
      name
      description
      cover_url
    }
    tencent_meeting {
      password
      wl_include {
        key
        kind
        name
      }
      wl_exclude {
        key
        kind
        name
      }
    }
    title
    updated_at
    video {
      id
      title
      cover_url
    }
    video_id
    vip_visibility
  }
}
    `;

/**
 * __useRoadshowQuery__
 *
 * To run a query within a Vue component, call `useRoadshowQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoadshowQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRoadshowQuery({
 *   roadshowId: // value for 'roadshowId'
 * });
 */
export function useRoadshowQuery(variables: RoadshowQueryVariables | VueCompositionApi.Ref<RoadshowQueryVariables> | ReactiveFunction<RoadshowQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<RoadshowQuery, RoadshowQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RoadshowQuery, RoadshowQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RoadshowQuery, RoadshowQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<RoadshowQuery, RoadshowQueryVariables>(RoadshowDocument, variables, options);
}
export function useRoadshowLazyQuery(variables: RoadshowQueryVariables | VueCompositionApi.Ref<RoadshowQueryVariables> | ReactiveFunction<RoadshowQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<RoadshowQuery, RoadshowQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RoadshowQuery, RoadshowQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RoadshowQuery, RoadshowQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<RoadshowQuery, RoadshowQueryVariables>(RoadshowDocument, variables, options);
}
export type RoadshowQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<RoadshowQuery, RoadshowQueryVariables>;
export const TagsDocument = gql`
    query Tags($isTopic: Boolean, $first: Int, $offset: Int, $kw: String, $contentsFirst: Int, $kinds: [Int], $group: Int, $getContents: Boolean = false) {
  tags(is_topic: $isTopic, first: $first, offset: $offset, kw: $kw) {
    ...Tag
    contents(first: $contentsFirst, kinds: $kinds, group: $group) @include(if: $getContents) {
      items {
        raw_id
        title
      }
      total_count
    }
  }
}
    ${TagFragmentDoc}`;

/**
 * __useTagsQuery__
 *
 * To run a query within a Vue component, call `useTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTagsQuery({
 *   isTopic: // value for 'isTopic'
 *   first: // value for 'first'
 *   offset: // value for 'offset'
 *   kw: // value for 'kw'
 *   contentsFirst: // value for 'contentsFirst'
 *   kinds: // value for 'kinds'
 *   group: // value for 'group'
 *   getContents: // value for 'getContents'
 * });
 */
export function useTagsQuery(variables: TagsQueryVariables | VueCompositionApi.Ref<TagsQueryVariables> | ReactiveFunction<TagsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<TagsQuery, TagsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TagsQuery, TagsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TagsQuery, TagsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TagsQuery, TagsQueryVariables>(TagsDocument, variables, options);
}
export function useTagsLazyQuery(variables: TagsQueryVariables | VueCompositionApi.Ref<TagsQueryVariables> | ReactiveFunction<TagsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<TagsQuery, TagsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TagsQuery, TagsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TagsQuery, TagsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TagsQuery, TagsQueryVariables>(TagsDocument, variables, options);
}
export type TagsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TagsQuery, TagsQueryVariables>;
export const Roadshow_User_GroupsDocument = gql`
    query Roadshow_user_groups($pagination: PaginationInput) {
  roadshow_user_groups(pagination: $pagination) {
    total_count
    page_info {
      has_next_page
      end_cursor
    }
    nodes {
      id
      name
      users {
        area
        nickname
        phone_number
      }
    }
  }
}
    `;

/**
 * __useRoadshow_User_GroupsQuery__
 *
 * To run a query within a Vue component, call `useRoadshow_User_GroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoadshow_User_GroupsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRoadshow_User_GroupsQuery({
 *   pagination: // value for 'pagination'
 * });
 */
export function useRoadshow_User_GroupsQuery(variables: Roadshow_User_GroupsQueryVariables | VueCompositionApi.Ref<Roadshow_User_GroupsQueryVariables> | ReactiveFunction<Roadshow_User_GroupsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Roadshow_User_GroupsQuery, Roadshow_User_GroupsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Roadshow_User_GroupsQuery, Roadshow_User_GroupsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Roadshow_User_GroupsQuery, Roadshow_User_GroupsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Roadshow_User_GroupsQuery, Roadshow_User_GroupsQueryVariables>(Roadshow_User_GroupsDocument, variables, options);
}
export function useRoadshow_User_GroupsLazyQuery(variables: Roadshow_User_GroupsQueryVariables | VueCompositionApi.Ref<Roadshow_User_GroupsQueryVariables> | ReactiveFunction<Roadshow_User_GroupsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Roadshow_User_GroupsQuery, Roadshow_User_GroupsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Roadshow_User_GroupsQuery, Roadshow_User_GroupsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Roadshow_User_GroupsQuery, Roadshow_User_GroupsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Roadshow_User_GroupsQuery, Roadshow_User_GroupsQueryVariables>(Roadshow_User_GroupsDocument, variables, options);
}
export type Roadshow_User_GroupsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Roadshow_User_GroupsQuery, Roadshow_User_GroupsQueryVariables>;
export const CalendarEventUpdateDocument = gql`
    mutation CalendarEventUpdate($event: CalendarEventInput!) {
  calendarEventUpdate(event: $event) {
    ...CalendarEvent
  }
}
    ${CalendarEventFragmentDoc}`;

/**
 * __useCalendarEventUpdateMutation__
 *
 * To run a mutation, you first call `useCalendarEventUpdateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventUpdateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCalendarEventUpdateMutation({
 *   variables: {
 *     event: // value for 'event'
 *   },
 * });
 */
export function useCalendarEventUpdateMutation(options: VueApolloComposable.UseMutationOptions<CalendarEventUpdateMutation, CalendarEventUpdateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CalendarEventUpdateMutation, CalendarEventUpdateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CalendarEventUpdateMutation, CalendarEventUpdateMutationVariables>(CalendarEventUpdateDocument, options);
}
export type CalendarEventUpdateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CalendarEventUpdateMutation, CalendarEventUpdateMutationVariables>;
export const CalendarTopicUpdateDocument = gql`
    mutation CalendarTopicUpdate($topic: CalendarTopicInput!) {
  calendarTopicUpdate(topic: $topic) {
    ...CalendarTopic
  }
}
    ${CalendarTopicFragmentDoc}`;

/**
 * __useCalendarTopicUpdateMutation__
 *
 * To run a mutation, you first call `useCalendarTopicUpdateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCalendarTopicUpdateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCalendarTopicUpdateMutation({
 *   variables: {
 *     topic: // value for 'topic'
 *   },
 * });
 */
export function useCalendarTopicUpdateMutation(options: VueApolloComposable.UseMutationOptions<CalendarTopicUpdateMutation, CalendarTopicUpdateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CalendarTopicUpdateMutation, CalendarTopicUpdateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CalendarTopicUpdateMutation, CalendarTopicUpdateMutationVariables>(CalendarTopicUpdateDocument, options);
}
export type CalendarTopicUpdateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CalendarTopicUpdateMutation, CalendarTopicUpdateMutationVariables>;
export const ExternalItemUpdateDocument = gql`
    mutation ExternalItemUpdate($item: ExternalItemInput!) {
  externalItemUpdate(item: $item) {
    ...ExternalItem
  }
}
    ${ExternalItemFragmentDoc}`;

/**
 * __useExternalItemUpdateMutation__
 *
 * To run a mutation, you first call `useExternalItemUpdateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useExternalItemUpdateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useExternalItemUpdateMutation({
 *   variables: {
 *     item: // value for 'item'
 *   },
 * });
 */
export function useExternalItemUpdateMutation(options: VueApolloComposable.UseMutationOptions<ExternalItemUpdateMutation, ExternalItemUpdateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ExternalItemUpdateMutation, ExternalItemUpdateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ExternalItemUpdateMutation, ExternalItemUpdateMutationVariables>(ExternalItemUpdateDocument, options);
}
export type ExternalItemUpdateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ExternalItemUpdateMutation, ExternalItemUpdateMutationVariables>;
export const ExternalSourceUpdateDocument = gql`
    mutation ExternalSourceUpdate($source: SourceInput!) {
  externalSourceUpdate(source: $source) {
    ...ExternalSource
  }
}
    ${ExternalSourceFragmentDoc}`;

/**
 * __useExternalSourceUpdateMutation__
 *
 * To run a mutation, you first call `useExternalSourceUpdateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useExternalSourceUpdateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useExternalSourceUpdateMutation({
 *   variables: {
 *     source: // value for 'source'
 *   },
 * });
 */
export function useExternalSourceUpdateMutation(options: VueApolloComposable.UseMutationOptions<ExternalSourceUpdateMutation, ExternalSourceUpdateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ExternalSourceUpdateMutation, ExternalSourceUpdateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ExternalSourceUpdateMutation, ExternalSourceUpdateMutationVariables>(ExternalSourceUpdateDocument, options);
}
export type ExternalSourceUpdateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ExternalSourceUpdateMutation, ExternalSourceUpdateMutationVariables>;
export const RoadshowUpdateDocument = gql`
    mutation RoadshowUpdate($roadshow: RoadshowInput!) {
  roadshowUpdate(roadshow: $roadshow) {
    body
    created_at
    end_time
    id
    live_method
    live_status
    people
    poster
    start_time
    status
    summary
    tag_relations {
      group
      id
    }
    tags {
      id
      is_topic
      name
      cover_url
      description
    }
    tencent_meeting {
      password
      wl_include {
        key
        kind
        name
      }
      wl_exclude {
        key
        kind
        name
      }
    }
    title
    updated_at
    video {
      id
      title
      cover_url
      status
    }
    vip_visibility
    video_id
  }
}
    `;

/**
 * __useRoadshowUpdateMutation__
 *
 * To run a mutation, you first call `useRoadshowUpdateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRoadshowUpdateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRoadshowUpdateMutation({
 *   variables: {
 *     roadshow: // value for 'roadshow'
 *   },
 * });
 */
export function useRoadshowUpdateMutation(options: VueApolloComposable.UseMutationOptions<RoadshowUpdateMutation, RoadshowUpdateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RoadshowUpdateMutation, RoadshowUpdateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RoadshowUpdateMutation, RoadshowUpdateMutationVariables>(RoadshowUpdateDocument, options);
}
export type RoadshowUpdateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RoadshowUpdateMutation, RoadshowUpdateMutationVariables>;
export const RoadshowUserGroupUpdateDocument = gql`
    mutation RoadshowUserGroupUpdate($group: RoadshowUserGroupInput!) {
  roadshowUserGroupUpdate(group: $group) {
    id
    name
    users {
      area
      nickname
      phone_number
    }
  }
}
    `;

/**
 * __useRoadshowUserGroupUpdateMutation__
 *
 * To run a mutation, you first call `useRoadshowUserGroupUpdateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRoadshowUserGroupUpdateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRoadshowUserGroupUpdateMutation({
 *   variables: {
 *     group: // value for 'group'
 *   },
 * });
 */
export function useRoadshowUserGroupUpdateMutation(options: VueApolloComposable.UseMutationOptions<RoadshowUserGroupUpdateMutation, RoadshowUserGroupUpdateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RoadshowUserGroupUpdateMutation, RoadshowUserGroupUpdateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RoadshowUserGroupUpdateMutation, RoadshowUserGroupUpdateMutationVariables>(RoadshowUserGroupUpdateDocument, options);
}
export type RoadshowUserGroupUpdateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RoadshowUserGroupUpdateMutation, RoadshowUserGroupUpdateMutationVariables>;
export const ExternalSourceGroupUpdateDocument = gql`
    mutation ExternalSourceGroupUpdate($group: SourceGroupInput!) {
  externalSourceGroupUpdate(group: $group) {
    ...ExternalSourceGroup
  }
}
    ${ExternalSourceGroupFragmentDoc}`;

/**
 * __useExternalSourceGroupUpdateMutation__
 *
 * To run a mutation, you first call `useExternalSourceGroupUpdateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useExternalSourceGroupUpdateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useExternalSourceGroupUpdateMutation({
 *   variables: {
 *     group: // value for 'group'
 *   },
 * });
 */
export function useExternalSourceGroupUpdateMutation(options: VueApolloComposable.UseMutationOptions<ExternalSourceGroupUpdateMutation, ExternalSourceGroupUpdateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ExternalSourceGroupUpdateMutation, ExternalSourceGroupUpdateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ExternalSourceGroupUpdateMutation, ExternalSourceGroupUpdateMutationVariables>(ExternalSourceGroupUpdateDocument, options);
}
export type ExternalSourceGroupUpdateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ExternalSourceGroupUpdateMutation, ExternalSourceGroupUpdateMutationVariables>;
export const WscnLiveUpdateDocument = gql`
    mutation WscnLiveUpdate($item: WscnLiveInput!) {
  wscnLiveUpdate(item: $item) {
    tag_relations {
      k
      id
      group
    }
    id
  }
}
    `;

/**
 * __useWscnLiveUpdateMutation__
 *
 * To run a mutation, you first call `useWscnLiveUpdateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useWscnLiveUpdateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useWscnLiveUpdateMutation({
 *   variables: {
 *     item: // value for 'item'
 *   },
 * });
 */
export function useWscnLiveUpdateMutation(options: VueApolloComposable.UseMutationOptions<WscnLiveUpdateMutation, WscnLiveUpdateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<WscnLiveUpdateMutation, WscnLiveUpdateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<WscnLiveUpdateMutation, WscnLiveUpdateMutationVariables>(WscnLiveUpdateDocument, options);
}
export type WscnLiveUpdateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<WscnLiveUpdateMutation, WscnLiveUpdateMutationVariables>;